import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Decimal: any;
  Json: any;
  NaiveDateTime: any;
};


export type Accent = {
  __typename?: 'Accent';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AddStoryToPlaylistInput = {
  /** Playlist id */
  playlistId: Scalars['ID'];
  /** Story id */
  storyId: Scalars['ID'];
};

export type BillingPeriod = {
  __typename?: 'BillingPeriod';
  /** The currency code of the plan amount. E.g. 'USD', 'EUR', 'GBP', etc. ISO 4217 format */
  currencyCode: Scalars['String'];
  /** The number of units in the billing period */
  period: Scalars['Int'];
  /** The plan amount in cents */
  price: Scalars['Int'];
  /** The unit of the billing period. Either 'day', 'week', 'month' or 'year' */
  unit: Scalars['String'];
};

export type ContentDrop = {
  __typename?: 'ContentDrop';
  backgroundColor: Scalars['String'];
  content?: Maybe<Array<ContentDropContent>>;
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  textColor: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type ContentDropContent = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ContentType = RecentSearchContent & {
  __typename?: 'ContentType';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Coupon = {
  __typename?: 'Coupon';
  /** The currency code of the discount amount. E.g. 'USD', 'EUR', 'GBP', etc. ISO 4217 format: https://www.chargebee.com/docs/2.0/supported-currencies.html */
  currencyCode?: Maybe<Scalars['String']>;
  /** In cents */
  discountAmount?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Float']>;
  /** The type of the discount. Either 'percentage' or 'fixed_amount'. */
  discountType: Scalars['String'];
  /** The duration of the coupon. Either 'one_time', 'forever' or 'limited_period' */
  durationType: Scalars['String'];
  id: Scalars['String'];
};

export type CreatePlaylistInput = {
  /** Playlist name */
  name: Scalars['String'];
  /** Playlist image id */
  playlistImageId: Scalars['ID'];
  /** Stories ids */
  storiesIds?: Maybe<Array<Scalars['ID']>>;
};


export type DeletePlaylistInput = {
  /** Playlist id */
  playlistId: Scalars['ID'];
};

export type Duration = {
  durationAbove: Scalars['Int'];
  durationBelow: Scalars['Int'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  enabled: Scalars['Boolean'];
  featureName: Scalars['String'];
};

export type FilterSelection = {
  /** If true returns only stories that have been already listened to. Requires authentication. */
  alreadyListened?: Maybe<Scalars['Boolean']>;
  contentTypeSlugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  duration?: Maybe<Duration>;
  /** If true excludes already listened stories from the response. Requires authentication. */
  excludeAlreadyListened?: Maybe<Scalars['Boolean']>;
  /**
   * If true excludes femtasy red stories in the results. By default, they
   *       will be included.
   */
  excludeFemtasyRed?: Maybe<Scalars['Boolean']>;
  genreIds?: Maybe<Array<Scalars['ID']>>;
  /** If true returns only three sixty stories. */
  isThreeSixtyStory?: Maybe<Scalars['Boolean']>;
  languageIntensityIds?: Maybe<Array<Scalars['ID']>>;
  /** If true returns only loved stories. Requires authentication. */
  lovedStories?: Maybe<Scalars['Boolean']>;
  markets?: Maybe<Array<Market>>;
  /** DEPRECATED. Use `stories_from_loved_speakers` instead. If true returns only stories from loved speakers, if false, returns only stories from not loved speakers. Requires authentication. */
  onlyLoved?: Maybe<Scalars['Boolean']>;
  participantTypes?: Maybe<Array<Maybe<ParticipantType>>>;
  seriesIds?: Maybe<Array<Scalars['ID']>>;
  speakerGender?: Maybe<Gender>;
  speakerIds?: Maybe<Array<Scalars['ID']>>;
  /** If true returns only stories from loved speakers. Requires authentication. */
  storiesFromLovedSpeakers?: Maybe<Scalars['Boolean']>;
  storyIds?: Maybe<Array<Scalars['ID']>>;
  tagIds?: Maybe<Array<Scalars['ID']>>;
  tagIdsByOr?: Maybe<Array<Scalars['ID']>>;
};

export enum Gender {
  Diverse = 'DIVERSE',
  Female = 'FEMALE',
  Male = 'MALE'
}

export type Genre = RecentSearchContent & {
  __typename?: 'Genre';
  createdAt: Scalars['NaiveDateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  storiesCount: Scalars['Int'];
  updatedAt: Scalars['NaiveDateTime'];
};

export type InfluencerCode = {
  __typename?: 'InfluencerCode';
  description: Scalars['String'];
  discountCode: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  utmCampaign: Scalars['String'];
};

export type Journey = {
  __typename?: 'Journey';
  backgroundGradientBottom: Scalars['String'];
  backgroundGradientTop: Scalars['String'];
  completionMessage: Scalars['String'];
  description: Scalars['String'];
  headerIllustration?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  illustration?: Maybe<Scalars['String']>;
  languageIntensity: LanguageIntensity;
  longTitle: Scalars['String'];
  releaseDate?: Maybe<Scalars['NaiveDateTime']>;
  stories: StoriesResponse;
  tags: Array<Tag>;
  teaser?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  transcodedTeaserUrl?: Maybe<Scalars['String']>;
};


export type JourneyStoriesArgs = {
  filterSelection?: Maybe<FilterSelection>;
  order?: Maybe<StoryOrder>;
  pagination?: Maybe<Pagination>;
};

export type JourneyFilters = {
  journeyIds?: Maybe<Array<Scalars['ID']>>;
};


export type KlaviyoForm = {
  __typename?: 'KlaviyoForm';
  active: Scalars['Boolean'];
  displayUrl: Scalars['String'];
  excludeUrls?: Maybe<Scalars['String']>;
  formId: Scalars['String'];
  id: Scalars['ID'];
  includeUrls?: Maybe<Scalars['String']>;
  showAfter: Scalars['Int'];
  showOnlyOnce: Scalars['Boolean'];
  title: Scalars['String'];
};

export type LanguageIntensity = RecentSearchContent & {
  __typename?: 'LanguageIntensity';
  createdAt: Scalars['NaiveDateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  updatedAt: Scalars['NaiveDateTime'];
};

export type MarkStoryAsListenedInput = {
  storyId: Scalars['ID'];
  timeStopped: Scalars['Int'];
};

export enum Market {
  De = 'DE',
  EnGb = 'EN_GB',
  EnUs = 'EN_US',
  FrFr = 'FR_FR'
}

export type MasturbationTechnique = {
  __typename?: 'MasturbationTechnique';
  description: Scalars['String'];
  headerIllustration: Scalars['String'];
  id: Scalars['ID'];
  stories: StoriesResponse;
  tileIllustration: Scalars['String'];
  title: Scalars['String'];
};


export type MasturbationTechniqueStoriesArgs = {
  filterSelection?: Maybe<FilterSelection>;
  order?: Maybe<StoryOrder>;
  pagination?: Maybe<Pagination>;
};

export enum MasturbationTechniqueSortBy {
  Position = 'POSITION'
}

export type MasturbationTechniquesFilters = {
  masturbationTechniquesIds?: Maybe<Array<Scalars['ID']>>;
};

export type MasturbationTechniquesOrder = {
  order?: Maybe<SortOrder>;
  orderBy?: Maybe<MasturbationTechniqueSortBy>;
};

export type Message = {
  __typename?: 'Message';
  text?: Maybe<Scalars['String']>;
};

export enum MessageKey {
  SignupDiscountMessage = 'SIGNUP_DISCOUNT_MESSAGE'
}


export type NewCheckout = {
  __typename?: 'NewCheckout';
  response: Scalars['String'];
};

export type NewCheckoutInput = {
  planId: Scalars['String'];
  /** The tracking_id associated to the referral's user_id */
  referralId?: Maybe<Scalars['String']>;
  utm?: Maybe<Utm>;
};

export enum NewsletterList {
  DachOrganicSocialLeadCampaigns = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGNS',
  DachOrganicSocialLeadCampaign_1 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_1',
  DachOrganicSocialLeadCampaign_2 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_2',
  DachOrganicSocialLeadCampaign_3 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_3',
  DachOrganicSocialLeadCampaign_4 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_4',
  DachOrganicSocialLeadCampaign_5 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_5',
  DachOrganicSocialLeadCampaign_6 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_6',
  DachOrganicSocialLeadCampaign_7 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_7',
  DachOrganicSocialLeadCampaign_8 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_8',
  DachOrganicSocialLeadCampaign_9 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_9',
  DachOrganicSocialLeadCampaign_10 = 'DACH_ORGANIC_SOCIAL_LEAD_CAMPAIGN_10',
  DachPlatformFooter = 'DACH_PLATFORM_FOOTER',
  DachPodcast_1 = 'DACH_PODCAST_1',
  DachPodcast_2 = 'DACH_PODCAST_2',
  DachPodcast_3 = 'DACH_PODCAST_3',
  DachPodcast_4 = 'DACH_PODCAST_4',
  DachPodcast_5 = 'DACH_PODCAST_5',
  DachPodcast_6 = 'DACH_PODCAST_6',
  DachPodcast_7 = 'DACH_PODCAST_7',
  DachPodcast_8 = 'DACH_PODCAST_8',
  DachPodcast_9 = 'DACH_PODCAST_9',
  DachPodcast_10 = 'DACH_PODCAST_10',
  DachPodcastBattle_1 = 'DACH_PODCAST_BATTLE_1',
  DachPodcastBattle_2 = 'DACH_PODCAST_BATTLE_2',
  DachPodcastBattle_3 = 'DACH_PODCAST_BATTLE_3',
  DachPodcastBattle_4 = 'DACH_PODCAST_BATTLE_4',
  DachPodcastBattle_5 = 'DACH_PODCAST_BATTLE_5',
  DachPodcastBattle_6 = 'DACH_PODCAST_BATTLE_6',
  DachPodcastBattle_7 = 'DACH_PODCAST_BATTLE_7',
  DachPodcastBattle_8 = 'DACH_PODCAST_BATTLE_8',
  DachPodcastBattle_9 = 'DACH_PODCAST_BATTLE_9',
  DachPodcastBattle_10 = 'DACH_PODCAST_BATTLE_10',
  DachPodcastTeaser = 'DACH_PODCAST_TEASER',
  DeInstagramOrganic_1 = 'DE_INSTAGRAM_ORGANIC_1',
  DeInstagramOrganic_2 = 'DE_INSTAGRAM_ORGANIC_2',
  DeInstagramOrganic_3 = 'DE_INSTAGRAM_ORGANIC_3',
  DeOther_1 = 'DE_OTHER_1',
  DeOther_2 = 'DE_OTHER_2',
  DePinterestPaidAds_1 = 'DE_PINTEREST_PAID_ADS_1',
  DePinterestPaidAds_2 = 'DE_PINTEREST_PAID_ADS_2',
  DePinterestPaidAds_3 = 'DE_PINTEREST_PAID_ADS_3',
  EngOrganicSocialLeadCampaign_1 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_1',
  EngOrganicSocialLeadCampaign_2 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_2',
  EngOrganicSocialLeadCampaign_3 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_3',
  EngOrganicSocialLeadCampaign_4 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_4',
  EngOrganicSocialLeadCampaign_5 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_5',
  EngOrganicSocialLeadCampaign_6 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_6',
  EngOrganicSocialLeadCampaign_7 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_7',
  EngOrganicSocialLeadCampaign_8 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_8',
  EngOrganicSocialLeadCampaign_9 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_9',
  EngOrganicSocialLeadCampaign_10 = 'ENG_ORGANIC_SOCIAL_LEAD_CAMPAIGN_10',
  EnPlatformFooter = 'EN_PLATFORM_FOOTER',
  FrInstagramOrganic_1 = 'FR_INSTAGRAM_ORGANIC_1',
  FrInstagramOrganic_2 = 'FR_INSTAGRAM_ORGANIC_2',
  FrInstagramOrganic_3 = 'FR_INSTAGRAM_ORGANIC_3',
  FrOrganicSocialLeadCampaigns = 'FR_ORGANIC_SOCIAL_LEAD_CAMPAIGNS',
  FrOther_1 = 'FR_OTHER_1',
  FrOther_2 = 'FR_OTHER_2',
  FrPinterestPaidAds_1 = 'FR_PINTEREST_PAID_ADS_1',
  FrPinterestPaidAds_2 = 'FR_PINTEREST_PAID_ADS_2',
  FrPinterestPaidAds_3 = 'FR_PINTEREST_PAID_ADS_3',
  FrPlatformFooter = 'FR_PLATFORM_FOOTER',
  FrPodcast_1 = 'FR_PODCAST_1',
  FrPodcast_2 = 'FR_PODCAST_2',
  FrPodcast_3 = 'FR_PODCAST_3',
  FrPodcastBattle_1 = 'FR_PODCAST_BATTLE_1',
  FrPodcastBattle_2 = 'FR_PODCAST_BATTLE_2',
  FrPodcastBattle_3 = 'FR_PODCAST_BATTLE_3',
  FrPodcastBattle_4 = 'FR_PODCAST_BATTLE_4',
  FrPodcastBattle_5 = 'FR_PODCAST_BATTLE_5',
  FrPodcastBattle_6 = 'FR_PODCAST_BATTLE_6',
  FrPodcastBattle_7 = 'FR_PODCAST_BATTLE_7',
  FrPodcastBattle_8 = 'FR_PODCAST_BATTLE_8',
  FrPodcastBattle_9 = 'FR_PODCAST_BATTLE_9',
  FrPodcastBattle_10 = 'FR_PODCAST_BATTLE_10',
  Student = 'STUDENT'
}

export enum NotificationType {
  NewExplorePage = 'NEW_EXPLORE_PAGE',
  NewHomePage = 'NEW_HOME_PAGE',
  OrgasmTooltip = 'ORGASM_TOOLTIP',
  PwaBanner = 'PWA_BANNER',
  StoryDetailsActionsMenuTooltip = 'STORY_DETAILS_ACTIONS_MENU_TOOLTIP'
}

export type OnboardingV1Response = {
  __typename?: 'OnboardingV1Response';
  contentTypes?: Maybe<Array<Scalars['String']>>;
  languageIntensity?: Maybe<Scalars['String']>;
  reasons?: Maybe<Array<Scalars['String']>>;
  scenarios?: Maybe<Array<Scalars['String']>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type Pagination = {
  page: Scalars['Int'];
  perPage: Scalars['Int'];
};

export enum ParticipantType {
  Anonym = 'ANONYM',
  Diverse = 'DIVERSE',
  Female = 'FEMALE',
  FemaleFemale = 'FEMALE_FEMALE',
  FemaleMale = 'FEMALE_MALE',
  Male = 'MALE',
  MaleFemale = 'MALE_FEMALE',
  MaleMale = 'MALE_MALE'
}

export type ParticipantsType = {
  __typename?: 'ParticipantsType';
  name: Scalars['String'];
  slug: ParticipantType;
};

export type Playlist = {
  __typename?: 'Playlist';
  createdAt?: Maybe<Scalars['NaiveDateTime']>;
  id: Scalars['ID'];
  image?: Maybe<PlaylistImage>;
  name?: Maybe<Scalars['String']>;
  publicAccess: Scalars['Boolean'];
  showAsCuration: Scalars['Boolean'];
  showOnExplorePage: Scalars['Boolean'];
  stories: StoriesResponse;
  type: PlaylistTypeEnum;
};


export type PlaylistStoriesArgs = {
  filterSelection?: Maybe<FilterSelection>;
  order?: Maybe<StoryOrder>;
  pagination?: Maybe<Pagination>;
};

export type PlaylistFilters = {
  ids?: Maybe<Array<Scalars['ID']>>;
  types?: Maybe<Array<PlaylistTypeEnum>>;
  visibleAsCuration?: Maybe<Scalars['Boolean']>;
  visibleOnHomePage?: Maybe<Scalars['Boolean']>;
};

export type PlaylistImage = {
  __typename?: 'PlaylistImage';
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
};

export type PlaylistImagesFilters = {
  showInCreationDialog?: Maybe<Scalars['Boolean']>;
};

export enum PlaylistTypeEnum {
  Femtasy = 'FEMTASY',
  FemtasyEditorial = 'FEMTASY_EDITORIAL',
  Tag = 'TAG',
  User = 'USER'
}

export type PortalSession = {
  __typename?: 'PortalSession';
  response: Scalars['String'];
};

export type PostPurchaseAnswer = {
  __typename?: 'PostPurchaseAnswer';
  freeText: Scalars['Boolean'];
  freeTextPlaceholder?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  localizedLabel: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  optionsTrackingIds?: Maybe<Array<Scalars['String']>>;
  sendSelectedOptionAsKey: Scalars['Boolean'];
};

export type RecentSearchContent = {
  id: Scalars['ID'];
};

export type RecentSearchesFilters = {
  types?: Maybe<Array<SearchResultType>>;
};

export type RecommendedStories = {
  __typename?: 'RecommendedStories';
  recommendedStories: Array<Story>;
};

export type RedeemOfferInput = {
  offerType: RedeemedOfferType;
  variant: RedeemedOfferVariant;
};

export type RedeemedOffer = {
  __typename?: 'RedeemedOffer';
  createdAt: Scalars['NaiveDateTime'];
  offerType: RedeemedOfferType;
  updatedAt: Scalars['NaiveDateTime'];
};

export enum RedeemedOfferType {
  CancelFlowDiscount_1 = 'CANCEL_FLOW_DISCOUNT_1',
  CancelFlowDiscount_2 = 'CANCEL_FLOW_DISCOUNT_2',
  Discount = 'DISCOUNT',
  Downgrade = 'DOWNGRADE',
  TrialExtension = 'TRIAL_EXTENSION'
}

export enum RedeemedOfferVariant {
  Feedback = 'FEEDBACK',
  Regular = 'REGULAR',
  ScheduleForCancellation = 'SCHEDULE_FOR_CANCELLATION'
}

export type RemoveStoryFromPlaylistInput = {
  /** Playlist id */
  playlistId: Scalars['ID'];
  /** Story id */
  storyId: Scalars['ID'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Adds a story to a playlist */
  addStoryToPlaylist: Playlist;
  /** Cancels a subscription */
  cancelSubscription: User;
  /** Creates a playlist */
  createPlaylist: Playlist;
  /** Creates a portal session for a customer */
  createPortalSession: PortalSession;
  deletePlaylist: Playlist;
  increaseNumberOfListens?: Maybe<Story>;
  markStoryAsListened?: Maybe<Story>;
  /** Creates a new checkout for the checkout hosted page. */
  newCheckout: NewCheckout;
  /** Reactivates a subscription that is in trial state */
  reactivateSubscription?: Maybe<User>;
  redeemOffer?: Maybe<User>;
  /** Removes a story from a playlist */
  removeStoryFromPlaylist: Playlist;
  savePlaylistToMyPlaylists: Playlist;
  /** Saves a post purchase survey answer for the current user */
  savePostPurchaseSurveyAnswer?: Maybe<Scalars['Boolean']>;
  /** Saves a recent search */
  saveRecentSearch?: Maybe<Scalars['Boolean']>;
  /** Tracks an event with Segment */
  segmentTrack: Scalars['Boolean'];
  setNotificationShown?: Maybe<UserNotification>;
  /** Updates the story markets for the current user */
  setStoryMarkets: User;
  /** Set the user preferences */
  setUserPreferences?: Maybe<UserPreferences>;
  /** Adds a grace period to the user */
  startGracePeriod: User;
  /** Stores a user onboarding responses */
  storeOnboardingResponses?: Maybe<Scalars['Boolean']>;
  /** Attempts to subscribe the provided email to the newsletter */
  subscribeToNewsletter?: Maybe<Scalars['Boolean']>;
  toggleLoveSpeaker?: Maybe<Speaker>;
  toggleLoveStory?: Maybe<Story>;
  /** Updates user's playlist */
  updatePlaylist: Playlist;
  updateTimeStopped?: Maybe<Story>;
};


export type RootMutationTypeAddStoryToPlaylistArgs = {
  input: AddStoryToPlaylistInput;
};


export type RootMutationTypeCreatePlaylistArgs = {
  input: CreatePlaylistInput;
};


export type RootMutationTypeDeletePlaylistArgs = {
  input: DeletePlaylistInput;
};


export type RootMutationTypeIncreaseNumberOfListensArgs = {
  storyId: Scalars['ID'];
};


export type RootMutationTypeMarkStoryAsListenedArgs = {
  input: MarkStoryAsListenedInput;
};


export type RootMutationTypeNewCheckoutArgs = {
  input: NewCheckoutInput;
};


export type RootMutationTypeRedeemOfferArgs = {
  redeemOfferInput: RedeemOfferInput;
};


export type RootMutationTypeRemoveStoryFromPlaylistArgs = {
  input: RemoveStoryFromPlaylistInput;
};


export type RootMutationTypeSavePlaylistToMyPlaylistsArgs = {
  input: SavePlaylistToMyPlaylistsInput;
};


export type RootMutationTypeSavePostPurchaseSurveyAnswerArgs = {
  answer?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  planName: Scalars['String'];
  position: Scalars['Int'];
  subscriptionId?: Maybe<Scalars['String']>;
};


export type RootMutationTypeSaveRecentSearchArgs = {
  searchableId: Scalars['String'];
  searchableType: SearchResultType;
};


export type RootMutationTypeSegmentTrackArgs = {
  input: SegmentInput;
};


export type RootMutationTypeSetNotificationShownArgs = {
  input: SetNotificationShownInput;
};


export type RootMutationTypeSetStoryMarketsArgs = {
  input: Array<Market>;
};


export type RootMutationTypeSetUserPreferencesArgs = {
  input: UserPreferencesInput;
};


export type RootMutationTypeStoreOnboardingResponsesArgs = {
  serializedResponses: Scalars['String'];
};


export type RootMutationTypeSubscribeToNewsletterArgs = {
  campaign: NewsletterList;
  email: Scalars['String'];
};


export type RootMutationTypeToggleLoveSpeakerArgs = {
  input: ToggleLoveSpeakerInput;
};


export type RootMutationTypeToggleLoveStoryArgs = {
  input: ToggleLoveStoryInput;
};


export type RootMutationTypeUpdatePlaylistArgs = {
  input: UpdatePlaylistInput;
};


export type RootMutationTypeUpdateTimeStoppedArgs = {
  input: UpdateTimeStoppedInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  activeContentDrop?: Maybe<ContentDrop>;
  favouriteKinks: Array<Tag>;
  /** Get all feature flags */
  featureFlags: Array<FeatureFlag>;
  genres: Array<Genre>;
  hotStories: StoriesResponse;
  /** Get a specific influencer code */
  influencerCode?: Maybe<InfluencerCode>;
  /** Get all journeys */
  journeys: Array<Journey>;
  /** Get Klaviyo forms */
  klaviyoForms: Array<KlaviyoForm>;
  languageIntensities: Array<LanguageIntensity>;
  /** Get the last five stories that the user has listened to */
  listenedStories: Array<Story>;
  /** Get all masturbation techniques */
  masturbationTechniques: Array<MasturbationTechnique>;
  me: User;
  message?: Maybe<Message>;
  playlistImages: Array<PlaylistImage>;
  /** Get user's playlists */
  playlists: Array<Playlist>;
  postPurchaseAnswers: Array<PostPurchaseAnswer>;
  /** Get recent searches */
  recentSearches: Array<RecentSearchContent>;
  recommendedStories?: Maybe<RecommendedStories>;
  /** Get Redeemed Offers */
  redeemedOffers: Array<RedeemedOffer>;
  search: SearchResult;
  speakers: SpeakersResponse;
  stories: StoriesResponse;
  story?: Maybe<Story>;
  tag?: Maybe<Tag>;
  tags: Array<Tag>;
  userNotifications: Array<UserNotification>;
  /** Get user's user_preferences */
  userPreferences?: Maybe<UserPreferences>;
};


export type RootQueryTypeFavouriteKinksArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type RootQueryTypeInfluencerCodeArgs = {
  utmCampaign: Scalars['String'];
};


export type RootQueryTypeJourneysArgs = {
  journeyFilters?: Maybe<JourneyFilters>;
};


export type RootQueryTypeMasturbationTechniquesArgs = {
  masturbationTechniquesFilters?: Maybe<MasturbationTechniquesFilters>;
  masturbationTechniquesOrder?: Maybe<MasturbationTechniquesOrder>;
};


export type RootQueryTypeMessageArgs = {
  key: MessageKey;
};


export type RootQueryTypePlaylistImagesArgs = {
  filters?: Maybe<PlaylistImagesFilters>;
};


export type RootQueryTypePlaylistsArgs = {
  filters?: Maybe<PlaylistFilters>;
};


export type RootQueryTypeRecentSearchesArgs = {
  filters?: Maybe<RecentSearchesFilters>;
  pagination?: Maybe<Pagination>;
};


export type RootQueryTypeRecommendedStoriesArgs = {
  campaign: Scalars['String'];
  distinctBySpeaker?: Maybe<Scalars['Boolean']>;
  genreIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  limitByKinkinessScore?: Maybe<Scalars['Boolean']>;
  numberResults?: Maybe<Scalars['Int']>;
  speakerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  storyId?: Maybe<Scalars['ID']>;
  tagIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};


export type RootQueryTypeSearchArgs = {
  keyword: Scalars['String'];
};


export type RootQueryTypeSpeakersArgs = {
  order?: Maybe<SpeakerOrder>;
  orderOptions?: Maybe<Array<Maybe<SpeakerOrder>>>;
  pagination?: Maybe<Pagination>;
  speakerFilters?: Maybe<SpeakerFilters>;
};


export type RootQueryTypeStoriesArgs = {
  filterSelection?: Maybe<FilterSelection>;
  order?: Maybe<StoryOrder>;
  pagination?: Maybe<Pagination>;
};


export type RootQueryTypeStoryArgs = {
  returnCookies?: Maybe<Scalars['Boolean']>;
  storyId: Scalars['ID'];
};


export type RootQueryTypeTagArgs = {
  tagId: Scalars['ID'];
};


export type RootQueryTypeTagsArgs = {
  order?: Maybe<TagOrder>;
  pagination?: Maybe<Pagination>;
  tagFilters?: Maybe<TagFilters>;
};

export type SavePlaylistToMyPlaylistsInput = {
  /** Playlist id */
  playlistId: Scalars['ID'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  items: Array<SearchResultItem>;
};

export type SearchResultItem = Genre | Speaker | Story | Tag;

export enum SearchResultType {
  ContentType = 'ContentType',
  Genre = 'Genre',
  LanguageIntensity = 'LanguageIntensity',
  Speaker = 'Speaker',
  Story = 'Story',
  Tag = 'Tag'
}

export type SegmentInput = {
  eventName?: Maybe<Scalars['String']>;
  requestType?: SegmentRequestType;
  /** Object with the traits to be sent to Segment */
  traits: Scalars['Json'];
};

export enum SegmentRequestType {
  Identify = 'IDENTIFY',
  Track = 'TRACK'
}

export type Series = ContentDropContent & {
  __typename?: 'Series';
  description: Scalars['String'];
  id: Scalars['ID'];
  stories: StoriesResponse;
  title: Scalars['String'];
};


export type SeriesStoriesArgs = {
  filterSelection?: Maybe<FilterSelection>;
  order?: Maybe<StoryOrder>;
  pagination?: Maybe<Pagination>;
};

export type SeriesInfo = {
  __typename?: 'SeriesInfo';
  nextStory?: Maybe<StoryInterface>;
  previousStory?: Maybe<StoryInterface>;
  title?: Maybe<Scalars['String']>;
};

export type SetNotificationShownInput = {
  notificationType?: Maybe<NotificationType>;
};

export enum SortOrder {
  Asc = 'ASC',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type Speaker = RecentSearchContent & {
  __typename?: 'Speaker';
  accent?: Maybe<Accent>;
  createdAt: Scalars['NaiveDateTime'];
  description?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  gender: Gender;
  id: Scalars['ID'];
  illustration?: Maybe<Scalars['String']>;
  loved: Scalars['Boolean'];
  lovedAt?: Maybe<Scalars['NaiveDateTime']>;
  name: Scalars['String'];
  numberOfListens: Scalars['Int'];
  participantsType: ParticipantsType;
  rating: Scalars['Decimal'];
  stories: StoriesResponse;
  /** @deprecated Use `stories.totalCount instead */
  storiesCount: Scalars['Int'];
  transcodedSampleUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['NaiveDateTime'];
};


export type SpeakerStoriesArgs = {
  filterSelection?: Maybe<FilterSelection>;
  order?: Maybe<StoryOrder>;
  pagination?: Maybe<Pagination>;
};

export type SpeakerFilters = {
  /** If true returns only loved speakers. Needs to be an authenticated request. */
  onlyLoved?: Maybe<Scalars['Boolean']>;
  participantTypes?: Maybe<Array<Maybe<ParticipantType>>>;
  speakerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** Order options to sort the speakers. The order matters. */
export type SpeakerOrder = {
  order?: Maybe<SortOrder>;
  orderBy?: Maybe<SpeakerSortBy>;
};

export enum SpeakerSortBy {
  CreatedAt = 'CREATED_AT',
  /** Sorts the speakers that have the featured flag enabled. */
  Featured = 'FEATURED',
  /** Sorts the speakers by when they were loved by the user. Requires authentication. */
  LovedAt = 'LOVED_AT',
  Name = 'NAME',
  NumberOfListens = 'NUMBER_OF_LISTENS',
  Rating = 'RATING'
}

export type SpeakersResponse = {
  __typename?: 'SpeakersResponse';
  speakers: Array<Speaker>;
  totalCount: Scalars['Int'];
};

export type StoriesResponse = {
  __typename?: 'StoriesResponse';
  stories: Array<StoryInterface>;
  totalCount: Scalars['Int'];
};

export type Story = ContentDropContent & StoryInterface & {
  __typename?: 'Story';
  actions: Array<StoryActions>;
  alreadyListened: Scalars['Boolean'];
  /** @deprecated Field removed, returns fake data */
  alreadyVoted: Scalars['Boolean'];
  contentType: ContentType;
  createdAt: Scalars['NaiveDateTime'];
  description: Scalars['String'];
  /** Story duration in seconds */
  duration: Scalars['Int'];
  durationInMinutes: Scalars['String'];
  femtasyRed: Scalars['Boolean'];
  freeTrial: Scalars['Boolean'];
  genre: Genre;
  id: Scalars['ID'];
  isNew: Scalars['Boolean'];
  languageIntensity: LanguageIntensity;
  loved: Scalars['Boolean'];
  markets: Array<Market>;
  numberOfListens?: Maybe<Scalars['Int']>;
  orgasms: Array<Scalars['Int']>;
  playlists: Array<Playlist>;
  rating?: Maybe<Scalars['Decimal']>;
  recommendedOrder?: Maybe<Scalars['Int']>;
  releaseDate: Scalars['NaiveDateTime'];
  relevanceScore?: Maybe<Scalars['Float']>;
  /** @deprecated safeDescription no longer be supported */
  safeDescription: Scalars['String'];
  /**
   * Returns the series info for the story when the story belongs to a series.
   *
   *   This field is NOT OPTIMIZED for lists of stories as it doesn't use the dataloader.
   */
  seriesInfo?: Maybe<SeriesInfo>;
  speaker: Speaker;
  tags: Array<Tag>;
  themeTag?: Maybe<Tag>;
  title: Scalars['String'];
  transcodedAudioUrl?: Maybe<Scalars['String']>;
  transcodedSampleUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['NaiveDateTime'];
  /** @deprecated Field removed, returns fake data */
  userRating?: Maybe<Scalars['Int']>;
};

export enum StoryActions {
  Play = 'PLAY'
}

export type StoryInterface = {
  actions: Array<StoryActions>;
  alreadyListened: Scalars['Boolean'];
  alreadyVoted: Scalars['Boolean'];
  contentType: ContentType;
  createdAt: Scalars['NaiveDateTime'];
  description: Scalars['String'];
  /** Story duration in seconds */
  duration: Scalars['Int'];
  durationInMinutes: Scalars['String'];
  femtasyRed: Scalars['Boolean'];
  freeTrial: Scalars['Boolean'];
  genre: Genre;
  id: Scalars['ID'];
  isNew: Scalars['Boolean'];
  languageIntensity: LanguageIntensity;
  loved: Scalars['Boolean'];
  markets: Array<Market>;
  numberOfListens?: Maybe<Scalars['Int']>;
  orgasms: Array<Scalars['Int']>;
  playlists: Array<Playlist>;
  rating?: Maybe<Scalars['Decimal']>;
  recommendedOrder?: Maybe<Scalars['Int']>;
  releaseDate: Scalars['NaiveDateTime'];
  relevanceScore?: Maybe<Scalars['Float']>;
  safeDescription: Scalars['String'];
  speaker: Speaker;
  tags: Array<Tag>;
  themeTag?: Maybe<Tag>;
  title: Scalars['String'];
  transcodedAudioUrl?: Maybe<Scalars['String']>;
  transcodedSampleUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['NaiveDateTime'];
  userRating?: Maybe<Scalars['Int']>;
};

export type StoryOrder = {
  campaign?: Maybe<Scalars['String']>;
  order?: Maybe<SortOrder>;
  orderBy?: Maybe<StorySortBy>;
};

export enum StorySortBy {
  CreatedAt = 'CREATED_AT',
  NumberOfListens = 'NUMBER_OF_LISTENS',
  Personalize = 'PERSONALIZE',
  Rating = 'RATING',
  RecommendedOrder = 'RECOMMENDED_ORDER',
  ReleaseDate = 'RELEASE_DATE'
}

export type Tag = RecentSearchContent & {
  __typename?: 'Tag';
  bubbleWithTitle?: Maybe<Scalars['String']>;
  bubbleWithTitleAndImage?: Maybe<Scalars['String']>;
  createdAt: Scalars['NaiveDateTime'];
  description?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  featuredImage?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isAffirmation?: Maybe<Scalars['Boolean']>;
  isMood?: Maybe<Scalars['Boolean']>;
  isScenario?: Maybe<Scalars['Boolean']>;
  isUserPlaylist: Scalars['Boolean'];
  kinkinessScore?: Maybe<Scalars['Int']>;
  mostRecentAddedAt?: Maybe<Scalars['NaiveDateTime']>;
  name: Scalars['String'];
  numberOfListens: Scalars['Int'];
  onboardingImage?: Maybe<Scalars['String']>;
  onboardingPosition?: Maybe<Scalars['Int']>;
  playlist: Playlist;
  rating: Scalars['Decimal'];
  stories: StoriesResponse;
  /** @deprecated Use `stories.totalCount instead */
  storiesCount: Scalars['Int'];
  updatedAt: Scalars['NaiveDateTime'];
  visualWithText?: Maybe<Scalars['String']>;
  visualWithoutText?: Maybe<Scalars['String']>;
};


export type TagStoriesArgs = {
  filterSelection?: Maybe<FilterSelection>;
  order?: Maybe<StoryOrder>;
  pagination?: Maybe<Pagination>;
};

export type TagFilters = {
  contentTypeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isAffirmation?: Maybe<Scalars['Boolean']>;
  isFeatured?: Maybe<Scalars['Boolean']>;
  isMood?: Maybe<Scalars['Boolean']>;
  isScenario?: Maybe<Scalars['Boolean']>;
  /** Returns only the Tags that have onboarding_position other than null */
  onlyWithOnboardingPosition?: Maybe<Scalars['Boolean']>;
  tagIds?: Maybe<Array<Scalars['ID']>>;
};

export type TagOrder = {
  order?: Maybe<SortOrder>;
  orderBy?: Maybe<TagSortBy>;
};

export enum TagSortBy {
  CreatedAt = 'CREATED_AT',
  NumberOfListens = 'NUMBER_OF_LISTENS',
  OnboardingPosition = 'ONBOARDING_POSITION',
  Rating = 'RATING',
  UpdatedAt = 'UPDATED_AT'
}

export type ThreeSixtyStory = StoryInterface & {
  __typename?: 'ThreeSixtyStory';
  actions: Array<StoryActions>;
  alreadyListened: Scalars['Boolean'];
  /** @deprecated Field removed, returns fake data */
  alreadyVoted: Scalars['Boolean'];
  contentType: ContentType;
  createdAt: Scalars['NaiveDateTime'];
  description: Scalars['String'];
  /** Story duration in seconds */
  duration: Scalars['Int'];
  durationInMinutes: Scalars['String'];
  femtasyRed: Scalars['Boolean'];
  freeTrial: Scalars['Boolean'];
  genre: Genre;
  id: Scalars['ID'];
  image: Scalars['String'];
  isNew: Scalars['Boolean'];
  languageIntensity: LanguageIntensity;
  loved: Scalars['Boolean'];
  markets: Array<Market>;
  numberOfListens?: Maybe<Scalars['Int']>;
  orgasms: Array<Scalars['Int']>;
  playlists: Array<Playlist>;
  rating?: Maybe<Scalars['Decimal']>;
  recommendedOrder?: Maybe<Scalars['Int']>;
  releaseDate: Scalars['NaiveDateTime'];
  relevanceScore?: Maybe<Scalars['Float']>;
  /** @deprecated safeDescription no longer be supported */
  safeDescription: Scalars['String'];
  /**
   * Returns the series info for the story when the story belongs to a series.
   *
   *   This field is NOT OPTIMIZED for lists of stories as it doesn't use the dataloader.
   */
  seriesInfo?: Maybe<SeriesInfo>;
  speaker: Speaker;
  tags: Array<Tag>;
  themeTag?: Maybe<Tag>;
  title: Scalars['String'];
  transcodedAudioUrl?: Maybe<Scalars['String']>;
  transcodedSampleUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['NaiveDateTime'];
  /** @deprecated Field removed, returns fake data */
  userRating?: Maybe<Scalars['Int']>;
};

export type ToggleLoveSpeakerInput = {
  speakerId: Scalars['ID'];
};

export type ToggleLoveStoryInput = {
  storyId: Scalars['ID'];
};

export type UpdatePlaylistInput = {
  /** Playlist name */
  name: Scalars['String'];
  /** Playlist id */
  playlistId: Scalars['ID'];
  /** Playlist Image id */
  playlistImageId: Scalars['ID'];
  /** Playlist stories */
  storiesIds: Array<Scalars['ID']>;
};

export type UpdateTimeStoppedInput = {
  storyId: Scalars['ID'];
  timeStopped: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  activeSubscription?: Maybe<UserSubscription>;
  email: Scalars['String'];
  emailConfirmed: Scalars['Boolean'];
  favouriteSound?: Maybe<Story>;
  favouriteStory?: Maybe<Story>;
  id: Scalars['ID'];
  isFirstSession: Scalars['Boolean'];
  maxedOutTrials: Scalars['Boolean'];
  modeKinkiness?: Maybe<Scalars['Float']>;
  nickname?: Maybe<Scalars['String']>;
  onboardingResponses: Array<Maybe<UserOnboardingResponses>>;
  pinSet: Scalars['Boolean'];
  primaryMarket: Market;
  provider?: Maybe<Scalars['String']>;
  signUpDate: Scalars['NaiveDateTime'];
  storyMarkets: Array<Market>;
  submittedPostPurchaseSurvey: Scalars['Boolean'];
  /** @deprecated Use `user.activeSubscription.expiresAt` instead */
  subscriptionExpiresAt?: Maybe<Scalars['NaiveDateTime']>;
  /** @deprecated Use `user.activeSubscription.subscriptionId` instead */
  subscriptionId?: Maybe<Scalars['String']>;
  /** The user's time spent listening to stories in seconds */
  timeSpent: Scalars['Int'];
  topContentType?: Maybe<ContentType>;
  trackingId: Scalars['String'];
  verificationStatus?: Maybe<VerificationStatus>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  count: Scalars['Int'];
  createdAt: Scalars['NaiveDateTime'];
  id: Scalars['ID'];
  lastShownAt: Scalars['NaiveDateTime'];
  notificationType: NotificationType;
  updatedAt: Scalars['NaiveDateTime'];
};

export type UserOnboardingResponses = {
  __typename?: 'UserOnboardingResponses';
  id: Scalars['ID'];
  responses: OnboardingV1Response;
  version: Scalars['Int'];
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  createdAt: Scalars['NaiveDateTime'];
  hideAlreadyListened: Scalars['Boolean'];
  id: Scalars['ID'];
  updatedAt: Scalars['NaiveDateTime'];
};

export type UserPreferencesInput = {
  hideAlreadyListened?: Maybe<Scalars['Boolean']>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  bespoke: Scalars['Boolean'];
  billingPeriod: BillingPeriod;
  cancellationScheduledAt?: Maybe<Scalars['NaiveDateTime']>;
  coupons?: Maybe<Array<Coupon>>;
  /** The date and time when the subscription was created in Femtasy. */
  createdAt?: Maybe<Scalars['NaiveDateTime']>;
  expiresAt: Scalars['NaiveDateTime'];
  freeTrialEndsAt?: Maybe<Scalars['NaiveDateTime']>;
  freeTrialStartedAt?: Maybe<Scalars['NaiveDateTime']>;
  scheduledChanges?: Maybe<UserSubscriptionWithScheduledChanges>;
  subscriptionId: Scalars['String'];
};

export type UserSubscriptionWithScheduledChanges = {
  __typename?: 'UserSubscriptionWithScheduledChanges';
  billingPeriod: BillingPeriod;
  cancellationScheduledAt?: Maybe<Scalars['NaiveDateTime']>;
  expiresAt: Scalars['NaiveDateTime'];
  freeTrialEndsAt?: Maybe<Scalars['NaiveDateTime']>;
  freeTrialStartedAt?: Maybe<Scalars['NaiveDateTime']>;
};

export type Utm = {
  /** The b2b_special_plan used for testing. This is temporary. */
  b2bSpecialPlan?: Maybe<Scalars['String']>;
  /** The campaign used to determine which reward will apply to the referral/referee */
  campaign?: Maybe<Scalars['String']>;
  /** Identifies what was clicked to bring the user to the site. */
  content?: Maybe<Scalars['String']>;
  /** The cross_team_campaign used for testing. This is temporary. */
  crossTeamCampaign?: Maybe<Scalars['String']>;
  /** A custom UTM identifier. */
  id?: Maybe<Scalars['String']>;
  /** Identifies what type of link was used, such as email or pay-per-click advertising. */
  medium?: Maybe<Scalars['String']>;
  /** Identifies which site sent the traffic. */
  source?: Maybe<Scalars['String']>;
  /** Identifies search terms. */
  term?: Maybe<Scalars['String']>;
};

export enum VerificationStatus {
  Failure = 'FAILURE',
  NotStarted = 'NOT_STARTED',
  Rechecked = 'RECHECKED',
  Started = 'STARTED',
  Success = 'SUCCESS'
}

export type StoryAudioUrlFragment = (
  { __typename?: 'Story' }
  & Pick<Story, 'id' | 'transcodedAudioUrl' | 'title' | 'description' | 'orgasms'>
  & { contentType: (
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'name' | 'slug'>
  ), speaker: (
    { __typename?: 'Speaker' }
    & Pick<Speaker, 'name'>
  ) }
);

export type GetStoryAudioUrlQueryVariables = Exact<{
  storyId: Scalars['ID'];
}>;


export type GetStoryAudioUrlQuery = (
  { __typename?: 'RootQueryType' }
  & { story?: Maybe<(
    { __typename?: 'Story' }
    & StoryAudioUrlFragment
  )> }
);

export type StoryDetailsFragment = (
  { __typename?: 'Story' }
  & Pick<Story, 'alreadyListened' | 'description' | 'durationInMinutes' | 'femtasyRed' | 'freeTrial' | 'loved' | 'orgasms' | 'id' | 'numberOfListens' | 'recommendedOrder' | 'title' | 'transcodedSampleUrl' | 'transcodedAudioUrl' | 'actions'>
  & { genre: (
    { __typename?: 'Genre' }
    & Pick<Genre, 'id' | 'name'>
  ), languageIntensity: (
    { __typename?: 'LanguageIntensity' }
    & Pick<LanguageIntensity, 'id' | 'name' | 'slug'>
  ), seriesInfo?: Maybe<(
    { __typename?: 'SeriesInfo' }
    & Pick<SeriesInfo, 'title'>
    & { nextStory?: Maybe<(
      { __typename?: 'Story' }
      & Pick<Story, 'id'>
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & Pick<ThreeSixtyStory, 'id'>
    )>, previousStory?: Maybe<(
      { __typename?: 'Story' }
      & Pick<Story, 'id'>
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & Pick<ThreeSixtyStory, 'id'>
    )> }
  )>, speaker: (
    { __typename?: 'Speaker' }
    & Pick<Speaker, 'id' | 'loved' | 'name'>
    & { participantsType: (
      { __typename?: 'ParticipantsType' }
      & Pick<ParticipantsType, 'slug'>
    ) }
  ), tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )>, themeTag?: Maybe<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )>, contentType: (
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'slug' | 'name'>
  ), playlists: Array<(
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id' | 'name' | 'type'>
  )> }
);

export type GetStoryDetailsQueryVariables = Exact<{
  storyId: Scalars['ID'];
}>;


export type GetStoryDetailsQuery = (
  { __typename?: 'RootQueryType' }
  & { story?: Maybe<(
    { __typename?: 'Story' }
    & StoryDetailsFragment
  )> }
);

export type StoryForPlayerFragment = (
  { __typename?: 'Story' }
  & Pick<Story, 'description' | 'femtasyRed' | 'freeTrial' | 'id' | 'loved' | 'title' | 'transcodedAudioUrl'>
  & { playlists: Array<(
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id' | 'type'>
  )>, speaker: (
    { __typename?: 'Speaker' }
    & Pick<Speaker, 'id' | 'name' | 'loved'>
    & { participantsType: (
      { __typename?: 'ParticipantsType' }
      & Pick<ParticipantsType, 'slug'>
    ) }
  ), tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )>, themeTag?: Maybe<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )>, genre: (
    { __typename?: 'Genre' }
    & Pick<Genre, 'id' | 'name'>
  ), contentType: (
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'slug' | 'name'>
  ) }
);

export type GetStoryForPlayerQueryVariables = Exact<{
  storyId: Scalars['ID'];
}>;


export type GetStoryForPlayerQuery = (
  { __typename?: 'RootQueryType' }
  & { story?: Maybe<(
    { __typename?: 'Story' }
    & StoryForPlayerFragment
  )> }
);

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = (
  { __typename?: 'RootMutationType' }
  & { cancelSubscription: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { activeSubscription?: Maybe<(
      { __typename?: 'UserSubscription' }
      & Pick<UserSubscription, 'cancellationScheduledAt'>
    )> }
  ) }
);

export type ContentSeriesFragment = (
  { __typename?: 'Series' }
  & Pick<Series, 'id'>
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & { stories: Array<(
      { __typename?: 'Story' }
      & StoryTile_Story_Fragment
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & StoryTile_ThreeSixtyStory_Fragment
    )> }
  ) }
);

export type ActiveContentDropFragment = (
  { __typename?: 'ContentDrop' }
  & Pick<ContentDrop, 'id' | 'title' | 'description' | 'image' | 'backgroundColor' | 'textColor'>
  & { content?: Maybe<Array<(
    { __typename?: 'Series' }
    & ContentSeriesFragment
  ) | (
    { __typename?: 'Story' }
    & StoryTile_Story_Fragment
  )>> }
);

export type ActiveContentDropQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveContentDropQuery = (
  { __typename?: 'RootQueryType' }
  & { activeContentDrop?: Maybe<(
    { __typename?: 'ContentDrop' }
    & ActiveContentDropFragment
  )> }
);

export type FeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagsQuery = (
  { __typename?: 'RootQueryType' }
  & { featureFlags: Array<(
    { __typename?: 'FeatureFlag' }
    & Pick<FeatureFlag, 'featureName' | 'enabled'>
  )> }
);

export type GetAlreadyListenedStoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAlreadyListenedStoriesQuery = (
  { __typename?: 'RootQueryType' }
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & { stories: Array<(
      { __typename?: 'Story' }
      & Pick<Story, 'id'>
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & Pick<ThreeSixtyStory, 'id'>
    )> }
  ) }
);

export type DataForCancellationFlowQueryVariables = Exact<{ [key: string]: never; }>;


export type DataForCancellationFlowQuery = (
  { __typename?: 'RootQueryType' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'timeSpent'>
    & { favouriteSound?: Maybe<(
      { __typename?: 'Story' }
      & Pick<Story, 'title'>
    )>, favouriteStory?: Maybe<(
      { __typename?: 'Story' }
      & Pick<Story, 'title'>
    )>, activeSubscription?: Maybe<(
      { __typename?: 'UserSubscription' }
      & Pick<UserSubscription, 'expiresAt' | 'freeTrialEndsAt' | 'freeTrialStartedAt'>
      & { billingPeriod: (
        { __typename?: 'BillingPeriod' }
        & Pick<BillingPeriod, 'period' | 'unit' | 'price' | 'currencyCode'>
      ) }
    )> }
  ), redeemedOffers: Array<(
    { __typename?: 'RedeemedOffer' }
    & Pick<RedeemedOffer, 'offerType'>
  )>, likedAudios: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), numberOfAudiosListened: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), numberOfStoriesListened: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), numberOfSoundsListened: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), storiesOfSpeakersListened: (
    { __typename?: 'StoriesResponse' }
    & { stories: Array<(
      { __typename?: 'Story' }
      & Pick<Story, 'id'>
      & { speaker: (
        { __typename?: 'Speaker' }
        & Pick<Speaker, 'id'>
      ) }
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & Pick<ThreeSixtyStory, 'id'>
      & { speaker: (
        { __typename?: 'Speaker' }
        & Pick<Speaker, 'id'>
      ) }
    )> }
  ), storiesOfKinksListened: (
    { __typename?: 'StoriesResponse' }
    & { stories: Array<(
      { __typename?: 'Story' }
      & Pick<Story, 'id'>
      & { tags: Array<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'id'>
      )> }
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & Pick<ThreeSixtyStory, 'id'>
      & { tags: Array<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'id'>
      )> }
    )> }
  ), totalNumberOfAudios: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), totalNumberOfStories: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), totalNumberOfSounds: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), totalNumberOfSpeakers: (
    { __typename?: 'SpeakersResponse' }
    & Pick<SpeakersResponse, 'totalCount'>
  ), allKinks: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id'>
  )> }
);

export type FeatureTagFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'visualWithText' | 'visualWithoutText' | 'featured'>
);

export type FeaturedTagsQueryVariables = Exact<{
  order?: Maybe<TagOrder>;
  pagination?: Maybe<Pagination>;
}>;


export type FeaturedTagsQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & FeatureTagFragment
  )> }
);

export type JourneyDetailsFragment = (
  { __typename?: 'Journey' }
  & Pick<Journey, 'backgroundGradientBottom' | 'backgroundGradientTop' | 'description' | 'id' | 'illustration' | 'headerIllustration' | 'longTitle' | 'title'>
  & { languageIntensity: (
    { __typename?: 'LanguageIntensity' }
    & Pick<LanguageIntensity, 'id' | 'name' | 'slug'>
  ) }
);

type JourneyDetailStory_Story_Fragment = (
  { __typename?: 'Story' }
  & Pick<Story, 'alreadyListened' | 'description' | 'durationInMinutes' | 'id' | 'femtasyRed' | 'releaseDate' | 'title' | 'freeTrial' | 'actions'>
  & { speaker: (
    { __typename?: 'Speaker' }
    & Pick<Speaker, 'id' | 'name'>
    & { participantsType: (
      { __typename?: 'ParticipantsType' }
      & Pick<ParticipantsType, 'slug'>
    ) }
  ), tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
);

type JourneyDetailStory_ThreeSixtyStory_Fragment = (
  { __typename?: 'ThreeSixtyStory' }
  & Pick<ThreeSixtyStory, 'alreadyListened' | 'description' | 'durationInMinutes' | 'id' | 'femtasyRed' | 'releaseDate' | 'title' | 'freeTrial' | 'actions'>
  & { speaker: (
    { __typename?: 'Speaker' }
    & Pick<Speaker, 'id' | 'name'>
    & { participantsType: (
      { __typename?: 'ParticipantsType' }
      & Pick<ParticipantsType, 'slug'>
    ) }
  ), tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
);

export type JourneyDetailStoryFragment = JourneyDetailStory_Story_Fragment | JourneyDetailStory_ThreeSixtyStory_Fragment;

export type GetJourneyDetailsWithStoriesQueryVariables = Exact<{
  journeyId: Scalars['ID'];
}>;


export type GetJourneyDetailsWithStoriesQuery = (
  { __typename?: 'RootQueryType' }
  & { journeys: Array<(
    { __typename?: 'Journey' }
    & Pick<Journey, 'transcodedTeaserUrl'>
    & { stories: (
      { __typename?: 'StoriesResponse' }
      & Pick<StoriesResponse, 'totalCount'>
      & { stories: Array<(
        { __typename?: 'Story' }
        & JourneyDetailStory_Story_Fragment
      ) | (
        { __typename?: 'ThreeSixtyStory' }
        & JourneyDetailStory_ThreeSixtyStory_Fragment
      )> }
    ) }
    & JourneyDetailsFragment
  )> }
);

export type StoryDetailsForSearchFragment = (
  { __typename?: 'Story' }
  & Pick<Story, 'id' | 'loved' | 'alreadyListened'>
  & { playlists: Array<(
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id' | 'type'>
  )> }
);

export type GetPerUserStoryDetailsForSearchResultsQueryVariables = Exact<{
  perPage: Scalars['Int'];
  storyIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetPerUserStoryDetailsForSearchResultsQuery = (
  { __typename?: 'RootQueryType' }
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & { stories: Array<(
      { __typename?: 'Story' }
      & StoryDetailsForSearchFragment
    ) | { __typename?: 'ThreeSixtyStory' }> }
  ) }
);

export type GetPopularTagsAndSpeakersQueryVariables = Exact<{
  tagsIds: Array<Scalars['ID']> | Scalars['ID'];
  speakersIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetPopularTagsAndSpeakersQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name' | 'bubbleWithTitle' | 'bubbleWithTitleAndImage'>
  )>, speakers: (
    { __typename?: 'SpeakersResponse' }
    & { speakers: Array<(
      { __typename?: 'Speaker' }
      & Pick<Speaker, 'id' | 'name'>
      & { participantsType: (
        { __typename?: 'ParticipantsType' }
        & Pick<ParticipantsType, 'slug'>
      ) }
    )> }
  ) }
);

export type GetPostPurchaseAnswersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPostPurchaseAnswersQuery = (
  { __typename?: 'RootQueryType' }
  & { postPurchaseAnswers: Array<(
    { __typename?: 'PostPurchaseAnswer' }
    & Pick<PostPurchaseAnswer, 'id' | 'key' | 'localizedLabel' | 'options' | 'optionsTrackingIds' | 'sendSelectedOptionAsKey' | 'freeText' | 'freeTextPlaceholder'>
  )> }
);

export type GetQueueRecommendationsQueryVariables = Exact<{
  campaign: Scalars['String'];
  storyId: Scalars['ID'];
}>;


export type GetQueueRecommendationsQuery = (
  { __typename?: 'RootQueryType' }
  & { recommendedStories?: Maybe<(
    { __typename?: 'RecommendedStories' }
    & { recommendedStories: Array<(
      { __typename?: 'Story' }
      & Pick<Story, 'id' | 'title'>
      & { speaker: (
        { __typename?: 'Speaker' }
        & Pick<Speaker, 'name'>
      ) }
    )> }
  )> }
);

export type GetRedeemedOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedeemedOffersQuery = (
  { __typename?: 'RootQueryType' }
  & { redeemedOffers: Array<(
    { __typename?: 'RedeemedOffer' }
    & Pick<RedeemedOffer, 'offerType'>
  )> }
);

export type GetScenarioFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'bubbleWithTitle' | 'bubbleWithTitleAndImage'>
);

export type GetScenariosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScenariosQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & GetScenarioFragment
  )> }
);

export type GetSpeakerLovedQueryVariables = Exact<{
  speakerId: Scalars['ID'];
}>;


export type GetSpeakerLovedQuery = (
  { __typename?: 'RootQueryType' }
  & { speakers: (
    { __typename?: 'SpeakersResponse' }
    & { speakers: Array<(
      { __typename?: 'Speaker' }
      & Pick<Speaker, 'id' | 'loved'>
    )> }
  ) }
);

export type StoryLovedFragment = (
  { __typename?: 'Story' }
  & Pick<Story, 'id' | 'loved'>
  & { playlists: Array<(
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id' | 'type'>
  )> }
);

export type GetStoryLovedQueryVariables = Exact<{
  storyId: Scalars['ID'];
}>;


export type GetStoryLovedQuery = (
  { __typename?: 'RootQueryType' }
  & { story?: Maybe<(
    { __typename?: 'Story' }
    & StoryLovedFragment
  )> }
);

export type GetTagsFeaturedImagesFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'description' | 'visualWithText'>
);

export type GetTagsFeaturedImagesWithoutTextFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'description' | 'visualWithoutText'>
);

export type GetTagsFeaturedImagesQueryVariables = Exact<{
  tagsIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTagsFeaturedImagesQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & GetTagsFeaturedImagesFragment
  )> }
);

export type GetTagsFeaturedImagesWithoutTextQueryVariables = Exact<{
  tagsIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTagsFeaturedImagesWithoutTextQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & GetTagsFeaturedImagesWithoutTextFragment
  )> }
);

export type TagForScenarioFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'visualWithText'>
);

export type GetTagsForScenariosQueryVariables = Exact<{
  soloTagIds: Array<Scalars['ID']> | Scalars['ID'];
  couplesTagIds: Array<Scalars['ID']> | Scalars['ID'];
  threesomesTagIds: Array<Scalars['ID']> | Scalars['ID'];
  groupsTagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTagsForScenariosQuery = (
  { __typename?: 'RootQueryType' }
  & { solo: Array<(
    { __typename?: 'Tag' }
    & TagForScenarioFragment
  )>, couples: Array<(
    { __typename?: 'Tag' }
    & TagForScenarioFragment
  )>, threesomes: Array<(
    { __typename?: 'Tag' }
    & TagForScenarioFragment
  )>, groups: Array<(
    { __typename?: 'Tag' }
    & TagForScenarioFragment
  )> }
);

export type GetTagsKinkinessScoreQueryVariables = Exact<{
  tagsIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTagsKinkinessScoreQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'kinkinessScore'>
  )> }
);

export type GetTagsNamesQueryVariables = Exact<{
  tagsIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetTagsNamesQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
);

export type GetVoicesStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVoicesStatisticsQuery = (
  { __typename?: 'RootQueryType' }
  & { femaleAudios: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), femaleVoices: (
    { __typename?: 'SpeakersResponse' }
    & Pick<SpeakersResponse, 'totalCount'>
  ), maleAudios: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), maleVoices: (
    { __typename?: 'SpeakersResponse' }
    & Pick<SpeakersResponse, 'totalCount'>
  ), nonBinaryAudios: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ), nonBinaryVoices: (
    { __typename?: 'SpeakersResponse' }
    & Pick<SpeakersResponse, 'totalCount'>
  ), loversVoices: (
    { __typename?: 'SpeakersResponse' }
    & Pick<SpeakersResponse, 'totalCount'>
  ), loversAudios: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ) }
);

export type IncreaseNumberOfListensMutationVariables = Exact<{
  storyId: Scalars['ID'];
}>;


export type IncreaseNumberOfListensMutation = (
  { __typename?: 'RootMutationType' }
  & { increaseNumberOfListens?: Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'id'>
  )> }
);

export type JourneyFragment = (
  { __typename?: 'Journey' }
  & Pick<Journey, 'id' | 'description' | 'title' | 'longTitle' | 'illustration' | 'headerIllustration'>
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
    & { stories: Array<(
      { __typename?: 'Story' }
      & JourneyDetailStory_Story_Fragment
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & JourneyDetailStory_ThreeSixtyStory_Fragment
    )> }
  ) }
);

export type JourneysQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneysQuery = (
  { __typename?: 'RootQueryType' }
  & { journeys: Array<(
    { __typename?: 'Journey' }
    & JourneyFragment
  )> }
);

export type KinkTagFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'visualWithText' | 'visualWithoutText' | 'mostRecentAddedAt' | 'kinkinessScore' | 'featured'>
);

export type KinksPageQueryVariables = Exact<{
  tagOfTheMonthId: Scalars['ID'];
}>;


export type KinksPageQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & KinkTagFragment
  )>, tagOfTheMonth?: Maybe<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'description'>
    & KinkTagFragment
  )> }
);

export type KlaviyoFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type KlaviyoFormsQuery = (
  { __typename?: 'RootQueryType' }
  & { klaviyoForms: Array<(
    { __typename?: 'KlaviyoForm' }
    & Pick<KlaviyoForm, 'id' | 'formId' | 'displayUrl' | 'includeUrls' | 'excludeUrls' | 'showAfter' | 'showOnlyOnce'>
  )> }
);

export type MarkStoryAsListenedMutationVariables = Exact<{
  storyId: Scalars['ID'];
  timeStopped: Scalars['Int'];
}>;


export type MarkStoryAsListenedMutation = (
  { __typename?: 'RootMutationType' }
  & { markStoryAsListened?: Maybe<(
    { __typename: 'Story' }
    & Pick<Story, 'id' | 'alreadyListened'>
  )> }
);

export type GetMasturbationTechniquesWithStoriesQueryVariables = Exact<{
  masturbationTechniquesFilters?: Maybe<MasturbationTechniquesFilters>;
}>;


export type GetMasturbationTechniquesWithStoriesQuery = (
  { __typename?: 'RootQueryType' }
  & { masturbationTechniques: Array<(
    { __typename?: 'MasturbationTechnique' }
    & Pick<MasturbationTechnique, 'id' | 'title' | 'tileIllustration' | 'headerIllustration' | 'description'>
    & { stories: (
      { __typename?: 'StoriesResponse' }
      & { stories: Array<(
        { __typename?: 'Story' }
        & StoryTile_Story_Fragment
      ) | (
        { __typename?: 'ThreeSixtyStory' }
        & StoryTile_ThreeSixtyStory_Fragment
      )> }
    ) }
  )> }
);

export type MasturbationTechniqueForSlideFragment = (
  { __typename?: 'MasturbationTechnique' }
  & Pick<MasturbationTechnique, 'id' | 'description' | 'title' | 'tileIllustration'>
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & { stories: Array<(
      { __typename?: 'Story' }
      & { speaker: (
        { __typename?: 'Speaker' }
        & SpeakerForStoryTileFragment
      ) }
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & { speaker: (
        { __typename?: 'Speaker' }
        & SpeakerForStoryTileFragment
      ) }
    )> }
  ) }
);

export type GetMasturbationTechniquesQueryVariables = Exact<{
  masturbationTechniquesOrder?: Maybe<MasturbationTechniquesOrder>;
}>;


export type GetMasturbationTechniquesQuery = (
  { __typename?: 'RootQueryType' }
  & { masturbationTechniques: Array<(
    { __typename?: 'MasturbationTechnique' }
    & MasturbationTechniqueForSlideFragment
  )> }
);

export type ActiveSubscriptionFragment = (
  { __typename?: 'UserSubscription' }
  & Pick<UserSubscription, 'bespoke' | 'cancellationScheduledAt' | 'expiresAt' | 'freeTrialEndsAt' | 'freeTrialStartedAt' | 'subscriptionId' | 'createdAt'>
  & { billingPeriod: (
    { __typename?: 'BillingPeriod' }
    & Pick<BillingPeriod, 'unit'>
  ) }
);

export type UserProfileFragment = (
  { __typename?: 'User' }
  & Pick<User, 'email' | 'emailConfirmed' | 'id' | 'isFirstSession' | 'maxedOutTrials' | 'modeKinkiness' | 'pinSet' | 'primaryMarket' | 'signUpDate' | 'storyMarkets' | 'subscriptionExpiresAt' | 'trackingId' | 'verificationStatus'>
  & { activeSubscription?: Maybe<(
    { __typename?: 'UserSubscription' }
    & ActiveSubscriptionFragment
  )>, onboardingResponses: Array<Maybe<(
    { __typename?: 'UserOnboardingResponses' }
    & Pick<UserOnboardingResponses, 'id' | 'version'>
    & { responses: (
      { __typename?: 'OnboardingV1Response' }
      & Pick<OnboardingV1Response, 'contentTypes' | 'languageIntensity' | 'reasons' | 'tagIds' | 'scenarios'>
    ) }
  )>>, topContentType?: Maybe<(
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'id' | 'name' | 'slug'>
  )> }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'RootQueryType' }
  & { me: (
    { __typename?: 'User' }
    & UserProfileFragment
  ), userPreferences?: Maybe<(
    { __typename?: 'UserPreferences' }
    & Pick<UserPreferences, 'hideAlreadyListened'>
  )> }
);

export type TagSummaryFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'description' | 'visualWithoutText'>
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ) }
);

export type MoodsQueryVariables = Exact<{ [key: string]: never; }>;


export type MoodsQuery = (
  { __typename?: 'RootQueryType' }
  & { moods: Array<(
    { __typename?: 'Tag' }
    & TagSummaryFragment
  )> }
);

export type FavouriteKinksQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
}>;


export type FavouriteKinksQuery = (
  { __typename?: 'RootQueryType' }
  & { favouriteKinks: Array<(
    { __typename?: 'Tag' }
    & FeatureTagFragment
  )> }
);

export type OnboardingTagFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'bubbleWithTitle' | 'bubbleWithTitleAndImage' | 'onboardingPosition'>
);

export type OnboardingTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingTagsQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & OnboardingTagFragment
  )> }
);

export type OnboardingVanillaTagsQueryVariables = Exact<{
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type OnboardingVanillaTagsQuery = (
  { __typename?: 'RootQueryType' }
  & { tags: Array<(
    { __typename?: 'Tag' }
    & OnboardingTagFragment
  )> }
);

export type PlaylistImageFragment = (
  { __typename?: 'PlaylistImage' }
  & Pick<PlaylistImage, 'id' | 'image'>
);

export type PlaylistDetailsFragment = (
  { __typename?: 'Playlist' }
  & Pick<Playlist, 'id' | 'name' | 'type' | 'publicAccess' | 'showOnExplorePage' | 'showAsCuration'>
  & { image?: Maybe<(
    { __typename?: 'PlaylistImage' }
    & PlaylistImageFragment
  )>, stories: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
    & { stories: Array<(
      { __typename?: 'Story' }
      & StoryTile_Story_Fragment
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & StoryTile_ThreeSixtyStory_Fragment
    )> }
  ) }
);

export type PlaylistWithStoriesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PlaylistWithStoriesQuery = (
  { __typename?: 'RootQueryType' }
  & { playlists: Array<(
    { __typename?: 'Playlist' }
    & PlaylistDetailsFragment
  )> }
);

export type PlaylistForListFragment = (
  { __typename?: 'Playlist' }
  & Pick<Playlist, 'id' | 'name' | 'type' | 'publicAccess' | 'showOnExplorePage' | 'showAsCuration'>
  & { image?: Maybe<(
    { __typename?: 'PlaylistImage' }
    & PlaylistImageFragment
  )>, stories: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
    & { stories: Array<(
      { __typename?: 'Story' }
      & Pick<Story, 'releaseDate'>
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & Pick<ThreeSixtyStory, 'releaseDate'>
    )> }
  ) }
);

export type GetPlaylistsQueryVariables = Exact<{
  filters: PlaylistFilters;
}>;


export type GetPlaylistsQuery = (
  { __typename?: 'RootQueryType' }
  & { playlists: Array<(
    { __typename?: 'Playlist' }
    & PlaylistForListFragment
  )> }
);

export type UserPlaylistsQueryVariables = Exact<{
  types: Array<PlaylistTypeEnum> | PlaylistTypeEnum;
}>;


export type UserPlaylistsQuery = (
  { __typename?: 'RootQueryType' }
  & { playlists: Array<(
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'createdAt'>
    & PlaylistForListFragment
  )> }
);

export type UserPlaylistsOnlyIdQueryVariables = Exact<{
  types: Array<PlaylistTypeEnum> | PlaylistTypeEnum;
}>;


export type UserPlaylistsOnlyIdQuery = (
  { __typename?: 'RootQueryType' }
  & { playlists: Array<(
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id'>
  )> }
);

export type CreatePlaylistMutationVariables = Exact<{
  input: CreatePlaylistInput;
}>;


export type CreatePlaylistMutation = (
  { __typename?: 'RootMutationType' }
  & { createPlaylist: (
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id' | 'name' | 'type'>
    & { stories: (
      { __typename?: 'StoriesResponse' }
      & { stories: Array<(
        { __typename?: 'Story' }
        & Pick<Story, 'id'>
        & { playlists: Array<(
          { __typename?: 'Playlist' }
          & Pick<Playlist, 'id'>
        )> }
      ) | (
        { __typename?: 'ThreeSixtyStory' }
        & Pick<ThreeSixtyStory, 'id'>
        & { playlists: Array<(
          { __typename?: 'Playlist' }
          & Pick<Playlist, 'id'>
        )> }
      )> }
    ) }
  ) }
);

export type UpdatePlaylistMutationVariables = Exact<{
  input: UpdatePlaylistInput;
}>;


export type UpdatePlaylistMutation = (
  { __typename?: 'RootMutationType' }
  & { updatePlaylist: (
    { __typename?: 'Playlist' }
    & PlaylistDetailsFragment
  ) }
);

export type PlaylistImagesQueryVariables = Exact<{
  showInCreationDialog?: Maybe<Scalars['Boolean']>;
}>;


export type PlaylistImagesQuery = (
  { __typename?: 'RootQueryType' }
  & { playlistImages: Array<(
    { __typename?: 'PlaylistImage' }
    & Pick<PlaylistImage, 'id' | 'image'>
  )> }
);

export type DeletePLaylistMutationVariables = Exact<{
  input: DeletePlaylistInput;
}>;


export type DeletePLaylistMutation = (
  { __typename?: 'RootMutationType' }
  & { deletePlaylist: (
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id'>
  ) }
);

export type AddStoryToPlaylistMutationVariables = Exact<{
  input: AddStoryToPlaylistInput;
}>;


export type AddStoryToPlaylistMutation = (
  { __typename?: 'RootMutationType' }
  & { addStoryToPlaylist: (
    { __typename?: 'Playlist' }
    & PlaylistDetailsFragment
  ) }
);

export type RemoveStoryFromPlaylistMutationVariables = Exact<{
  input: RemoveStoryFromPlaylistInput;
}>;


export type RemoveStoryFromPlaylistMutation = (
  { __typename?: 'RootMutationType' }
  & { removeStoryFromPlaylist: (
    { __typename?: 'Playlist' }
    & PlaylistDetailsFragment
  ) }
);

export type SavePlaylistToMyPlaylistsMutationVariables = Exact<{
  input: SavePlaylistToMyPlaylistsInput;
}>;


export type SavePlaylistToMyPlaylistsMutation = (
  { __typename?: 'RootMutationType' }
  & { savePlaylistToMyPlaylists: (
    { __typename?: 'Playlist' }
    & PlaylistDetailsFragment
  ) }
);

export type CreatePortalSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreatePortalSessionMutation = (
  { __typename?: 'RootMutationType' }
  & { createPortalSession: (
    { __typename?: 'PortalSession' }
    & Pick<PortalSession, 'response'>
  ) }
);

export type ReactivateSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type ReactivateSubscriptionMutation = (
  { __typename?: 'RootMutationType' }
  & { reactivateSubscription?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { activeSubscription?: Maybe<(
      { __typename?: 'UserSubscription' }
      & Pick<UserSubscription, 'cancellationScheduledAt'>
    )> }
  )> }
);

export type RecentSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentSearchesQuery = (
  { __typename?: 'RootQueryType' }
  & { recentSearches: Array<(
    { __typename: 'ContentType' }
    & Pick<ContentType, 'id' | 'slug'>
  ) | (
    { __typename: 'Genre' }
    & Pick<Genre, 'id'>
  ) | (
    { __typename: 'LanguageIntensity' }
    & Pick<LanguageIntensity, 'id' | 'slug'>
  ) | (
    { __typename: 'Speaker' }
    & Pick<Speaker, 'name' | 'id'>
  ) | (
    { __typename: 'Tag' }
    & Pick<Tag, 'name' | 'id'>
  )> }
);

export type SaveRecentSearchMutationVariables = Exact<{
  id: Scalars['String'];
  type: SearchResultType;
}>;


export type SaveRecentSearchMutation = (
  { __typename?: 'RootMutationType' }
  & Pick<RootMutationType, 'saveRecentSearch'>
);

type RecommendedStory_Story_Fragment = (
  { __typename?: 'Story' }
  & Pick<Story, 'transcodedSampleUrl' | 'relevanceScore'>
  & { tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
  & StoryTile_Story_Fragment
);

type RecommendedStory_ThreeSixtyStory_Fragment = (
  { __typename?: 'ThreeSixtyStory' }
  & Pick<ThreeSixtyStory, 'transcodedSampleUrl' | 'relevanceScore'>
  & { tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
  & StoryTile_ThreeSixtyStory_Fragment
);

export type RecommendedStoryFragment = RecommendedStory_Story_Fragment | RecommendedStory_ThreeSixtyStory_Fragment;

export type RecommendedStoriesQueryVariables = Exact<{
  campaign: Scalars['String'];
  numberResults?: Maybe<Scalars['Int']>;
  distinctBySpeaker?: Maybe<Scalars['Boolean']>;
  storyId?: Maybe<Scalars['ID']>;
  genreIds?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  speakerIds?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  tagIds?: Maybe<Array<Maybe<Scalars['ID']>> | Maybe<Scalars['ID']>>;
  limitByKinkinessScore?: Maybe<Scalars['Boolean']>;
}>;


export type RecommendedStoriesQuery = (
  { __typename?: 'RootQueryType' }
  & { recommendedStories?: Maybe<(
    { __typename?: 'RecommendedStories' }
    & { recommendedStories: Array<(
      { __typename?: 'Story' }
      & RecommendedStory_Story_Fragment
    )> }
  )> }
);

export type RedeemOfferMutationVariables = Exact<{
  redeemOfferInput: RedeemOfferInput;
}>;


export type RedeemOfferMutation = (
  { __typename?: 'RootMutationType' }
  & { redeemOffer?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { activeSubscription?: Maybe<(
      { __typename?: 'UserSubscription' }
      & Pick<UserSubscription, 'freeTrialEndsAt'>
    )> }
  )> }
);

export type SavePostPurchaseSurveyAnswerMutationVariables = Exact<{
  answer?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  planName: Scalars['String'];
  position: Scalars['Int'];
  subscriptionId?: Maybe<Scalars['String']>;
}>;


export type SavePostPurchaseSurveyAnswerMutation = (
  { __typename?: 'RootMutationType' }
  & Pick<RootMutationType, 'savePostPurchaseSurveyAnswer'>
);

export type SegmentMutationVariables = Exact<{
  input: SegmentInput;
}>;


export type SegmentMutation = (
  { __typename?: 'RootMutationType' }
  & Pick<RootMutationType, 'segmentTrack'>
);

export type SetStoryMarketsMutationVariables = Exact<{
  storyMarkets: Array<Market> | Market;
}>;


export type SetStoryMarketsMutation = (
  { __typename?: 'RootMutationType' }
  & { setStoryMarkets: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'storyMarkets'>
  ) }
);

export type SpeakerSummaryFragment = (
  { __typename: 'Speaker' }
  & Pick<Speaker, 'id' | 'name' | 'gender' | 'loved' | 'transcodedSampleUrl'>
  & { participantsType: (
    { __typename?: 'ParticipantsType' }
    & Pick<ParticipantsType, 'slug'>
  ), accent?: Maybe<(
    { __typename?: 'Accent' }
    & Pick<Accent, 'name'>
  )>, stories: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
  ) }
);

export type SpeakersQueryVariables = Exact<{
  speakerFilters?: Maybe<SpeakerFilters>;
  orderOptions?: Maybe<Array<Maybe<SpeakerOrder>> | Maybe<SpeakerOrder>>;
  pagination?: Maybe<Pagination>;
}>;


export type SpeakersQuery = (
  { __typename?: 'RootQueryType' }
  & { speakers: (
    { __typename?: 'SpeakersResponse' }
    & { speakers: Array<(
      { __typename?: 'Speaker' }
      & SpeakerSummaryFragment
    )> }
  ) }
);

export type StoreOnboardingResponsesMutationVariables = Exact<{
  serializedResponses: Scalars['String'];
}>;


export type StoreOnboardingResponsesMutation = (
  { __typename?: 'RootMutationType' }
  & Pick<RootMutationType, 'storeOnboardingResponses'>
);

export type SpeakerForStoryTileFragment = (
  { __typename?: 'Speaker' }
  & Pick<Speaker, 'id' | 'name'>
  & { participantsType: (
    { __typename?: 'ParticipantsType' }
    & Pick<ParticipantsType, 'slug'>
  ) }
);

type CommonStoryTileFields_Story_Fragment = (
  { __typename?: 'Story' }
  & Pick<Story, 'id' | 'title' | 'description' | 'loved' | 'femtasyRed' | 'durationInMinutes' | 'releaseDate' | 'alreadyListened'>
  & { contentType: (
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'slug'>
  ), playlists: Array<(
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id' | 'type'>
  )>, languageIntensity: (
    { __typename?: 'LanguageIntensity' }
    & Pick<LanguageIntensity, 'id' | 'slug'>
  ), speaker: (
    { __typename?: 'Speaker' }
    & SpeakerForStoryTileFragment
  ), themeTag?: Maybe<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )>, tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
);

type CommonStoryTileFields_ThreeSixtyStory_Fragment = (
  { __typename?: 'ThreeSixtyStory' }
  & Pick<ThreeSixtyStory, 'id' | 'title' | 'description' | 'loved' | 'femtasyRed' | 'durationInMinutes' | 'releaseDate' | 'alreadyListened'>
  & { contentType: (
    { __typename?: 'ContentType' }
    & Pick<ContentType, 'slug'>
  ), playlists: Array<(
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id' | 'type'>
  )>, languageIntensity: (
    { __typename?: 'LanguageIntensity' }
    & Pick<LanguageIntensity, 'id' | 'slug'>
  ), speaker: (
    { __typename?: 'Speaker' }
    & SpeakerForStoryTileFragment
  ), themeTag?: Maybe<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )>, tags: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
);

export type CommonStoryTileFieldsFragment = CommonStoryTileFields_Story_Fragment | CommonStoryTileFields_ThreeSixtyStory_Fragment;

type StoryTile_Story_Fragment = (
  { __typename?: 'Story' }
  & CommonStoryTileFields_Story_Fragment
);

type StoryTile_ThreeSixtyStory_Fragment = (
  { __typename?: 'ThreeSixtyStory' }
  & CommonStoryTileFields_ThreeSixtyStory_Fragment
);

export type StoryTileFragment = StoryTile_Story_Fragment | StoryTile_ThreeSixtyStory_Fragment;

export type StoriesForTileWithStoriesTotalCountQueryVariables = Exact<{
  pagination?: Maybe<Pagination>;
  order?: Maybe<StoryOrder>;
  filterSelection?: Maybe<FilterSelection>;
}>;


export type StoriesForTileWithStoriesTotalCountQuery = (
  { __typename?: 'RootQueryType' }
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
    & { stories: Array<(
      { __typename?: 'Story' }
      & StoryTile_Story_Fragment
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & StoryTile_ThreeSixtyStory_Fragment
    )> }
  ) }
);

export type StoriesForTileQueryVariables = Exact<{
  pagination?: Maybe<Pagination>;
  order?: Maybe<StoryOrder>;
  filterSelection?: Maybe<FilterSelection>;
}>;


export type StoriesForTileQuery = (
  { __typename?: 'RootQueryType' }
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & { stories: Array<(
      { __typename?: 'Story' }
      & StoryTile_Story_Fragment
    ) | (
      { __typename?: 'ThreeSixtyStory' }
      & StoryTile_ThreeSixtyStory_Fragment
    )> }
  ) }
);

export type ThreeSixtyStoryForTileFragment = (
  { __typename?: 'ThreeSixtyStory' }
  & CommonStoryTileFields_ThreeSixtyStory_Fragment
);

export type ThreeSixtyStoriesQueryVariables = Exact<{
  excludeAlreadyListened?: Maybe<Scalars['Boolean']>;
  order?: Maybe<StoryOrder>;
}>;


export type ThreeSixtyStoriesQuery = (
  { __typename?: 'RootQueryType' }
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & { stories: Array<{ __typename?: 'Story' } | (
      { __typename?: 'ThreeSixtyStory' }
      & ThreeSixtyStoryForTileFragment
    )> }
  ) }
);

export type ThreeSixtyStoriesWithPaginationQueryVariables = Exact<{
  excludeAlreadyListened?: Maybe<Scalars['Boolean']>;
  pagination?: Maybe<Pagination>;
  order?: Maybe<StoryOrder>;
}>;


export type ThreeSixtyStoriesWithPaginationQuery = (
  { __typename?: 'RootQueryType' }
  & { stories: (
    { __typename?: 'StoriesResponse' }
    & Pick<StoriesResponse, 'totalCount'>
    & { stories: Array<{ __typename?: 'Story' } | (
      { __typename?: 'ThreeSixtyStory' }
      & ThreeSixtyStoryForTileFragment
    )> }
  ) }
);

export type SubmittedPostPurchaseSurveyQueryVariables = Exact<{ [key: string]: never; }>;


export type SubmittedPostPurchaseSurveyQuery = (
  { __typename?: 'RootQueryType' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'submittedPostPurchaseSurvey'>
  ) }
);

export type SubscribeToNewsletterMutationVariables = Exact<{
  email: Scalars['String'];
  campaign: NewsletterList;
}>;


export type SubscribeToNewsletterMutation = (
  { __typename?: 'RootMutationType' }
  & Pick<RootMutationType, 'subscribeToNewsletter'>
);

export type TagForDetailsPageFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'name' | 'description' | 'headerImage' | 'isUserPlaylist'>
  & { playlist: (
    { __typename?: 'Playlist' }
    & Pick<Playlist, 'id'>
  ) }
);

export type TagForDetailsPageQueryVariables = Exact<{
  tagId: Scalars['ID'];
}>;


export type TagForDetailsPageQuery = (
  { __typename?: 'RootQueryType' }
  & { tag?: Maybe<(
    { __typename?: 'Tag' }
    & TagForDetailsPageFragment
  )> }
);

export type ToggleLoveSpeakerMutationVariables = Exact<{
  speakerId: Scalars['ID'];
}>;


export type ToggleLoveSpeakerMutation = (
  { __typename?: 'RootMutationType' }
  & { toggleLoveSpeaker?: Maybe<(
    { __typename: 'Speaker' }
    & Pick<Speaker, 'id' | 'loved'>
  )> }
);

export type ToggleLoveStoryMutationVariables = Exact<{
  storyId: Scalars['ID'];
}>;


export type ToggleLoveStoryMutation = (
  { __typename?: 'RootMutationType' }
  & { toggleLoveStory?: Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'id' | 'loved'>
  )> }
);

export type UpdateTimeStoppedMutationVariables = Exact<{
  storyId: Scalars['ID'];
  timeStopped: Scalars['Int'];
}>;


export type UpdateTimeStoppedMutation = (
  { __typename?: 'RootMutationType' }
  & { updateTimeStopped?: Maybe<(
    { __typename?: 'Story' }
    & Pick<Story, 'id'>
  )> }
);

export type UserNotificationFragment = (
  { __typename?: 'UserNotification' }
  & Pick<UserNotification, 'id' | 'notificationType' | 'lastShownAt' | 'count'>
);

export type UserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationsQuery = (
  { __typename?: 'RootQueryType' }
  & { userNotifications: Array<(
    { __typename?: 'UserNotification' }
    & UserNotificationFragment
  )> }
);

export type SetNotificationShownMutationVariables = Exact<{
  notificationType: NotificationType;
}>;


export type SetNotificationShownMutation = (
  { __typename?: 'RootMutationType' }
  & { setNotificationShown?: Maybe<(
    { __typename?: 'UserNotification' }
    & UserNotificationFragment
  )> }
);

export type SetUserPreferencesMutationVariables = Exact<{
  userPreferences: UserPreferencesInput;
}>;


export type SetUserPreferencesMutation = (
  { __typename?: 'RootMutationType' }
  & { setUserPreferences?: Maybe<(
    { __typename?: 'UserPreferences' }
    & Pick<UserPreferences, 'hideAlreadyListened'>
  )> }
);

export type UserSubscriptionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSubscriptionInfoQuery = (
  { __typename?: 'RootQueryType' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { activeSubscription?: Maybe<(
      { __typename?: 'UserSubscription' }
      & { billingPeriod: (
        { __typename?: 'BillingPeriod' }
        & Pick<BillingPeriod, 'period' | 'unit'>
      ), scheduledChanges?: Maybe<(
        { __typename?: 'UserSubscriptionWithScheduledChanges' }
        & { billingPeriod: (
          { __typename?: 'BillingPeriod' }
          & Pick<BillingPeriod, 'period' | 'unit'>
        ) }
      )>, coupons?: Maybe<Array<(
        { __typename?: 'Coupon' }
        & Pick<Coupon, 'id' | 'discountPercentage' | 'discountAmount' | 'currencyCode' | 'discountType' | 'durationType'>
      )>> }
      & ActiveSubscriptionFragment
    )> }
  ) }
);

export const StoryAudioUrlFragmentDoc = gql`
    fragment StoryAudioUrl on Story {
  id
  transcodedAudioUrl
  title
  description
  orgasms
  contentType {
    name
    slug
  }
  speaker {
    name
  }
}
    `;
export const StoryDetailsFragmentDoc = gql`
    fragment StoryDetails on Story {
  alreadyListened
  description
  durationInMinutes
  femtasyRed
  freeTrial
  loved
  orgasms
  genre {
    id
    name
  }
  id
  languageIntensity {
    id
    name
    slug
  }
  numberOfListens
  recommendedOrder
  seriesInfo {
    nextStory {
      id
    }
    previousStory {
      id
    }
    title
  }
  speaker {
    id
    loved
    name
    participantsType {
      slug
    }
  }
  tags {
    id
    name
  }
  themeTag {
    id
    name
  }
  title
  transcodedSampleUrl
  transcodedAudioUrl
  contentType {
    slug
    name
  }
  actions
  playlists {
    id
    name
    type
  }
}
    `;
export const StoryForPlayerFragmentDoc = gql`
    fragment StoryForPlayer on Story {
  description
  femtasyRed
  freeTrial
  id
  loved
  playlists {
    id
    type
  }
  speaker {
    id
    name
    loved
    participantsType {
      slug
    }
  }
  title
  transcodedAudioUrl
  tags {
    id
    name
  }
  themeTag {
    id
    name
  }
  genre {
    id
    name
  }
  speaker {
    id
    loved
    name
    participantsType {
      slug
    }
  }
  contentType {
    slug
    name
  }
}
    `;
export const SpeakerForStoryTileFragmentDoc = gql`
    fragment SpeakerForStoryTile on Speaker {
  id
  name
  participantsType {
    slug
  }
}
    `;
export const CommonStoryTileFieldsFragmentDoc = gql`
    fragment CommonStoryTileFields on StoryInterface {
  id
  title
  description
  contentType {
    slug
  }
  loved
  playlists {
    id
    type
  }
  femtasyRed
  durationInMinutes
  releaseDate
  alreadyListened
  languageIntensity {
    id
    slug
  }
  speaker {
    ...SpeakerForStoryTile
  }
  themeTag {
    id
    name
  }
  tags {
    id
    name
  }
}
    ${SpeakerForStoryTileFragmentDoc}`;
export const StoryTileFragmentDoc = gql`
    fragment StoryTile on StoryInterface {
  ...CommonStoryTileFields
}
    ${CommonStoryTileFieldsFragmentDoc}`;
export const ContentSeriesFragmentDoc = gql`
    fragment ContentSeries on Series {
  id
  stories {
    stories {
      ...StoryTile
    }
  }
}
    ${StoryTileFragmentDoc}`;
export const ActiveContentDropFragmentDoc = gql`
    fragment ActiveContentDrop on ContentDrop {
  id
  title
  description
  image
  backgroundColor
  textColor
  content {
    ...StoryTile
    ...ContentSeries
  }
}
    ${StoryTileFragmentDoc}
${ContentSeriesFragmentDoc}`;
export const FeatureTagFragmentDoc = gql`
    fragment FeatureTag on Tag {
  id
  name
  visualWithText
  visualWithoutText
  featured
}
    `;
export const JourneyDetailsFragmentDoc = gql`
    fragment JourneyDetails on Journey {
  backgroundGradientBottom
  backgroundGradientTop
  description
  id
  illustration
  headerIllustration
  languageIntensity {
    id
    name
    slug
  }
  longTitle
  title
}
    `;
export const StoryDetailsForSearchFragmentDoc = gql`
    fragment StoryDetailsForSearch on Story {
  id
  loved
  alreadyListened
  playlists {
    id
    type
  }
}
    `;
export const GetScenarioFragmentDoc = gql`
    fragment GetScenario on Tag {
  id
  name
  bubbleWithTitle
  bubbleWithTitleAndImage
}
    `;
export const StoryLovedFragmentDoc = gql`
    fragment StoryLoved on Story {
  id
  loved
  playlists {
    id
    type
  }
}
    `;
export const GetTagsFeaturedImagesFragmentDoc = gql`
    fragment GetTagsFeaturedImages on Tag {
  id
  name
  description
  visualWithText
}
    `;
export const GetTagsFeaturedImagesWithoutTextFragmentDoc = gql`
    fragment GetTagsFeaturedImagesWithoutText on Tag {
  id
  name
  description
  visualWithoutText
}
    `;
export const TagForScenarioFragmentDoc = gql`
    fragment TagForScenario on Tag {
  id
  name
  visualWithText
}
    `;
export const JourneyDetailStoryFragmentDoc = gql`
    fragment JourneyDetailStory on StoryInterface {
  alreadyListened
  description
  durationInMinutes
  id
  femtasyRed
  releaseDate
  speaker {
    id
    name
    participantsType {
      slug
    }
  }
  tags {
    id
    name
  }
  title
  freeTrial
  actions
}
    `;
export const JourneyFragmentDoc = gql`
    fragment Journey on Journey {
  id
  description
  title
  longTitle
  illustration
  headerIllustration
  stories(order: {order: ASC, orderBy: CREATED_AT}) {
    totalCount
    stories {
      ...JourneyDetailStory
    }
  }
}
    ${JourneyDetailStoryFragmentDoc}`;
export const KinkTagFragmentDoc = gql`
    fragment KinkTag on Tag {
  id
  name
  visualWithText
  visualWithoutText
  mostRecentAddedAt
  kinkinessScore
  featured
}
    `;
export const MasturbationTechniqueForSlideFragmentDoc = gql`
    fragment MasturbationTechniqueForSlide on MasturbationTechnique {
  id
  description
  title
  tileIllustration
  stories {
    stories {
      speaker {
        ...SpeakerForStoryTile
      }
    }
  }
}
    ${SpeakerForStoryTileFragmentDoc}`;
export const ActiveSubscriptionFragmentDoc = gql`
    fragment ActiveSubscription on UserSubscription {
  bespoke
  billingPeriod {
    unit
  }
  cancellationScheduledAt
  expiresAt
  freeTrialEndsAt
  freeTrialStartedAt
  subscriptionId
  createdAt
}
    `;
export const UserProfileFragmentDoc = gql`
    fragment UserProfile on User {
  activeSubscription {
    ...ActiveSubscription
  }
  email
  emailConfirmed
  id
  isFirstSession
  isFirstSession
  maxedOutTrials
  maxedOutTrials
  modeKinkiness
  onboardingResponses {
    id
    responses {
      contentTypes
      languageIntensity
      reasons
      tagIds
      scenarios
    }
    version
  }
  pinSet
  primaryMarket
  signUpDate
  storyMarkets
  subscriptionExpiresAt
  trackingId
  topContentType {
    id
    name
    slug
  }
  verificationStatus
}
    ${ActiveSubscriptionFragmentDoc}`;
export const TagSummaryFragmentDoc = gql`
    fragment TagSummary on Tag {
  id
  name
  description
  visualWithoutText
  stories {
    totalCount
  }
}
    `;
export const OnboardingTagFragmentDoc = gql`
    fragment OnboardingTag on Tag {
  id
  name
  bubbleWithTitle
  bubbleWithTitleAndImage
  onboardingPosition
}
    `;
export const PlaylistImageFragmentDoc = gql`
    fragment PlaylistImage on PlaylistImage {
  id
  image
}
    `;
export const PlaylistDetailsFragmentDoc = gql`
    fragment PlaylistDetails on Playlist {
  id
  name
  type
  publicAccess
  showOnExplorePage
  showAsCuration
  image {
    ...PlaylistImage
  }
  stories(pagination: {page: 0, perPage: 1000}) {
    stories {
      ...StoryTile
    }
    totalCount
  }
}
    ${PlaylistImageFragmentDoc}
${StoryTileFragmentDoc}`;
export const PlaylistForListFragmentDoc = gql`
    fragment PlaylistForList on Playlist {
  id
  name
  type
  publicAccess
  showOnExplorePage
  showAsCuration
  image {
    ...PlaylistImage
  }
  stories(order: {order: DESC}) {
    totalCount
    stories {
      releaseDate
    }
  }
}
    ${PlaylistImageFragmentDoc}`;
export const RecommendedStoryFragmentDoc = gql`
    fragment RecommendedStory on StoryInterface {
  ...StoryTile
  transcodedSampleUrl
  relevanceScore
  tags {
    id
    name
  }
}
    ${StoryTileFragmentDoc}`;
export const SpeakerSummaryFragmentDoc = gql`
    fragment SpeakerSummary on Speaker {
  __typename
  id
  name
  gender
  loved
  participantsType {
    slug
  }
  accent {
    name
  }
  stories {
    totalCount
  }
  transcodedSampleUrl
}
    `;
export const ThreeSixtyStoryForTileFragmentDoc = gql`
    fragment ThreeSixtyStoryForTile on ThreeSixtyStory {
  ...CommonStoryTileFields
}
    ${CommonStoryTileFieldsFragmentDoc}`;
export const TagForDetailsPageFragmentDoc = gql`
    fragment TagForDetailsPage on Tag {
  id
  name
  description
  headerImage
  isUserPlaylist
  playlist {
    id
  }
}
    `;
export const UserNotificationFragmentDoc = gql`
    fragment UserNotification on UserNotification {
  id
  notificationType
  lastShownAt
  count
}
    `;
export const GetStoryAudioUrlDocument = gql`
    query GetStoryAudioUrl($storyId: ID!) {
  story(storyId: $storyId, returnCookies: true) {
    ...StoryAudioUrl
  }
}
    ${StoryAudioUrlFragmentDoc}`;

/**
 * __useGetStoryAudioUrlQuery__
 *
 * To run a query within a React component, call `useGetStoryAudioUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryAudioUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryAudioUrlQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetStoryAudioUrlQuery(baseOptions: Apollo.QueryHookOptions<GetStoryAudioUrlQuery, GetStoryAudioUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoryAudioUrlQuery, GetStoryAudioUrlQueryVariables>(GetStoryAudioUrlDocument, options);
      }
export function useGetStoryAudioUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoryAudioUrlQuery, GetStoryAudioUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoryAudioUrlQuery, GetStoryAudioUrlQueryVariables>(GetStoryAudioUrlDocument, options);
        }
export type GetStoryAudioUrlQueryHookResult = ReturnType<typeof useGetStoryAudioUrlQuery>;
export type GetStoryAudioUrlLazyQueryHookResult = ReturnType<typeof useGetStoryAudioUrlLazyQuery>;
export type GetStoryAudioUrlQueryResult = Apollo.QueryResult<GetStoryAudioUrlQuery, GetStoryAudioUrlQueryVariables>;
export const GetStoryDetailsDocument = gql`
    query GetStoryDetails($storyId: ID!) {
  story(storyId: $storyId) {
    ...StoryDetails
  }
}
    ${StoryDetailsFragmentDoc}`;

/**
 * __useGetStoryDetailsQuery__
 *
 * To run a query within a React component, call `useGetStoryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryDetailsQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetStoryDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetStoryDetailsQuery, GetStoryDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoryDetailsQuery, GetStoryDetailsQueryVariables>(GetStoryDetailsDocument, options);
      }
export function useGetStoryDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoryDetailsQuery, GetStoryDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoryDetailsQuery, GetStoryDetailsQueryVariables>(GetStoryDetailsDocument, options);
        }
export type GetStoryDetailsQueryHookResult = ReturnType<typeof useGetStoryDetailsQuery>;
export type GetStoryDetailsLazyQueryHookResult = ReturnType<typeof useGetStoryDetailsLazyQuery>;
export type GetStoryDetailsQueryResult = Apollo.QueryResult<GetStoryDetailsQuery, GetStoryDetailsQueryVariables>;
export const GetStoryForPlayerDocument = gql`
    query GetStoryForPlayer($storyId: ID!) {
  story(storyId: $storyId, returnCookies: true) {
    ...StoryForPlayer
  }
}
    ${StoryForPlayerFragmentDoc}`;

/**
 * __useGetStoryForPlayerQuery__
 *
 * To run a query within a React component, call `useGetStoryForPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryForPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryForPlayerQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetStoryForPlayerQuery(baseOptions: Apollo.QueryHookOptions<GetStoryForPlayerQuery, GetStoryForPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoryForPlayerQuery, GetStoryForPlayerQueryVariables>(GetStoryForPlayerDocument, options);
      }
export function useGetStoryForPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoryForPlayerQuery, GetStoryForPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoryForPlayerQuery, GetStoryForPlayerQueryVariables>(GetStoryForPlayerDocument, options);
        }
export type GetStoryForPlayerQueryHookResult = ReturnType<typeof useGetStoryForPlayerQuery>;
export type GetStoryForPlayerLazyQueryHookResult = ReturnType<typeof useGetStoryForPlayerLazyQuery>;
export type GetStoryForPlayerQueryResult = Apollo.QueryResult<GetStoryForPlayerQuery, GetStoryForPlayerQueryVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription {
  cancelSubscription {
    id
    activeSubscription {
      cancellationScheduledAt
    }
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ActiveContentDropDocument = gql`
    query activeContentDrop {
  activeContentDrop {
    ...ActiveContentDrop
  }
}
    ${ActiveContentDropFragmentDoc}`;

/**
 * __useActiveContentDropQuery__
 *
 * To run a query within a React component, call `useActiveContentDropQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveContentDropQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveContentDropQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveContentDropQuery(baseOptions?: Apollo.QueryHookOptions<ActiveContentDropQuery, ActiveContentDropQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveContentDropQuery, ActiveContentDropQueryVariables>(ActiveContentDropDocument, options);
      }
export function useActiveContentDropLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveContentDropQuery, ActiveContentDropQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveContentDropQuery, ActiveContentDropQueryVariables>(ActiveContentDropDocument, options);
        }
export type ActiveContentDropQueryHookResult = ReturnType<typeof useActiveContentDropQuery>;
export type ActiveContentDropLazyQueryHookResult = ReturnType<typeof useActiveContentDropLazyQuery>;
export type ActiveContentDropQueryResult = Apollo.QueryResult<ActiveContentDropQuery, ActiveContentDropQueryVariables>;
export const FeatureFlagsDocument = gql`
    query featureFlags {
  featureFlags {
    featureName
    enabled
  }
}
    `;

/**
 * __useFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
      }
export function useFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagsQuery, FeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagsQuery, FeatureFlagsQueryVariables>(FeatureFlagsDocument, options);
        }
export type FeatureFlagsQueryHookResult = ReturnType<typeof useFeatureFlagsQuery>;
export type FeatureFlagsLazyQueryHookResult = ReturnType<typeof useFeatureFlagsLazyQuery>;
export type FeatureFlagsQueryResult = Apollo.QueryResult<FeatureFlagsQuery, FeatureFlagsQueryVariables>;
export const GetAlreadyListenedStoriesDocument = gql`
    query GetAlreadyListenedStories {
  stories(
    filterSelection: {alreadyListened: true}
    pagination: {page: 0, perPage: 10000}
  ) {
    stories {
      id
    }
  }
}
    `;

/**
 * __useGetAlreadyListenedStoriesQuery__
 *
 * To run a query within a React component, call `useGetAlreadyListenedStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlreadyListenedStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlreadyListenedStoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAlreadyListenedStoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAlreadyListenedStoriesQuery, GetAlreadyListenedStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlreadyListenedStoriesQuery, GetAlreadyListenedStoriesQueryVariables>(GetAlreadyListenedStoriesDocument, options);
      }
export function useGetAlreadyListenedStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlreadyListenedStoriesQuery, GetAlreadyListenedStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlreadyListenedStoriesQuery, GetAlreadyListenedStoriesQueryVariables>(GetAlreadyListenedStoriesDocument, options);
        }
export type GetAlreadyListenedStoriesQueryHookResult = ReturnType<typeof useGetAlreadyListenedStoriesQuery>;
export type GetAlreadyListenedStoriesLazyQueryHookResult = ReturnType<typeof useGetAlreadyListenedStoriesLazyQuery>;
export type GetAlreadyListenedStoriesQueryResult = Apollo.QueryResult<GetAlreadyListenedStoriesQuery, GetAlreadyListenedStoriesQueryVariables>;
export const DataForCancellationFlowDocument = gql`
    query dataForCancellationFlow {
  me {
    favouriteSound {
      title
    }
    favouriteStory {
      title
    }
    timeSpent
    activeSubscription {
      billingPeriod {
        period
        unit
        price
        currencyCode
      }
      expiresAt
      freeTrialEndsAt
      freeTrialStartedAt
    }
  }
  redeemedOffers {
    offerType
  }
  likedAudios: stories(filterSelection: {lovedStories: true}) {
    totalCount
  }
  numberOfAudiosListened: stories(filterSelection: {alreadyListened: true}) {
    totalCount
  }
  numberOfStoriesListened: stories(
    filterSelection: {contentTypeSlugs: ["story"], alreadyListened: true}
  ) {
    totalCount
  }
  numberOfSoundsListened: stories(
    filterSelection: {contentTypeSlugs: ["sounds"], alreadyListened: true}
  ) {
    totalCount
  }
  storiesOfSpeakersListened: stories(
    filterSelection: {alreadyListened: true}
    pagination: {page: 0, perPage: 10000}
  ) {
    stories {
      id
      speaker {
        id
      }
    }
  }
  storiesOfKinksListened: stories(
    filterSelection: {alreadyListened: true}
    pagination: {page: 0, perPage: 10000}
  ) {
    stories {
      id
      tags {
        id
      }
    }
  }
  totalNumberOfAudios: stories {
    totalCount
  }
  totalNumberOfStories: stories(filterSelection: {contentTypeSlugs: ["story"]}) {
    totalCount
  }
  totalNumberOfSounds: stories(filterSelection: {contentTypeSlugs: ["sounds"]}) {
    totalCount
  }
  totalNumberOfSpeakers: speakers {
    totalCount
  }
  allKinks: tags(pagination: {page: 0, perPage: 1000}) {
    id
  }
}
    `;

/**
 * __useDataForCancellationFlowQuery__
 *
 * To run a query within a React component, call `useDataForCancellationFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataForCancellationFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataForCancellationFlowQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataForCancellationFlowQuery(baseOptions?: Apollo.QueryHookOptions<DataForCancellationFlowQuery, DataForCancellationFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataForCancellationFlowQuery, DataForCancellationFlowQueryVariables>(DataForCancellationFlowDocument, options);
      }
export function useDataForCancellationFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataForCancellationFlowQuery, DataForCancellationFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataForCancellationFlowQuery, DataForCancellationFlowQueryVariables>(DataForCancellationFlowDocument, options);
        }
export type DataForCancellationFlowQueryHookResult = ReturnType<typeof useDataForCancellationFlowQuery>;
export type DataForCancellationFlowLazyQueryHookResult = ReturnType<typeof useDataForCancellationFlowLazyQuery>;
export type DataForCancellationFlowQueryResult = Apollo.QueryResult<DataForCancellationFlowQuery, DataForCancellationFlowQueryVariables>;
export const FeaturedTagsDocument = gql`
    query featuredTags($order: TagOrder, $pagination: Pagination) {
  tags(tagFilters: {isFeatured: true}, pagination: $pagination, order: $order) {
    ...FeatureTag
  }
}
    ${FeatureTagFragmentDoc}`;

/**
 * __useFeaturedTagsQuery__
 *
 * To run a query within a React component, call `useFeaturedTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedTagsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFeaturedTagsQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedTagsQuery, FeaturedTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedTagsQuery, FeaturedTagsQueryVariables>(FeaturedTagsDocument, options);
      }
export function useFeaturedTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedTagsQuery, FeaturedTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedTagsQuery, FeaturedTagsQueryVariables>(FeaturedTagsDocument, options);
        }
export type FeaturedTagsQueryHookResult = ReturnType<typeof useFeaturedTagsQuery>;
export type FeaturedTagsLazyQueryHookResult = ReturnType<typeof useFeaturedTagsLazyQuery>;
export type FeaturedTagsQueryResult = Apollo.QueryResult<FeaturedTagsQuery, FeaturedTagsQueryVariables>;
export const GetJourneyDetailsWithStoriesDocument = gql`
    query getJourneyDetailsWithStories($journeyId: ID!) {
  journeys(journeyFilters: {journeyIds: [$journeyId]}) {
    ...JourneyDetails
    transcodedTeaserUrl
    stories(order: {order: ASC, orderBy: CREATED_AT}) {
      stories {
        ...JourneyDetailStory
      }
      totalCount
    }
  }
}
    ${JourneyDetailsFragmentDoc}
${JourneyDetailStoryFragmentDoc}`;

/**
 * __useGetJourneyDetailsWithStoriesQuery__
 *
 * To run a query within a React component, call `useGetJourneyDetailsWithStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJourneyDetailsWithStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJourneyDetailsWithStoriesQuery({
 *   variables: {
 *      journeyId: // value for 'journeyId'
 *   },
 * });
 */
export function useGetJourneyDetailsWithStoriesQuery(baseOptions: Apollo.QueryHookOptions<GetJourneyDetailsWithStoriesQuery, GetJourneyDetailsWithStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJourneyDetailsWithStoriesQuery, GetJourneyDetailsWithStoriesQueryVariables>(GetJourneyDetailsWithStoriesDocument, options);
      }
export function useGetJourneyDetailsWithStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJourneyDetailsWithStoriesQuery, GetJourneyDetailsWithStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJourneyDetailsWithStoriesQuery, GetJourneyDetailsWithStoriesQueryVariables>(GetJourneyDetailsWithStoriesDocument, options);
        }
export type GetJourneyDetailsWithStoriesQueryHookResult = ReturnType<typeof useGetJourneyDetailsWithStoriesQuery>;
export type GetJourneyDetailsWithStoriesLazyQueryHookResult = ReturnType<typeof useGetJourneyDetailsWithStoriesLazyQuery>;
export type GetJourneyDetailsWithStoriesQueryResult = Apollo.QueryResult<GetJourneyDetailsWithStoriesQuery, GetJourneyDetailsWithStoriesQueryVariables>;
export const GetPerUserStoryDetailsForSearchResultsDocument = gql`
    query getPerUserStoryDetailsForSearchResults($perPage: Int!, $storyIds: [ID!]!) {
  stories(
    filterSelection: {storyIds: $storyIds}
    pagination: {perPage: $perPage, page: 0}
  ) {
    stories {
      ...StoryDetailsForSearch
    }
  }
}
    ${StoryDetailsForSearchFragmentDoc}`;

/**
 * __useGetPerUserStoryDetailsForSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetPerUserStoryDetailsForSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerUserStoryDetailsForSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerUserStoryDetailsForSearchResultsQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      storyIds: // value for 'storyIds'
 *   },
 * });
 */
export function useGetPerUserStoryDetailsForSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<GetPerUserStoryDetailsForSearchResultsQuery, GetPerUserStoryDetailsForSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerUserStoryDetailsForSearchResultsQuery, GetPerUserStoryDetailsForSearchResultsQueryVariables>(GetPerUserStoryDetailsForSearchResultsDocument, options);
      }
export function useGetPerUserStoryDetailsForSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerUserStoryDetailsForSearchResultsQuery, GetPerUserStoryDetailsForSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerUserStoryDetailsForSearchResultsQuery, GetPerUserStoryDetailsForSearchResultsQueryVariables>(GetPerUserStoryDetailsForSearchResultsDocument, options);
        }
export type GetPerUserStoryDetailsForSearchResultsQueryHookResult = ReturnType<typeof useGetPerUserStoryDetailsForSearchResultsQuery>;
export type GetPerUserStoryDetailsForSearchResultsLazyQueryHookResult = ReturnType<typeof useGetPerUserStoryDetailsForSearchResultsLazyQuery>;
export type GetPerUserStoryDetailsForSearchResultsQueryResult = Apollo.QueryResult<GetPerUserStoryDetailsForSearchResultsQuery, GetPerUserStoryDetailsForSearchResultsQueryVariables>;
export const GetPopularTagsAndSpeakersDocument = gql`
    query GetPopularTagsAndSpeakers($tagsIds: [ID!]!, $speakersIds: [ID!]!) {
  tags(tagFilters: {tagIds: $tagsIds}) {
    id
    name
    bubbleWithTitle
    bubbleWithTitleAndImage
  }
  speakers(speakerFilters: {speakerIds: $speakersIds}) {
    speakers {
      id
      name
      participantsType {
        slug
      }
    }
  }
}
    `;

/**
 * __useGetPopularTagsAndSpeakersQuery__
 *
 * To run a query within a React component, call `useGetPopularTagsAndSpeakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularTagsAndSpeakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularTagsAndSpeakersQuery({
 *   variables: {
 *      tagsIds: // value for 'tagsIds'
 *      speakersIds: // value for 'speakersIds'
 *   },
 * });
 */
export function useGetPopularTagsAndSpeakersQuery(baseOptions: Apollo.QueryHookOptions<GetPopularTagsAndSpeakersQuery, GetPopularTagsAndSpeakersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPopularTagsAndSpeakersQuery, GetPopularTagsAndSpeakersQueryVariables>(GetPopularTagsAndSpeakersDocument, options);
      }
export function useGetPopularTagsAndSpeakersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPopularTagsAndSpeakersQuery, GetPopularTagsAndSpeakersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPopularTagsAndSpeakersQuery, GetPopularTagsAndSpeakersQueryVariables>(GetPopularTagsAndSpeakersDocument, options);
        }
export type GetPopularTagsAndSpeakersQueryHookResult = ReturnType<typeof useGetPopularTagsAndSpeakersQuery>;
export type GetPopularTagsAndSpeakersLazyQueryHookResult = ReturnType<typeof useGetPopularTagsAndSpeakersLazyQuery>;
export type GetPopularTagsAndSpeakersQueryResult = Apollo.QueryResult<GetPopularTagsAndSpeakersQuery, GetPopularTagsAndSpeakersQueryVariables>;
export const GetPostPurchaseAnswersDocument = gql`
    query getPostPurchaseAnswers {
  postPurchaseAnswers {
    id
    key
    localizedLabel
    options
    optionsTrackingIds
    sendSelectedOptionAsKey
    freeText
    freeTextPlaceholder
  }
}
    `;

/**
 * __useGetPostPurchaseAnswersQuery__
 *
 * To run a query within a React component, call `useGetPostPurchaseAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostPurchaseAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostPurchaseAnswersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPostPurchaseAnswersQuery(baseOptions?: Apollo.QueryHookOptions<GetPostPurchaseAnswersQuery, GetPostPurchaseAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostPurchaseAnswersQuery, GetPostPurchaseAnswersQueryVariables>(GetPostPurchaseAnswersDocument, options);
      }
export function useGetPostPurchaseAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostPurchaseAnswersQuery, GetPostPurchaseAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostPurchaseAnswersQuery, GetPostPurchaseAnswersQueryVariables>(GetPostPurchaseAnswersDocument, options);
        }
export type GetPostPurchaseAnswersQueryHookResult = ReturnType<typeof useGetPostPurchaseAnswersQuery>;
export type GetPostPurchaseAnswersLazyQueryHookResult = ReturnType<typeof useGetPostPurchaseAnswersLazyQuery>;
export type GetPostPurchaseAnswersQueryResult = Apollo.QueryResult<GetPostPurchaseAnswersQuery, GetPostPurchaseAnswersQueryVariables>;
export const GetQueueRecommendationsDocument = gql`
    query getQueueRecommendations($campaign: String!, $storyId: ID!) {
  recommendedStories(campaign: $campaign, storyId: $storyId, numberResults: 7) {
    recommendedStories {
      id
      title
      speaker {
        name
      }
    }
  }
}
    `;

/**
 * __useGetQueueRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetQueueRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueRecommendationsQuery({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetQueueRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GetQueueRecommendationsQuery, GetQueueRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueRecommendationsQuery, GetQueueRecommendationsQueryVariables>(GetQueueRecommendationsDocument, options);
      }
export function useGetQueueRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueRecommendationsQuery, GetQueueRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueRecommendationsQuery, GetQueueRecommendationsQueryVariables>(GetQueueRecommendationsDocument, options);
        }
export type GetQueueRecommendationsQueryHookResult = ReturnType<typeof useGetQueueRecommendationsQuery>;
export type GetQueueRecommendationsLazyQueryHookResult = ReturnType<typeof useGetQueueRecommendationsLazyQuery>;
export type GetQueueRecommendationsQueryResult = Apollo.QueryResult<GetQueueRecommendationsQuery, GetQueueRecommendationsQueryVariables>;
export const GetRedeemedOffersDocument = gql`
    query getRedeemedOffers {
  redeemedOffers {
    offerType
  }
}
    `;

/**
 * __useGetRedeemedOffersQuery__
 *
 * To run a query within a React component, call `useGetRedeemedOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedeemedOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedeemedOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRedeemedOffersQuery(baseOptions?: Apollo.QueryHookOptions<GetRedeemedOffersQuery, GetRedeemedOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedeemedOffersQuery, GetRedeemedOffersQueryVariables>(GetRedeemedOffersDocument, options);
      }
export function useGetRedeemedOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedeemedOffersQuery, GetRedeemedOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedeemedOffersQuery, GetRedeemedOffersQueryVariables>(GetRedeemedOffersDocument, options);
        }
export type GetRedeemedOffersQueryHookResult = ReturnType<typeof useGetRedeemedOffersQuery>;
export type GetRedeemedOffersLazyQueryHookResult = ReturnType<typeof useGetRedeemedOffersLazyQuery>;
export type GetRedeemedOffersQueryResult = Apollo.QueryResult<GetRedeemedOffersQuery, GetRedeemedOffersQueryVariables>;
export const GetScenariosDocument = gql`
    query GetScenarios {
  tags(tagFilters: {isScenario: true}) {
    ...GetScenario
  }
}
    ${GetScenarioFragmentDoc}`;

/**
 * __useGetScenariosQuery__
 *
 * To run a query within a React component, call `useGetScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScenariosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScenariosQuery(baseOptions?: Apollo.QueryHookOptions<GetScenariosQuery, GetScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScenariosQuery, GetScenariosQueryVariables>(GetScenariosDocument, options);
      }
export function useGetScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScenariosQuery, GetScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScenariosQuery, GetScenariosQueryVariables>(GetScenariosDocument, options);
        }
export type GetScenariosQueryHookResult = ReturnType<typeof useGetScenariosQuery>;
export type GetScenariosLazyQueryHookResult = ReturnType<typeof useGetScenariosLazyQuery>;
export type GetScenariosQueryResult = Apollo.QueryResult<GetScenariosQuery, GetScenariosQueryVariables>;
export const GetSpeakerLovedDocument = gql`
    query GetSpeakerLoved($speakerId: ID!) {
  speakers(speakerFilters: {speakerIds: [$speakerId]}) {
    speakers {
      id
      loved
    }
  }
}
    `;

/**
 * __useGetSpeakerLovedQuery__
 *
 * To run a query within a React component, call `useGetSpeakerLovedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpeakerLovedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpeakerLovedQuery({
 *   variables: {
 *      speakerId: // value for 'speakerId'
 *   },
 * });
 */
export function useGetSpeakerLovedQuery(baseOptions: Apollo.QueryHookOptions<GetSpeakerLovedQuery, GetSpeakerLovedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpeakerLovedQuery, GetSpeakerLovedQueryVariables>(GetSpeakerLovedDocument, options);
      }
export function useGetSpeakerLovedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpeakerLovedQuery, GetSpeakerLovedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpeakerLovedQuery, GetSpeakerLovedQueryVariables>(GetSpeakerLovedDocument, options);
        }
export type GetSpeakerLovedQueryHookResult = ReturnType<typeof useGetSpeakerLovedQuery>;
export type GetSpeakerLovedLazyQueryHookResult = ReturnType<typeof useGetSpeakerLovedLazyQuery>;
export type GetSpeakerLovedQueryResult = Apollo.QueryResult<GetSpeakerLovedQuery, GetSpeakerLovedQueryVariables>;
export const GetStoryLovedDocument = gql`
    query GetStoryLoved($storyId: ID!) {
  story(storyId: $storyId) {
    ...StoryLoved
  }
}
    ${StoryLovedFragmentDoc}`;

/**
 * __useGetStoryLovedQuery__
 *
 * To run a query within a React component, call `useGetStoryLovedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryLovedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryLovedQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetStoryLovedQuery(baseOptions: Apollo.QueryHookOptions<GetStoryLovedQuery, GetStoryLovedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoryLovedQuery, GetStoryLovedQueryVariables>(GetStoryLovedDocument, options);
      }
export function useGetStoryLovedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoryLovedQuery, GetStoryLovedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoryLovedQuery, GetStoryLovedQueryVariables>(GetStoryLovedDocument, options);
        }
export type GetStoryLovedQueryHookResult = ReturnType<typeof useGetStoryLovedQuery>;
export type GetStoryLovedLazyQueryHookResult = ReturnType<typeof useGetStoryLovedLazyQuery>;
export type GetStoryLovedQueryResult = Apollo.QueryResult<GetStoryLovedQuery, GetStoryLovedQueryVariables>;
export const GetTagsFeaturedImagesDocument = gql`
    query getTagsFeaturedImages($tagsIds: [ID!]!) {
  tags(tagFilters: {tagIds: $tagsIds}) {
    ...GetTagsFeaturedImages
  }
}
    ${GetTagsFeaturedImagesFragmentDoc}`;

/**
 * __useGetTagsFeaturedImagesQuery__
 *
 * To run a query within a React component, call `useGetTagsFeaturedImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsFeaturedImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsFeaturedImagesQuery({
 *   variables: {
 *      tagsIds: // value for 'tagsIds'
 *   },
 * });
 */
export function useGetTagsFeaturedImagesQuery(baseOptions: Apollo.QueryHookOptions<GetTagsFeaturedImagesQuery, GetTagsFeaturedImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsFeaturedImagesQuery, GetTagsFeaturedImagesQueryVariables>(GetTagsFeaturedImagesDocument, options);
      }
export function useGetTagsFeaturedImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsFeaturedImagesQuery, GetTagsFeaturedImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsFeaturedImagesQuery, GetTagsFeaturedImagesQueryVariables>(GetTagsFeaturedImagesDocument, options);
        }
export type GetTagsFeaturedImagesQueryHookResult = ReturnType<typeof useGetTagsFeaturedImagesQuery>;
export type GetTagsFeaturedImagesLazyQueryHookResult = ReturnType<typeof useGetTagsFeaturedImagesLazyQuery>;
export type GetTagsFeaturedImagesQueryResult = Apollo.QueryResult<GetTagsFeaturedImagesQuery, GetTagsFeaturedImagesQueryVariables>;
export const GetTagsFeaturedImagesWithoutTextDocument = gql`
    query getTagsFeaturedImagesWithoutText($tagsIds: [ID!]!) {
  tags(tagFilters: {tagIds: $tagsIds}) {
    ...GetTagsFeaturedImagesWithoutText
  }
}
    ${GetTagsFeaturedImagesWithoutTextFragmentDoc}`;

/**
 * __useGetTagsFeaturedImagesWithoutTextQuery__
 *
 * To run a query within a React component, call `useGetTagsFeaturedImagesWithoutTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsFeaturedImagesWithoutTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsFeaturedImagesWithoutTextQuery({
 *   variables: {
 *      tagsIds: // value for 'tagsIds'
 *   },
 * });
 */
export function useGetTagsFeaturedImagesWithoutTextQuery(baseOptions: Apollo.QueryHookOptions<GetTagsFeaturedImagesWithoutTextQuery, GetTagsFeaturedImagesWithoutTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsFeaturedImagesWithoutTextQuery, GetTagsFeaturedImagesWithoutTextQueryVariables>(GetTagsFeaturedImagesWithoutTextDocument, options);
      }
export function useGetTagsFeaturedImagesWithoutTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsFeaturedImagesWithoutTextQuery, GetTagsFeaturedImagesWithoutTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsFeaturedImagesWithoutTextQuery, GetTagsFeaturedImagesWithoutTextQueryVariables>(GetTagsFeaturedImagesWithoutTextDocument, options);
        }
export type GetTagsFeaturedImagesWithoutTextQueryHookResult = ReturnType<typeof useGetTagsFeaturedImagesWithoutTextQuery>;
export type GetTagsFeaturedImagesWithoutTextLazyQueryHookResult = ReturnType<typeof useGetTagsFeaturedImagesWithoutTextLazyQuery>;
export type GetTagsFeaturedImagesWithoutTextQueryResult = Apollo.QueryResult<GetTagsFeaturedImagesWithoutTextQuery, GetTagsFeaturedImagesWithoutTextQueryVariables>;
export const GetTagsForScenariosDocument = gql`
    query GetTagsForScenarios($soloTagIds: [ID!]!, $couplesTagIds: [ID!]!, $threesomesTagIds: [ID!]!, $groupsTagIds: [ID!]!) {
  solo: tags(tagFilters: {tagIds: $soloTagIds}) {
    ...TagForScenario
  }
  couples: tags(tagFilters: {tagIds: $couplesTagIds}) {
    ...TagForScenario
  }
  threesomes: tags(tagFilters: {tagIds: $threesomesTagIds}) {
    ...TagForScenario
  }
  groups: tags(tagFilters: {tagIds: $groupsTagIds}) {
    ...TagForScenario
  }
}
    ${TagForScenarioFragmentDoc}`;

/**
 * __useGetTagsForScenariosQuery__
 *
 * To run a query within a React component, call `useGetTagsForScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsForScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsForScenariosQuery({
 *   variables: {
 *      soloTagIds: // value for 'soloTagIds'
 *      couplesTagIds: // value for 'couplesTagIds'
 *      threesomesTagIds: // value for 'threesomesTagIds'
 *      groupsTagIds: // value for 'groupsTagIds'
 *   },
 * });
 */
export function useGetTagsForScenariosQuery(baseOptions: Apollo.QueryHookOptions<GetTagsForScenariosQuery, GetTagsForScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsForScenariosQuery, GetTagsForScenariosQueryVariables>(GetTagsForScenariosDocument, options);
      }
export function useGetTagsForScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsForScenariosQuery, GetTagsForScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsForScenariosQuery, GetTagsForScenariosQueryVariables>(GetTagsForScenariosDocument, options);
        }
export type GetTagsForScenariosQueryHookResult = ReturnType<typeof useGetTagsForScenariosQuery>;
export type GetTagsForScenariosLazyQueryHookResult = ReturnType<typeof useGetTagsForScenariosLazyQuery>;
export type GetTagsForScenariosQueryResult = Apollo.QueryResult<GetTagsForScenariosQuery, GetTagsForScenariosQueryVariables>;
export const GetTagsKinkinessScoreDocument = gql`
    query getTagsKinkinessScore($tagsIds: [ID!]!) {
  tags(tagFilters: {tagIds: $tagsIds}) {
    id
    kinkinessScore
  }
}
    `;

/**
 * __useGetTagsKinkinessScoreQuery__
 *
 * To run a query within a React component, call `useGetTagsKinkinessScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsKinkinessScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsKinkinessScoreQuery({
 *   variables: {
 *      tagsIds: // value for 'tagsIds'
 *   },
 * });
 */
export function useGetTagsKinkinessScoreQuery(baseOptions: Apollo.QueryHookOptions<GetTagsKinkinessScoreQuery, GetTagsKinkinessScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsKinkinessScoreQuery, GetTagsKinkinessScoreQueryVariables>(GetTagsKinkinessScoreDocument, options);
      }
export function useGetTagsKinkinessScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsKinkinessScoreQuery, GetTagsKinkinessScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsKinkinessScoreQuery, GetTagsKinkinessScoreQueryVariables>(GetTagsKinkinessScoreDocument, options);
        }
export type GetTagsKinkinessScoreQueryHookResult = ReturnType<typeof useGetTagsKinkinessScoreQuery>;
export type GetTagsKinkinessScoreLazyQueryHookResult = ReturnType<typeof useGetTagsKinkinessScoreLazyQuery>;
export type GetTagsKinkinessScoreQueryResult = Apollo.QueryResult<GetTagsKinkinessScoreQuery, GetTagsKinkinessScoreQueryVariables>;
export const GetTagsNamesDocument = gql`
    query getTagsNames($tagsIds: [ID!]!) {
  tags(tagFilters: {tagIds: $tagsIds}) {
    id
    name
  }
}
    `;

/**
 * __useGetTagsNamesQuery__
 *
 * To run a query within a React component, call `useGetTagsNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsNamesQuery({
 *   variables: {
 *      tagsIds: // value for 'tagsIds'
 *   },
 * });
 */
export function useGetTagsNamesQuery(baseOptions: Apollo.QueryHookOptions<GetTagsNamesQuery, GetTagsNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsNamesQuery, GetTagsNamesQueryVariables>(GetTagsNamesDocument, options);
      }
export function useGetTagsNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsNamesQuery, GetTagsNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsNamesQuery, GetTagsNamesQueryVariables>(GetTagsNamesDocument, options);
        }
export type GetTagsNamesQueryHookResult = ReturnType<typeof useGetTagsNamesQuery>;
export type GetTagsNamesLazyQueryHookResult = ReturnType<typeof useGetTagsNamesLazyQuery>;
export type GetTagsNamesQueryResult = Apollo.QueryResult<GetTagsNamesQuery, GetTagsNamesQueryVariables>;
export const GetVoicesStatisticsDocument = gql`
    query getVoicesStatistics {
  femaleAudios: stories(filterSelection: {participantTypes: [FEMALE]}) {
    totalCount
  }
  femaleVoices: speakers(speakerFilters: {participantTypes: [FEMALE]}) {
    totalCount
  }
  maleAudios: stories(filterSelection: {participantTypes: [MALE]}) {
    totalCount
  }
  maleVoices: speakers(speakerFilters: {participantTypes: [MALE]}) {
    totalCount
  }
  nonBinaryAudios: stories(filterSelection: {participantTypes: [DIVERSE]}) {
    totalCount
  }
  nonBinaryVoices: speakers(speakerFilters: {participantTypes: [DIVERSE]}) {
    totalCount
  }
  loversVoices: speakers(
    speakerFilters: {participantTypes: [FEMALE_FEMALE, FEMALE_MALE, MALE_FEMALE, MALE_MALE, ANONYM]}
  ) {
    totalCount
  }
  loversAudios: stories(
    filterSelection: {participantTypes: [FEMALE_FEMALE, FEMALE_MALE, MALE_FEMALE, MALE_MALE, ANONYM]}
  ) {
    totalCount
  }
}
    `;

/**
 * __useGetVoicesStatisticsQuery__
 *
 * To run a query within a React component, call `useGetVoicesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoicesStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoicesStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVoicesStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetVoicesStatisticsQuery, GetVoicesStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoicesStatisticsQuery, GetVoicesStatisticsQueryVariables>(GetVoicesStatisticsDocument, options);
      }
export function useGetVoicesStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoicesStatisticsQuery, GetVoicesStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoicesStatisticsQuery, GetVoicesStatisticsQueryVariables>(GetVoicesStatisticsDocument, options);
        }
export type GetVoicesStatisticsQueryHookResult = ReturnType<typeof useGetVoicesStatisticsQuery>;
export type GetVoicesStatisticsLazyQueryHookResult = ReturnType<typeof useGetVoicesStatisticsLazyQuery>;
export type GetVoicesStatisticsQueryResult = Apollo.QueryResult<GetVoicesStatisticsQuery, GetVoicesStatisticsQueryVariables>;
export const IncreaseNumberOfListensDocument = gql`
    mutation IncreaseNumberOfListens($storyId: ID!) {
  increaseNumberOfListens(storyId: $storyId) {
    id
  }
}
    `;
export type IncreaseNumberOfListensMutationFn = Apollo.MutationFunction<IncreaseNumberOfListensMutation, IncreaseNumberOfListensMutationVariables>;

/**
 * __useIncreaseNumberOfListensMutation__
 *
 * To run a mutation, you first call `useIncreaseNumberOfListensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncreaseNumberOfListensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [increaseNumberOfListensMutation, { data, loading, error }] = useIncreaseNumberOfListensMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useIncreaseNumberOfListensMutation(baseOptions?: Apollo.MutationHookOptions<IncreaseNumberOfListensMutation, IncreaseNumberOfListensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IncreaseNumberOfListensMutation, IncreaseNumberOfListensMutationVariables>(IncreaseNumberOfListensDocument, options);
      }
export type IncreaseNumberOfListensMutationHookResult = ReturnType<typeof useIncreaseNumberOfListensMutation>;
export type IncreaseNumberOfListensMutationResult = Apollo.MutationResult<IncreaseNumberOfListensMutation>;
export type IncreaseNumberOfListensMutationOptions = Apollo.BaseMutationOptions<IncreaseNumberOfListensMutation, IncreaseNumberOfListensMutationVariables>;
export const JourneysDocument = gql`
    query journeys {
  journeys {
    ...Journey
  }
}
    ${JourneyFragmentDoc}`;

/**
 * __useJourneysQuery__
 *
 * To run a query within a React component, call `useJourneysQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneysQuery({
 *   variables: {
 *   },
 * });
 */
export function useJourneysQuery(baseOptions?: Apollo.QueryHookOptions<JourneysQuery, JourneysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneysQuery, JourneysQueryVariables>(JourneysDocument, options);
      }
export function useJourneysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneysQuery, JourneysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneysQuery, JourneysQueryVariables>(JourneysDocument, options);
        }
export type JourneysQueryHookResult = ReturnType<typeof useJourneysQuery>;
export type JourneysLazyQueryHookResult = ReturnType<typeof useJourneysLazyQuery>;
export type JourneysQueryResult = Apollo.QueryResult<JourneysQuery, JourneysQueryVariables>;
export const KinksPageDocument = gql`
    query kinksPage($tagOfTheMonthId: ID!) {
  tags(pagination: {page: 0, perPage: 100}, tagFilters: {isFeatured: true}) {
    ...KinkTag
  }
  tagOfTheMonth: tag(tagId: $tagOfTheMonthId) {
    ...KinkTag
    description
  }
}
    ${KinkTagFragmentDoc}`;

/**
 * __useKinksPageQuery__
 *
 * To run a query within a React component, call `useKinksPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useKinksPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKinksPageQuery({
 *   variables: {
 *      tagOfTheMonthId: // value for 'tagOfTheMonthId'
 *   },
 * });
 */
export function useKinksPageQuery(baseOptions: Apollo.QueryHookOptions<KinksPageQuery, KinksPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KinksPageQuery, KinksPageQueryVariables>(KinksPageDocument, options);
      }
export function useKinksPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KinksPageQuery, KinksPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KinksPageQuery, KinksPageQueryVariables>(KinksPageDocument, options);
        }
export type KinksPageQueryHookResult = ReturnType<typeof useKinksPageQuery>;
export type KinksPageLazyQueryHookResult = ReturnType<typeof useKinksPageLazyQuery>;
export type KinksPageQueryResult = Apollo.QueryResult<KinksPageQuery, KinksPageQueryVariables>;
export const KlaviyoFormsDocument = gql`
    query klaviyoForms {
  klaviyoForms {
    id
    formId
    displayUrl
    includeUrls
    excludeUrls
    showAfter
    showOnlyOnce
  }
}
    `;

/**
 * __useKlaviyoFormsQuery__
 *
 * To run a query within a React component, call `useKlaviyoFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKlaviyoFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKlaviyoFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useKlaviyoFormsQuery(baseOptions?: Apollo.QueryHookOptions<KlaviyoFormsQuery, KlaviyoFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KlaviyoFormsQuery, KlaviyoFormsQueryVariables>(KlaviyoFormsDocument, options);
      }
export function useKlaviyoFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KlaviyoFormsQuery, KlaviyoFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KlaviyoFormsQuery, KlaviyoFormsQueryVariables>(KlaviyoFormsDocument, options);
        }
export type KlaviyoFormsQueryHookResult = ReturnType<typeof useKlaviyoFormsQuery>;
export type KlaviyoFormsLazyQueryHookResult = ReturnType<typeof useKlaviyoFormsLazyQuery>;
export type KlaviyoFormsQueryResult = Apollo.QueryResult<KlaviyoFormsQuery, KlaviyoFormsQueryVariables>;
export const MarkStoryAsListenedDocument = gql`
    mutation MarkStoryAsListened($storyId: ID!, $timeStopped: Int!) {
  markStoryAsListened(input: {storyId: $storyId, timeStopped: $timeStopped}) {
    __typename
    id
    alreadyListened
  }
}
    `;
export type MarkStoryAsListenedMutationFn = Apollo.MutationFunction<MarkStoryAsListenedMutation, MarkStoryAsListenedMutationVariables>;

/**
 * __useMarkStoryAsListenedMutation__
 *
 * To run a mutation, you first call `useMarkStoryAsListenedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkStoryAsListenedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markStoryAsListenedMutation, { data, loading, error }] = useMarkStoryAsListenedMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      timeStopped: // value for 'timeStopped'
 *   },
 * });
 */
export function useMarkStoryAsListenedMutation(baseOptions?: Apollo.MutationHookOptions<MarkStoryAsListenedMutation, MarkStoryAsListenedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkStoryAsListenedMutation, MarkStoryAsListenedMutationVariables>(MarkStoryAsListenedDocument, options);
      }
export type MarkStoryAsListenedMutationHookResult = ReturnType<typeof useMarkStoryAsListenedMutation>;
export type MarkStoryAsListenedMutationResult = Apollo.MutationResult<MarkStoryAsListenedMutation>;
export type MarkStoryAsListenedMutationOptions = Apollo.BaseMutationOptions<MarkStoryAsListenedMutation, MarkStoryAsListenedMutationVariables>;
export const GetMasturbationTechniquesWithStoriesDocument = gql`
    query getMasturbationTechniquesWithStories($masturbationTechniquesFilters: MasturbationTechniquesFilters) {
  masturbationTechniques(
    masturbationTechniquesFilters: $masturbationTechniquesFilters
  ) {
    id
    title
    tileIllustration
    headerIllustration
    description
    stories {
      stories {
        ...StoryTile
      }
    }
  }
}
    ${StoryTileFragmentDoc}`;

/**
 * __useGetMasturbationTechniquesWithStoriesQuery__
 *
 * To run a query within a React component, call `useGetMasturbationTechniquesWithStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasturbationTechniquesWithStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasturbationTechniquesWithStoriesQuery({
 *   variables: {
 *      masturbationTechniquesFilters: // value for 'masturbationTechniquesFilters'
 *   },
 * });
 */
export function useGetMasturbationTechniquesWithStoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetMasturbationTechniquesWithStoriesQuery, GetMasturbationTechniquesWithStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasturbationTechniquesWithStoriesQuery, GetMasturbationTechniquesWithStoriesQueryVariables>(GetMasturbationTechniquesWithStoriesDocument, options);
      }
export function useGetMasturbationTechniquesWithStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasturbationTechniquesWithStoriesQuery, GetMasturbationTechniquesWithStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasturbationTechniquesWithStoriesQuery, GetMasturbationTechniquesWithStoriesQueryVariables>(GetMasturbationTechniquesWithStoriesDocument, options);
        }
export type GetMasturbationTechniquesWithStoriesQueryHookResult = ReturnType<typeof useGetMasturbationTechniquesWithStoriesQuery>;
export type GetMasturbationTechniquesWithStoriesLazyQueryHookResult = ReturnType<typeof useGetMasturbationTechniquesWithStoriesLazyQuery>;
export type GetMasturbationTechniquesWithStoriesQueryResult = Apollo.QueryResult<GetMasturbationTechniquesWithStoriesQuery, GetMasturbationTechniquesWithStoriesQueryVariables>;
export const GetMasturbationTechniquesDocument = gql`
    query getMasturbationTechniques($masturbationTechniquesOrder: MasturbationTechniquesOrder) {
  masturbationTechniques(
    masturbationTechniquesOrder: $masturbationTechniquesOrder
  ) {
    ...MasturbationTechniqueForSlide
  }
}
    ${MasturbationTechniqueForSlideFragmentDoc}`;

/**
 * __useGetMasturbationTechniquesQuery__
 *
 * To run a query within a React component, call `useGetMasturbationTechniquesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasturbationTechniquesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasturbationTechniquesQuery({
 *   variables: {
 *      masturbationTechniquesOrder: // value for 'masturbationTechniquesOrder'
 *   },
 * });
 */
export function useGetMasturbationTechniquesQuery(baseOptions?: Apollo.QueryHookOptions<GetMasturbationTechniquesQuery, GetMasturbationTechniquesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasturbationTechniquesQuery, GetMasturbationTechniquesQueryVariables>(GetMasturbationTechniquesDocument, options);
      }
export function useGetMasturbationTechniquesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasturbationTechniquesQuery, GetMasturbationTechniquesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasturbationTechniquesQuery, GetMasturbationTechniquesQueryVariables>(GetMasturbationTechniquesDocument, options);
        }
export type GetMasturbationTechniquesQueryHookResult = ReturnType<typeof useGetMasturbationTechniquesQuery>;
export type GetMasturbationTechniquesLazyQueryHookResult = ReturnType<typeof useGetMasturbationTechniquesLazyQuery>;
export type GetMasturbationTechniquesQueryResult = Apollo.QueryResult<GetMasturbationTechniquesQuery, GetMasturbationTechniquesQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserProfile
  }
  userPreferences {
    hideAlreadyListened
  }
}
    ${UserProfileFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MoodsDocument = gql`
    query moods {
  moods: tags(
    tagFilters: {isMood: true}
    order: {order: DESC, orderBy: UPDATED_AT}
  ) {
    ...TagSummary
  }
}
    ${TagSummaryFragmentDoc}`;

/**
 * __useMoodsQuery__
 *
 * To run a query within a React component, call `useMoodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMoodsQuery(baseOptions?: Apollo.QueryHookOptions<MoodsQuery, MoodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoodsQuery, MoodsQueryVariables>(MoodsDocument, options);
      }
export function useMoodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoodsQuery, MoodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoodsQuery, MoodsQueryVariables>(MoodsDocument, options);
        }
export type MoodsQueryHookResult = ReturnType<typeof useMoodsQuery>;
export type MoodsLazyQueryHookResult = ReturnType<typeof useMoodsLazyQuery>;
export type MoodsQueryResult = Apollo.QueryResult<MoodsQuery, MoodsQueryVariables>;
export const FavouriteKinksDocument = gql`
    query favouriteKinks($limit: Int = 3) {
  favouriteKinks(limit: $limit) {
    ...FeatureTag
  }
}
    ${FeatureTagFragmentDoc}`;

/**
 * __useFavouriteKinksQuery__
 *
 * To run a query within a React component, call `useFavouriteKinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavouriteKinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavouriteKinksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFavouriteKinksQuery(baseOptions?: Apollo.QueryHookOptions<FavouriteKinksQuery, FavouriteKinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavouriteKinksQuery, FavouriteKinksQueryVariables>(FavouriteKinksDocument, options);
      }
export function useFavouriteKinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavouriteKinksQuery, FavouriteKinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavouriteKinksQuery, FavouriteKinksQueryVariables>(FavouriteKinksDocument, options);
        }
export type FavouriteKinksQueryHookResult = ReturnType<typeof useFavouriteKinksQuery>;
export type FavouriteKinksLazyQueryHookResult = ReturnType<typeof useFavouriteKinksLazyQuery>;
export type FavouriteKinksQueryResult = Apollo.QueryResult<FavouriteKinksQuery, FavouriteKinksQueryVariables>;
export const OnboardingTagsDocument = gql`
    query onboardingTags {
  tags(
    tagFilters: {onlyWithOnboardingPosition: true}
    pagination: {page: 0, perPage: 50}
    order: {order: ASC, orderBy: ONBOARDING_POSITION}
  ) {
    ...OnboardingTag
  }
}
    ${OnboardingTagFragmentDoc}`;

/**
 * __useOnboardingTagsQuery__
 *
 * To run a query within a React component, call `useOnboardingTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingTagsQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingTagsQuery, OnboardingTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingTagsQuery, OnboardingTagsQueryVariables>(OnboardingTagsDocument, options);
      }
export function useOnboardingTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingTagsQuery, OnboardingTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingTagsQuery, OnboardingTagsQueryVariables>(OnboardingTagsDocument, options);
        }
export type OnboardingTagsQueryHookResult = ReturnType<typeof useOnboardingTagsQuery>;
export type OnboardingTagsLazyQueryHookResult = ReturnType<typeof useOnboardingTagsLazyQuery>;
export type OnboardingTagsQueryResult = Apollo.QueryResult<OnboardingTagsQuery, OnboardingTagsQueryVariables>;
export const OnboardingVanillaTagsDocument = gql`
    query onboardingVanillaTags($tagIds: [ID!]!) {
  tags(tagFilters: {tagIds: $tagIds}) {
    ...OnboardingTag
  }
}
    ${OnboardingTagFragmentDoc}`;

/**
 * __useOnboardingVanillaTagsQuery__
 *
 * To run a query within a React component, call `useOnboardingVanillaTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingVanillaTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingVanillaTagsQuery({
 *   variables: {
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useOnboardingVanillaTagsQuery(baseOptions: Apollo.QueryHookOptions<OnboardingVanillaTagsQuery, OnboardingVanillaTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingVanillaTagsQuery, OnboardingVanillaTagsQueryVariables>(OnboardingVanillaTagsDocument, options);
      }
export function useOnboardingVanillaTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingVanillaTagsQuery, OnboardingVanillaTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingVanillaTagsQuery, OnboardingVanillaTagsQueryVariables>(OnboardingVanillaTagsDocument, options);
        }
export type OnboardingVanillaTagsQueryHookResult = ReturnType<typeof useOnboardingVanillaTagsQuery>;
export type OnboardingVanillaTagsLazyQueryHookResult = ReturnType<typeof useOnboardingVanillaTagsLazyQuery>;
export type OnboardingVanillaTagsQueryResult = Apollo.QueryResult<OnboardingVanillaTagsQuery, OnboardingVanillaTagsQueryVariables>;
export const PlaylistWithStoriesDocument = gql`
    query playlistWithStories($id: ID!) {
  playlists(filters: {ids: [$id]}) {
    ...PlaylistDetails
  }
}
    ${PlaylistDetailsFragmentDoc}`;

/**
 * __usePlaylistWithStoriesQuery__
 *
 * To run a query within a React component, call `usePlaylistWithStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistWithStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistWithStoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaylistWithStoriesQuery(baseOptions: Apollo.QueryHookOptions<PlaylistWithStoriesQuery, PlaylistWithStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistWithStoriesQuery, PlaylistWithStoriesQueryVariables>(PlaylistWithStoriesDocument, options);
      }
export function usePlaylistWithStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistWithStoriesQuery, PlaylistWithStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistWithStoriesQuery, PlaylistWithStoriesQueryVariables>(PlaylistWithStoriesDocument, options);
        }
export type PlaylistWithStoriesQueryHookResult = ReturnType<typeof usePlaylistWithStoriesQuery>;
export type PlaylistWithStoriesLazyQueryHookResult = ReturnType<typeof usePlaylistWithStoriesLazyQuery>;
export type PlaylistWithStoriesQueryResult = Apollo.QueryResult<PlaylistWithStoriesQuery, PlaylistWithStoriesQueryVariables>;
export const GetPlaylistsDocument = gql`
    query getPlaylists($filters: PlaylistFilters!) {
  playlists(filters: $filters) {
    ...PlaylistForList
  }
}
    ${PlaylistForListFragmentDoc}`;

/**
 * __useGetPlaylistsQuery__
 *
 * To run a query within a React component, call `useGetPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaylistsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPlaylistsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaylistsQuery, GetPlaylistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaylistsQuery, GetPlaylistsQueryVariables>(GetPlaylistsDocument, options);
      }
export function useGetPlaylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaylistsQuery, GetPlaylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaylistsQuery, GetPlaylistsQueryVariables>(GetPlaylistsDocument, options);
        }
export type GetPlaylistsQueryHookResult = ReturnType<typeof useGetPlaylistsQuery>;
export type GetPlaylistsLazyQueryHookResult = ReturnType<typeof useGetPlaylistsLazyQuery>;
export type GetPlaylistsQueryResult = Apollo.QueryResult<GetPlaylistsQuery, GetPlaylistsQueryVariables>;
export const UserPlaylistsDocument = gql`
    query userPlaylists($types: [PlaylistTypeEnum!]!) {
  playlists(filters: {types: $types}) {
    ...PlaylistForList
    createdAt
  }
}
    ${PlaylistForListFragmentDoc}`;

/**
 * __useUserPlaylistsQuery__
 *
 * To run a query within a React component, call `useUserPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPlaylistsQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useUserPlaylistsQuery(baseOptions: Apollo.QueryHookOptions<UserPlaylistsQuery, UserPlaylistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPlaylistsQuery, UserPlaylistsQueryVariables>(UserPlaylistsDocument, options);
      }
export function useUserPlaylistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPlaylistsQuery, UserPlaylistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPlaylistsQuery, UserPlaylistsQueryVariables>(UserPlaylistsDocument, options);
        }
export type UserPlaylistsQueryHookResult = ReturnType<typeof useUserPlaylistsQuery>;
export type UserPlaylistsLazyQueryHookResult = ReturnType<typeof useUserPlaylistsLazyQuery>;
export type UserPlaylistsQueryResult = Apollo.QueryResult<UserPlaylistsQuery, UserPlaylistsQueryVariables>;
export const UserPlaylistsOnlyIdDocument = gql`
    query userPlaylistsOnlyId($types: [PlaylistTypeEnum!]!) {
  playlists(filters: {types: $types}) {
    id
  }
}
    `;

/**
 * __useUserPlaylistsOnlyIdQuery__
 *
 * To run a query within a React component, call `useUserPlaylistsOnlyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPlaylistsOnlyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPlaylistsOnlyIdQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useUserPlaylistsOnlyIdQuery(baseOptions: Apollo.QueryHookOptions<UserPlaylistsOnlyIdQuery, UserPlaylistsOnlyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPlaylistsOnlyIdQuery, UserPlaylistsOnlyIdQueryVariables>(UserPlaylistsOnlyIdDocument, options);
      }
export function useUserPlaylistsOnlyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPlaylistsOnlyIdQuery, UserPlaylistsOnlyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPlaylistsOnlyIdQuery, UserPlaylistsOnlyIdQueryVariables>(UserPlaylistsOnlyIdDocument, options);
        }
export type UserPlaylistsOnlyIdQueryHookResult = ReturnType<typeof useUserPlaylistsOnlyIdQuery>;
export type UserPlaylistsOnlyIdLazyQueryHookResult = ReturnType<typeof useUserPlaylistsOnlyIdLazyQuery>;
export type UserPlaylistsOnlyIdQueryResult = Apollo.QueryResult<UserPlaylistsOnlyIdQuery, UserPlaylistsOnlyIdQueryVariables>;
export const CreatePlaylistDocument = gql`
    mutation createPlaylist($input: CreatePlaylistInput!) {
  createPlaylist(input: $input) {
    id
    name
    type
    stories {
      stories {
        id
        playlists {
          id
        }
      }
    }
  }
}
    `;
export type CreatePlaylistMutationFn = Apollo.MutationFunction<CreatePlaylistMutation, CreatePlaylistMutationVariables>;

/**
 * __useCreatePlaylistMutation__
 *
 * To run a mutation, you first call `useCreatePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaylistMutation, { data, loading, error }] = useCreatePlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaylistMutation, CreatePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaylistMutation, CreatePlaylistMutationVariables>(CreatePlaylistDocument, options);
      }
export type CreatePlaylistMutationHookResult = ReturnType<typeof useCreatePlaylistMutation>;
export type CreatePlaylistMutationResult = Apollo.MutationResult<CreatePlaylistMutation>;
export type CreatePlaylistMutationOptions = Apollo.BaseMutationOptions<CreatePlaylistMutation, CreatePlaylistMutationVariables>;
export const UpdatePlaylistDocument = gql`
    mutation updatePlaylist($input: UpdatePlaylistInput!) {
  updatePlaylist(input: $input) {
    ...PlaylistDetails
  }
}
    ${PlaylistDetailsFragmentDoc}`;
export type UpdatePlaylistMutationFn = Apollo.MutationFunction<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>;

/**
 * __useUpdatePlaylistMutation__
 *
 * To run a mutation, you first call `useUpdatePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaylistMutation, { data, loading, error }] = useUpdatePlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>(UpdatePlaylistDocument, options);
      }
export type UpdatePlaylistMutationHookResult = ReturnType<typeof useUpdatePlaylistMutation>;
export type UpdatePlaylistMutationResult = Apollo.MutationResult<UpdatePlaylistMutation>;
export type UpdatePlaylistMutationOptions = Apollo.BaseMutationOptions<UpdatePlaylistMutation, UpdatePlaylistMutationVariables>;
export const PlaylistImagesDocument = gql`
    query playlistImages($showInCreationDialog: Boolean) {
  playlistImages(filters: {showInCreationDialog: $showInCreationDialog}) {
    id
    image
  }
}
    `;

/**
 * __usePlaylistImagesQuery__
 *
 * To run a query within a React component, call `usePlaylistImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistImagesQuery({
 *   variables: {
 *      showInCreationDialog: // value for 'showInCreationDialog'
 *   },
 * });
 */
export function usePlaylistImagesQuery(baseOptions?: Apollo.QueryHookOptions<PlaylistImagesQuery, PlaylistImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistImagesQuery, PlaylistImagesQueryVariables>(PlaylistImagesDocument, options);
      }
export function usePlaylistImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistImagesQuery, PlaylistImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistImagesQuery, PlaylistImagesQueryVariables>(PlaylistImagesDocument, options);
        }
export type PlaylistImagesQueryHookResult = ReturnType<typeof usePlaylistImagesQuery>;
export type PlaylistImagesLazyQueryHookResult = ReturnType<typeof usePlaylistImagesLazyQuery>;
export type PlaylistImagesQueryResult = Apollo.QueryResult<PlaylistImagesQuery, PlaylistImagesQueryVariables>;
export const DeletePLaylistDocument = gql`
    mutation deletePLaylist($input: DeletePlaylistInput!) {
  deletePlaylist(input: $input) {
    id
  }
}
    `;
export type DeletePLaylistMutationFn = Apollo.MutationFunction<DeletePLaylistMutation, DeletePLaylistMutationVariables>;

/**
 * __useDeletePLaylistMutation__
 *
 * To run a mutation, you first call `useDeletePLaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePLaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePLaylistMutation, { data, loading, error }] = useDeletePLaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePLaylistMutation(baseOptions?: Apollo.MutationHookOptions<DeletePLaylistMutation, DeletePLaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePLaylistMutation, DeletePLaylistMutationVariables>(DeletePLaylistDocument, options);
      }
export type DeletePLaylistMutationHookResult = ReturnType<typeof useDeletePLaylistMutation>;
export type DeletePLaylistMutationResult = Apollo.MutationResult<DeletePLaylistMutation>;
export type DeletePLaylistMutationOptions = Apollo.BaseMutationOptions<DeletePLaylistMutation, DeletePLaylistMutationVariables>;
export const AddStoryToPlaylistDocument = gql`
    mutation addStoryToPlaylist($input: AddStoryToPlaylistInput!) {
  addStoryToPlaylist(input: $input) {
    ...PlaylistDetails
  }
}
    ${PlaylistDetailsFragmentDoc}`;
export type AddStoryToPlaylistMutationFn = Apollo.MutationFunction<AddStoryToPlaylistMutation, AddStoryToPlaylistMutationVariables>;

/**
 * __useAddStoryToPlaylistMutation__
 *
 * To run a mutation, you first call `useAddStoryToPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStoryToPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStoryToPlaylistMutation, { data, loading, error }] = useAddStoryToPlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStoryToPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<AddStoryToPlaylistMutation, AddStoryToPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStoryToPlaylistMutation, AddStoryToPlaylistMutationVariables>(AddStoryToPlaylistDocument, options);
      }
export type AddStoryToPlaylistMutationHookResult = ReturnType<typeof useAddStoryToPlaylistMutation>;
export type AddStoryToPlaylistMutationResult = Apollo.MutationResult<AddStoryToPlaylistMutation>;
export type AddStoryToPlaylistMutationOptions = Apollo.BaseMutationOptions<AddStoryToPlaylistMutation, AddStoryToPlaylistMutationVariables>;
export const RemoveStoryFromPlaylistDocument = gql`
    mutation removeStoryFromPlaylist($input: RemoveStoryFromPlaylistInput!) {
  removeStoryFromPlaylist(input: $input) {
    ...PlaylistDetails
  }
}
    ${PlaylistDetailsFragmentDoc}`;
export type RemoveStoryFromPlaylistMutationFn = Apollo.MutationFunction<RemoveStoryFromPlaylistMutation, RemoveStoryFromPlaylistMutationVariables>;

/**
 * __useRemoveStoryFromPlaylistMutation__
 *
 * To run a mutation, you first call `useRemoveStoryFromPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStoryFromPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStoryFromPlaylistMutation, { data, loading, error }] = useRemoveStoryFromPlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveStoryFromPlaylistMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStoryFromPlaylistMutation, RemoveStoryFromPlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStoryFromPlaylistMutation, RemoveStoryFromPlaylistMutationVariables>(RemoveStoryFromPlaylistDocument, options);
      }
export type RemoveStoryFromPlaylistMutationHookResult = ReturnType<typeof useRemoveStoryFromPlaylistMutation>;
export type RemoveStoryFromPlaylistMutationResult = Apollo.MutationResult<RemoveStoryFromPlaylistMutation>;
export type RemoveStoryFromPlaylistMutationOptions = Apollo.BaseMutationOptions<RemoveStoryFromPlaylistMutation, RemoveStoryFromPlaylistMutationVariables>;
export const SavePlaylistToMyPlaylistsDocument = gql`
    mutation savePlaylistToMyPlaylists($input: SavePlaylistToMyPlaylistsInput!) {
  savePlaylistToMyPlaylists(input: $input) {
    ...PlaylistDetails
  }
}
    ${PlaylistDetailsFragmentDoc}`;
export type SavePlaylistToMyPlaylistsMutationFn = Apollo.MutationFunction<SavePlaylistToMyPlaylistsMutation, SavePlaylistToMyPlaylistsMutationVariables>;

/**
 * __useSavePlaylistToMyPlaylistsMutation__
 *
 * To run a mutation, you first call `useSavePlaylistToMyPlaylistsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlaylistToMyPlaylistsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlaylistToMyPlaylistsMutation, { data, loading, error }] = useSavePlaylistToMyPlaylistsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlaylistToMyPlaylistsMutation(baseOptions?: Apollo.MutationHookOptions<SavePlaylistToMyPlaylistsMutation, SavePlaylistToMyPlaylistsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePlaylistToMyPlaylistsMutation, SavePlaylistToMyPlaylistsMutationVariables>(SavePlaylistToMyPlaylistsDocument, options);
      }
export type SavePlaylistToMyPlaylistsMutationHookResult = ReturnType<typeof useSavePlaylistToMyPlaylistsMutation>;
export type SavePlaylistToMyPlaylistsMutationResult = Apollo.MutationResult<SavePlaylistToMyPlaylistsMutation>;
export type SavePlaylistToMyPlaylistsMutationOptions = Apollo.BaseMutationOptions<SavePlaylistToMyPlaylistsMutation, SavePlaylistToMyPlaylistsMutationVariables>;
export const CreatePortalSessionDocument = gql`
    mutation createPortalSession {
  createPortalSession {
    response
  }
}
    `;
export type CreatePortalSessionMutationFn = Apollo.MutationFunction<CreatePortalSessionMutation, CreatePortalSessionMutationVariables>;

/**
 * __useCreatePortalSessionMutation__
 *
 * To run a mutation, you first call `useCreatePortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortalSessionMutation, { data, loading, error }] = useCreatePortalSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreatePortalSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortalSessionMutation, CreatePortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortalSessionMutation, CreatePortalSessionMutationVariables>(CreatePortalSessionDocument, options);
      }
export type CreatePortalSessionMutationHookResult = ReturnType<typeof useCreatePortalSessionMutation>;
export type CreatePortalSessionMutationResult = Apollo.MutationResult<CreatePortalSessionMutation>;
export type CreatePortalSessionMutationOptions = Apollo.BaseMutationOptions<CreatePortalSessionMutation, CreatePortalSessionMutationVariables>;
export const ReactivateSubscriptionDocument = gql`
    mutation reactivateSubscription {
  reactivateSubscription {
    id
    activeSubscription {
      cancellationScheduledAt
    }
  }
}
    `;
export type ReactivateSubscriptionMutationFn = Apollo.MutationFunction<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;

/**
 * __useReactivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useReactivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSubscriptionMutation, { data, loading, error }] = useReactivateSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useReactivateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>(ReactivateSubscriptionDocument, options);
      }
export type ReactivateSubscriptionMutationHookResult = ReturnType<typeof useReactivateSubscriptionMutation>;
export type ReactivateSubscriptionMutationResult = Apollo.MutationResult<ReactivateSubscriptionMutation>;
export type ReactivateSubscriptionMutationOptions = Apollo.BaseMutationOptions<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;
export const RecentSearchesDocument = gql`
    query recentSearches {
  recentSearches(
    filters: {types: [Speaker, Tag, LanguageIntensity, Genre, ContentType]}
    pagination: {page: 0, perPage: 3}
  ) {
    __typename
    id
    ... on Tag {
      name
    }
    ... on Speaker {
      name
    }
    ... on LanguageIntensity {
      id
      slug
    }
    ... on Genre {
      id
    }
    ... on ContentType {
      id
      slug
    }
  }
}
    `;

/**
 * __useRecentSearchesQuery__
 *
 * To run a query within a React component, call `useRecentSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentSearchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentSearchesQuery(baseOptions?: Apollo.QueryHookOptions<RecentSearchesQuery, RecentSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentSearchesQuery, RecentSearchesQueryVariables>(RecentSearchesDocument, options);
      }
export function useRecentSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentSearchesQuery, RecentSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentSearchesQuery, RecentSearchesQueryVariables>(RecentSearchesDocument, options);
        }
export type RecentSearchesQueryHookResult = ReturnType<typeof useRecentSearchesQuery>;
export type RecentSearchesLazyQueryHookResult = ReturnType<typeof useRecentSearchesLazyQuery>;
export type RecentSearchesQueryResult = Apollo.QueryResult<RecentSearchesQuery, RecentSearchesQueryVariables>;
export const SaveRecentSearchDocument = gql`
    mutation saveRecentSearch($id: String!, $type: SearchResultType!) {
  saveRecentSearch(searchableId: $id, searchableType: $type)
}
    `;
export type SaveRecentSearchMutationFn = Apollo.MutationFunction<SaveRecentSearchMutation, SaveRecentSearchMutationVariables>;

/**
 * __useSaveRecentSearchMutation__
 *
 * To run a mutation, you first call `useSaveRecentSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRecentSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRecentSearchMutation, { data, loading, error }] = useSaveRecentSearchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSaveRecentSearchMutation(baseOptions?: Apollo.MutationHookOptions<SaveRecentSearchMutation, SaveRecentSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRecentSearchMutation, SaveRecentSearchMutationVariables>(SaveRecentSearchDocument, options);
      }
export type SaveRecentSearchMutationHookResult = ReturnType<typeof useSaveRecentSearchMutation>;
export type SaveRecentSearchMutationResult = Apollo.MutationResult<SaveRecentSearchMutation>;
export type SaveRecentSearchMutationOptions = Apollo.BaseMutationOptions<SaveRecentSearchMutation, SaveRecentSearchMutationVariables>;
export const RecommendedStoriesDocument = gql`
    query RecommendedStories($campaign: String!, $numberResults: Int, $distinctBySpeaker: Boolean, $storyId: ID, $genreIds: [ID], $speakerIds: [ID], $tagIds: [ID], $limitByKinkinessScore: Boolean) {
  recommendedStories(
    campaign: $campaign
    numberResults: $numberResults
    distinctBySpeaker: $distinctBySpeaker
    storyId: $storyId
    genreIds: $genreIds
    speakerIds: $speakerIds
    tagIds: $tagIds
    limitByKinkinessScore: $limitByKinkinessScore
  ) {
    recommendedStories {
      ...RecommendedStory
    }
  }
}
    ${RecommendedStoryFragmentDoc}`;

/**
 * __useRecommendedStoriesQuery__
 *
 * To run a query within a React component, call `useRecommendedStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedStoriesQuery({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      numberResults: // value for 'numberResults'
 *      distinctBySpeaker: // value for 'distinctBySpeaker'
 *      storyId: // value for 'storyId'
 *      genreIds: // value for 'genreIds'
 *      speakerIds: // value for 'speakerIds'
 *      tagIds: // value for 'tagIds'
 *      limitByKinkinessScore: // value for 'limitByKinkinessScore'
 *   },
 * });
 */
export function useRecommendedStoriesQuery(baseOptions: Apollo.QueryHookOptions<RecommendedStoriesQuery, RecommendedStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedStoriesQuery, RecommendedStoriesQueryVariables>(RecommendedStoriesDocument, options);
      }
export function useRecommendedStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedStoriesQuery, RecommendedStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedStoriesQuery, RecommendedStoriesQueryVariables>(RecommendedStoriesDocument, options);
        }
export type RecommendedStoriesQueryHookResult = ReturnType<typeof useRecommendedStoriesQuery>;
export type RecommendedStoriesLazyQueryHookResult = ReturnType<typeof useRecommendedStoriesLazyQuery>;
export type RecommendedStoriesQueryResult = Apollo.QueryResult<RecommendedStoriesQuery, RecommendedStoriesQueryVariables>;
export const RedeemOfferDocument = gql`
    mutation redeemOffer($redeemOfferInput: RedeemOfferInput!) {
  redeemOffer(redeemOfferInput: $redeemOfferInput) {
    id
    activeSubscription {
      freeTrialEndsAt
    }
  }
}
    `;
export type RedeemOfferMutationFn = Apollo.MutationFunction<RedeemOfferMutation, RedeemOfferMutationVariables>;

/**
 * __useRedeemOfferMutation__
 *
 * To run a mutation, you first call `useRedeemOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemOfferMutation, { data, loading, error }] = useRedeemOfferMutation({
 *   variables: {
 *      redeemOfferInput: // value for 'redeemOfferInput'
 *   },
 * });
 */
export function useRedeemOfferMutation(baseOptions?: Apollo.MutationHookOptions<RedeemOfferMutation, RedeemOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemOfferMutation, RedeemOfferMutationVariables>(RedeemOfferDocument, options);
      }
export type RedeemOfferMutationHookResult = ReturnType<typeof useRedeemOfferMutation>;
export type RedeemOfferMutationResult = Apollo.MutationResult<RedeemOfferMutation>;
export type RedeemOfferMutationOptions = Apollo.BaseMutationOptions<RedeemOfferMutation, RedeemOfferMutationVariables>;
export const SavePostPurchaseSurveyAnswerDocument = gql`
    mutation SavePostPurchaseSurveyAnswer($answer: String, $key: String!, $planName: String!, $position: Int!, $subscriptionId: String) {
  savePostPurchaseSurveyAnswer(
    answer: $answer
    key: $key
    planName: $planName
    position: $position
    subscriptionId: $subscriptionId
  )
}
    `;
export type SavePostPurchaseSurveyAnswerMutationFn = Apollo.MutationFunction<SavePostPurchaseSurveyAnswerMutation, SavePostPurchaseSurveyAnswerMutationVariables>;

/**
 * __useSavePostPurchaseSurveyAnswerMutation__
 *
 * To run a mutation, you first call `useSavePostPurchaseSurveyAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePostPurchaseSurveyAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePostPurchaseSurveyAnswerMutation, { data, loading, error }] = useSavePostPurchaseSurveyAnswerMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *      key: // value for 'key'
 *      planName: // value for 'planName'
 *      position: // value for 'position'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSavePostPurchaseSurveyAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SavePostPurchaseSurveyAnswerMutation, SavePostPurchaseSurveyAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePostPurchaseSurveyAnswerMutation, SavePostPurchaseSurveyAnswerMutationVariables>(SavePostPurchaseSurveyAnswerDocument, options);
      }
export type SavePostPurchaseSurveyAnswerMutationHookResult = ReturnType<typeof useSavePostPurchaseSurveyAnswerMutation>;
export type SavePostPurchaseSurveyAnswerMutationResult = Apollo.MutationResult<SavePostPurchaseSurveyAnswerMutation>;
export type SavePostPurchaseSurveyAnswerMutationOptions = Apollo.BaseMutationOptions<SavePostPurchaseSurveyAnswerMutation, SavePostPurchaseSurveyAnswerMutationVariables>;
export const SegmentDocument = gql`
    mutation segment($input: SegmentInput!) {
  segmentTrack(input: $input)
}
    `;
export type SegmentMutationFn = Apollo.MutationFunction<SegmentMutation, SegmentMutationVariables>;

/**
 * __useSegmentMutation__
 *
 * To run a mutation, you first call `useSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [segmentMutation, { data, loading, error }] = useSegmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSegmentMutation(baseOptions?: Apollo.MutationHookOptions<SegmentMutation, SegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SegmentMutation, SegmentMutationVariables>(SegmentDocument, options);
      }
export type SegmentMutationHookResult = ReturnType<typeof useSegmentMutation>;
export type SegmentMutationResult = Apollo.MutationResult<SegmentMutation>;
export type SegmentMutationOptions = Apollo.BaseMutationOptions<SegmentMutation, SegmentMutationVariables>;
export const SetStoryMarketsDocument = gql`
    mutation setStoryMarkets($storyMarkets: [Market!]!) {
  setStoryMarkets(input: $storyMarkets) {
    id
    storyMarkets
  }
}
    `;
export type SetStoryMarketsMutationFn = Apollo.MutationFunction<SetStoryMarketsMutation, SetStoryMarketsMutationVariables>;

/**
 * __useSetStoryMarketsMutation__
 *
 * To run a mutation, you first call `useSetStoryMarketsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStoryMarketsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStoryMarketsMutation, { data, loading, error }] = useSetStoryMarketsMutation({
 *   variables: {
 *      storyMarkets: // value for 'storyMarkets'
 *   },
 * });
 */
export function useSetStoryMarketsMutation(baseOptions?: Apollo.MutationHookOptions<SetStoryMarketsMutation, SetStoryMarketsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStoryMarketsMutation, SetStoryMarketsMutationVariables>(SetStoryMarketsDocument, options);
      }
export type SetStoryMarketsMutationHookResult = ReturnType<typeof useSetStoryMarketsMutation>;
export type SetStoryMarketsMutationResult = Apollo.MutationResult<SetStoryMarketsMutation>;
export type SetStoryMarketsMutationOptions = Apollo.BaseMutationOptions<SetStoryMarketsMutation, SetStoryMarketsMutationVariables>;
export const SpeakersDocument = gql`
    query speakers($speakerFilters: SpeakerFilters, $orderOptions: [SpeakerOrder], $pagination: Pagination) {
  speakers: speakers(
    speakerFilters: $speakerFilters
    orderOptions: $orderOptions
    pagination: $pagination
  ) {
    speakers {
      ...SpeakerSummary
    }
  }
}
    ${SpeakerSummaryFragmentDoc}`;

/**
 * __useSpeakersQuery__
 *
 * To run a query within a React component, call `useSpeakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpeakersQuery({
 *   variables: {
 *      speakerFilters: // value for 'speakerFilters'
 *      orderOptions: // value for 'orderOptions'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSpeakersQuery(baseOptions?: Apollo.QueryHookOptions<SpeakersQuery, SpeakersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpeakersQuery, SpeakersQueryVariables>(SpeakersDocument, options);
      }
export function useSpeakersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpeakersQuery, SpeakersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpeakersQuery, SpeakersQueryVariables>(SpeakersDocument, options);
        }
export type SpeakersQueryHookResult = ReturnType<typeof useSpeakersQuery>;
export type SpeakersLazyQueryHookResult = ReturnType<typeof useSpeakersLazyQuery>;
export type SpeakersQueryResult = Apollo.QueryResult<SpeakersQuery, SpeakersQueryVariables>;
export const StoreOnboardingResponsesDocument = gql`
    mutation StoreOnboardingResponses($serializedResponses: String!) {
  storeOnboardingResponses(serializedResponses: $serializedResponses)
}
    `;
export type StoreOnboardingResponsesMutationFn = Apollo.MutationFunction<StoreOnboardingResponsesMutation, StoreOnboardingResponsesMutationVariables>;

/**
 * __useStoreOnboardingResponsesMutation__
 *
 * To run a mutation, you first call `useStoreOnboardingResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreOnboardingResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeOnboardingResponsesMutation, { data, loading, error }] = useStoreOnboardingResponsesMutation({
 *   variables: {
 *      serializedResponses: // value for 'serializedResponses'
 *   },
 * });
 */
export function useStoreOnboardingResponsesMutation(baseOptions?: Apollo.MutationHookOptions<StoreOnboardingResponsesMutation, StoreOnboardingResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreOnboardingResponsesMutation, StoreOnboardingResponsesMutationVariables>(StoreOnboardingResponsesDocument, options);
      }
export type StoreOnboardingResponsesMutationHookResult = ReturnType<typeof useStoreOnboardingResponsesMutation>;
export type StoreOnboardingResponsesMutationResult = Apollo.MutationResult<StoreOnboardingResponsesMutation>;
export type StoreOnboardingResponsesMutationOptions = Apollo.BaseMutationOptions<StoreOnboardingResponsesMutation, StoreOnboardingResponsesMutationVariables>;
export const StoriesForTileWithStoriesTotalCountDocument = gql`
    query storiesForTileWithStoriesTotalCount($pagination: Pagination, $order: StoryOrder, $filterSelection: FilterSelection) {
  stories(
    pagination: $pagination
    order: $order
    filterSelection: $filterSelection
  ) {
    stories {
      ...StoryTile
    }
    totalCount
  }
}
    ${StoryTileFragmentDoc}`;

/**
 * __useStoriesForTileWithStoriesTotalCountQuery__
 *
 * To run a query within a React component, call `useStoriesForTileWithStoriesTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesForTileWithStoriesTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesForTileWithStoriesTotalCountQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *      filterSelection: // value for 'filterSelection'
 *   },
 * });
 */
export function useStoriesForTileWithStoriesTotalCountQuery(baseOptions?: Apollo.QueryHookOptions<StoriesForTileWithStoriesTotalCountQuery, StoriesForTileWithStoriesTotalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoriesForTileWithStoriesTotalCountQuery, StoriesForTileWithStoriesTotalCountQueryVariables>(StoriesForTileWithStoriesTotalCountDocument, options);
      }
export function useStoriesForTileWithStoriesTotalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoriesForTileWithStoriesTotalCountQuery, StoriesForTileWithStoriesTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoriesForTileWithStoriesTotalCountQuery, StoriesForTileWithStoriesTotalCountQueryVariables>(StoriesForTileWithStoriesTotalCountDocument, options);
        }
export type StoriesForTileWithStoriesTotalCountQueryHookResult = ReturnType<typeof useStoriesForTileWithStoriesTotalCountQuery>;
export type StoriesForTileWithStoriesTotalCountLazyQueryHookResult = ReturnType<typeof useStoriesForTileWithStoriesTotalCountLazyQuery>;
export type StoriesForTileWithStoriesTotalCountQueryResult = Apollo.QueryResult<StoriesForTileWithStoriesTotalCountQuery, StoriesForTileWithStoriesTotalCountQueryVariables>;
export const StoriesForTileDocument = gql`
    query storiesForTile($pagination: Pagination, $order: StoryOrder, $filterSelection: FilterSelection) {
  stories(
    pagination: $pagination
    order: $order
    filterSelection: $filterSelection
  ) {
    stories {
      ...StoryTile
    }
  }
}
    ${StoryTileFragmentDoc}`;

/**
 * __useStoriesForTileQuery__
 *
 * To run a query within a React component, call `useStoriesForTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesForTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesForTileQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *      filterSelection: // value for 'filterSelection'
 *   },
 * });
 */
export function useStoriesForTileQuery(baseOptions?: Apollo.QueryHookOptions<StoriesForTileQuery, StoriesForTileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoriesForTileQuery, StoriesForTileQueryVariables>(StoriesForTileDocument, options);
      }
export function useStoriesForTileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoriesForTileQuery, StoriesForTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoriesForTileQuery, StoriesForTileQueryVariables>(StoriesForTileDocument, options);
        }
export type StoriesForTileQueryHookResult = ReturnType<typeof useStoriesForTileQuery>;
export type StoriesForTileLazyQueryHookResult = ReturnType<typeof useStoriesForTileLazyQuery>;
export type StoriesForTileQueryResult = Apollo.QueryResult<StoriesForTileQuery, StoriesForTileQueryVariables>;
export const ThreeSixtyStoriesDocument = gql`
    query threeSixtyStories($excludeAlreadyListened: Boolean = false, $order: StoryOrder = {orderBy: RELEASE_DATE, order: DESC}) {
  stories(
    filterSelection: {isThreeSixtyStory: true, excludeAlreadyListened: $excludeAlreadyListened}
    order: $order
  ) {
    stories {
      ...ThreeSixtyStoryForTile
    }
  }
}
    ${ThreeSixtyStoryForTileFragmentDoc}`;

/**
 * __useThreeSixtyStoriesQuery__
 *
 * To run a query within a React component, call `useThreeSixtyStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreeSixtyStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreeSixtyStoriesQuery({
 *   variables: {
 *      excludeAlreadyListened: // value for 'excludeAlreadyListened'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useThreeSixtyStoriesQuery(baseOptions?: Apollo.QueryHookOptions<ThreeSixtyStoriesQuery, ThreeSixtyStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreeSixtyStoriesQuery, ThreeSixtyStoriesQueryVariables>(ThreeSixtyStoriesDocument, options);
      }
export function useThreeSixtyStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreeSixtyStoriesQuery, ThreeSixtyStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreeSixtyStoriesQuery, ThreeSixtyStoriesQueryVariables>(ThreeSixtyStoriesDocument, options);
        }
export type ThreeSixtyStoriesQueryHookResult = ReturnType<typeof useThreeSixtyStoriesQuery>;
export type ThreeSixtyStoriesLazyQueryHookResult = ReturnType<typeof useThreeSixtyStoriesLazyQuery>;
export type ThreeSixtyStoriesQueryResult = Apollo.QueryResult<ThreeSixtyStoriesQuery, ThreeSixtyStoriesQueryVariables>;
export const ThreeSixtyStoriesWithPaginationDocument = gql`
    query threeSixtyStoriesWithPagination($excludeAlreadyListened: Boolean = false, $pagination: Pagination, $order: StoryOrder = {orderBy: RELEASE_DATE, order: DESC}) {
  stories(
    filterSelection: {isThreeSixtyStory: true, excludeAlreadyListened: $excludeAlreadyListened}
    order: $order
    pagination: $pagination
  ) {
    stories {
      ...ThreeSixtyStoryForTile
    }
    totalCount
  }
}
    ${ThreeSixtyStoryForTileFragmentDoc}`;

/**
 * __useThreeSixtyStoriesWithPaginationQuery__
 *
 * To run a query within a React component, call `useThreeSixtyStoriesWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreeSixtyStoriesWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreeSixtyStoriesWithPaginationQuery({
 *   variables: {
 *      excludeAlreadyListened: // value for 'excludeAlreadyListened'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useThreeSixtyStoriesWithPaginationQuery(baseOptions?: Apollo.QueryHookOptions<ThreeSixtyStoriesWithPaginationQuery, ThreeSixtyStoriesWithPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreeSixtyStoriesWithPaginationQuery, ThreeSixtyStoriesWithPaginationQueryVariables>(ThreeSixtyStoriesWithPaginationDocument, options);
      }
export function useThreeSixtyStoriesWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreeSixtyStoriesWithPaginationQuery, ThreeSixtyStoriesWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreeSixtyStoriesWithPaginationQuery, ThreeSixtyStoriesWithPaginationQueryVariables>(ThreeSixtyStoriesWithPaginationDocument, options);
        }
export type ThreeSixtyStoriesWithPaginationQueryHookResult = ReturnType<typeof useThreeSixtyStoriesWithPaginationQuery>;
export type ThreeSixtyStoriesWithPaginationLazyQueryHookResult = ReturnType<typeof useThreeSixtyStoriesWithPaginationLazyQuery>;
export type ThreeSixtyStoriesWithPaginationQueryResult = Apollo.QueryResult<ThreeSixtyStoriesWithPaginationQuery, ThreeSixtyStoriesWithPaginationQueryVariables>;
export const SubmittedPostPurchaseSurveyDocument = gql`
    query submittedPostPurchaseSurvey {
  me {
    submittedPostPurchaseSurvey
  }
}
    `;

/**
 * __useSubmittedPostPurchaseSurveyQuery__
 *
 * To run a query within a React component, call `useSubmittedPostPurchaseSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmittedPostPurchaseSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmittedPostPurchaseSurveyQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubmittedPostPurchaseSurveyQuery(baseOptions?: Apollo.QueryHookOptions<SubmittedPostPurchaseSurveyQuery, SubmittedPostPurchaseSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmittedPostPurchaseSurveyQuery, SubmittedPostPurchaseSurveyQueryVariables>(SubmittedPostPurchaseSurveyDocument, options);
      }
export function useSubmittedPostPurchaseSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmittedPostPurchaseSurveyQuery, SubmittedPostPurchaseSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmittedPostPurchaseSurveyQuery, SubmittedPostPurchaseSurveyQueryVariables>(SubmittedPostPurchaseSurveyDocument, options);
        }
export type SubmittedPostPurchaseSurveyQueryHookResult = ReturnType<typeof useSubmittedPostPurchaseSurveyQuery>;
export type SubmittedPostPurchaseSurveyLazyQueryHookResult = ReturnType<typeof useSubmittedPostPurchaseSurveyLazyQuery>;
export type SubmittedPostPurchaseSurveyQueryResult = Apollo.QueryResult<SubmittedPostPurchaseSurveyQuery, SubmittedPostPurchaseSurveyQueryVariables>;
export const SubscribeToNewsletterDocument = gql`
    mutation subscribeToNewsletter($email: String!, $campaign: NewsletterList!) {
  subscribeToNewsletter(email: $email, campaign: $campaign)
}
    `;
export type SubscribeToNewsletterMutationFn = Apollo.MutationFunction<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;

/**
 * __useSubscribeToNewsletterMutation__
 *
 * To run a mutation, you first call `useSubscribeToNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToNewsletterMutation, { data, loading, error }] = useSubscribeToNewsletterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      campaign: // value for 'campaign'
 *   },
 * });
 */
export function useSubscribeToNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>(SubscribeToNewsletterDocument, options);
      }
export type SubscribeToNewsletterMutationHookResult = ReturnType<typeof useSubscribeToNewsletterMutation>;
export type SubscribeToNewsletterMutationResult = Apollo.MutationResult<SubscribeToNewsletterMutation>;
export type SubscribeToNewsletterMutationOptions = Apollo.BaseMutationOptions<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>;
export const TagForDetailsPageDocument = gql`
    query tagForDetailsPage($tagId: ID!) {
  tag(tagId: $tagId) {
    ...TagForDetailsPage
  }
}
    ${TagForDetailsPageFragmentDoc}`;

/**
 * __useTagForDetailsPageQuery__
 *
 * To run a query within a React component, call `useTagForDetailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagForDetailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagForDetailsPageQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useTagForDetailsPageQuery(baseOptions: Apollo.QueryHookOptions<TagForDetailsPageQuery, TagForDetailsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagForDetailsPageQuery, TagForDetailsPageQueryVariables>(TagForDetailsPageDocument, options);
      }
export function useTagForDetailsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagForDetailsPageQuery, TagForDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagForDetailsPageQuery, TagForDetailsPageQueryVariables>(TagForDetailsPageDocument, options);
        }
export type TagForDetailsPageQueryHookResult = ReturnType<typeof useTagForDetailsPageQuery>;
export type TagForDetailsPageLazyQueryHookResult = ReturnType<typeof useTagForDetailsPageLazyQuery>;
export type TagForDetailsPageQueryResult = Apollo.QueryResult<TagForDetailsPageQuery, TagForDetailsPageQueryVariables>;
export const ToggleLoveSpeakerDocument = gql`
    mutation ToggleLoveSpeaker($speakerId: ID!) {
  toggleLoveSpeaker(input: {speakerId: $speakerId}) {
    __typename
    id
    loved
  }
}
    `;
export type ToggleLoveSpeakerMutationFn = Apollo.MutationFunction<ToggleLoveSpeakerMutation, ToggleLoveSpeakerMutationVariables>;

/**
 * __useToggleLoveSpeakerMutation__
 *
 * To run a mutation, you first call `useToggleLoveSpeakerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLoveSpeakerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLoveSpeakerMutation, { data, loading, error }] = useToggleLoveSpeakerMutation({
 *   variables: {
 *      speakerId: // value for 'speakerId'
 *   },
 * });
 */
export function useToggleLoveSpeakerMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLoveSpeakerMutation, ToggleLoveSpeakerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLoveSpeakerMutation, ToggleLoveSpeakerMutationVariables>(ToggleLoveSpeakerDocument, options);
      }
export type ToggleLoveSpeakerMutationHookResult = ReturnType<typeof useToggleLoveSpeakerMutation>;
export type ToggleLoveSpeakerMutationResult = Apollo.MutationResult<ToggleLoveSpeakerMutation>;
export type ToggleLoveSpeakerMutationOptions = Apollo.BaseMutationOptions<ToggleLoveSpeakerMutation, ToggleLoveSpeakerMutationVariables>;
export const ToggleLoveStoryDocument = gql`
    mutation ToggleLoveStory($storyId: ID!) {
  toggleLoveStory(input: {storyId: $storyId}) {
    id
    loved
  }
}
    `;
export type ToggleLoveStoryMutationFn = Apollo.MutationFunction<ToggleLoveStoryMutation, ToggleLoveStoryMutationVariables>;

/**
 * __useToggleLoveStoryMutation__
 *
 * To run a mutation, you first call `useToggleLoveStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLoveStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLoveStoryMutation, { data, loading, error }] = useToggleLoveStoryMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useToggleLoveStoryMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLoveStoryMutation, ToggleLoveStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLoveStoryMutation, ToggleLoveStoryMutationVariables>(ToggleLoveStoryDocument, options);
      }
export type ToggleLoveStoryMutationHookResult = ReturnType<typeof useToggleLoveStoryMutation>;
export type ToggleLoveStoryMutationResult = Apollo.MutationResult<ToggleLoveStoryMutation>;
export type ToggleLoveStoryMutationOptions = Apollo.BaseMutationOptions<ToggleLoveStoryMutation, ToggleLoveStoryMutationVariables>;
export const UpdateTimeStoppedDocument = gql`
    mutation UpdateTimeStopped($storyId: ID!, $timeStopped: Int!) {
  updateTimeStopped(input: {storyId: $storyId, timeStopped: $timeStopped}) {
    id
  }
}
    `;
export type UpdateTimeStoppedMutationFn = Apollo.MutationFunction<UpdateTimeStoppedMutation, UpdateTimeStoppedMutationVariables>;

/**
 * __useUpdateTimeStoppedMutation__
 *
 * To run a mutation, you first call `useUpdateTimeStoppedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeStoppedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeStoppedMutation, { data, loading, error }] = useUpdateTimeStoppedMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      timeStopped: // value for 'timeStopped'
 *   },
 * });
 */
export function useUpdateTimeStoppedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeStoppedMutation, UpdateTimeStoppedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeStoppedMutation, UpdateTimeStoppedMutationVariables>(UpdateTimeStoppedDocument, options);
      }
export type UpdateTimeStoppedMutationHookResult = ReturnType<typeof useUpdateTimeStoppedMutation>;
export type UpdateTimeStoppedMutationResult = Apollo.MutationResult<UpdateTimeStoppedMutation>;
export type UpdateTimeStoppedMutationOptions = Apollo.BaseMutationOptions<UpdateTimeStoppedMutation, UpdateTimeStoppedMutationVariables>;
export const UserNotificationsDocument = gql`
    query userNotifications {
  userNotifications {
    ...UserNotification
  }
}
    ${UserNotificationFragmentDoc}`;

/**
 * __useUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
      }
export function useUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationsQuery, UserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationsQuery, UserNotificationsQueryVariables>(UserNotificationsDocument, options);
        }
export type UserNotificationsQueryHookResult = ReturnType<typeof useUserNotificationsQuery>;
export type UserNotificationsLazyQueryHookResult = ReturnType<typeof useUserNotificationsLazyQuery>;
export type UserNotificationsQueryResult = Apollo.QueryResult<UserNotificationsQuery, UserNotificationsQueryVariables>;
export const SetNotificationShownDocument = gql`
    mutation setNotificationShown($notificationType: NotificationType!) {
  setNotificationShown(input: {notificationType: $notificationType}) {
    ...UserNotification
  }
}
    ${UserNotificationFragmentDoc}`;
export type SetNotificationShownMutationFn = Apollo.MutationFunction<SetNotificationShownMutation, SetNotificationShownMutationVariables>;

/**
 * __useSetNotificationShownMutation__
 *
 * To run a mutation, you first call `useSetNotificationShownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationShownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationShownMutation, { data, loading, error }] = useSetNotificationShownMutation({
 *   variables: {
 *      notificationType: // value for 'notificationType'
 *   },
 * });
 */
export function useSetNotificationShownMutation(baseOptions?: Apollo.MutationHookOptions<SetNotificationShownMutation, SetNotificationShownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotificationShownMutation, SetNotificationShownMutationVariables>(SetNotificationShownDocument, options);
      }
export type SetNotificationShownMutationHookResult = ReturnType<typeof useSetNotificationShownMutation>;
export type SetNotificationShownMutationResult = Apollo.MutationResult<SetNotificationShownMutation>;
export type SetNotificationShownMutationOptions = Apollo.BaseMutationOptions<SetNotificationShownMutation, SetNotificationShownMutationVariables>;
export const SetUserPreferencesDocument = gql`
    mutation setUserPreferences($userPreferences: UserPreferencesInput!) {
  setUserPreferences(input: $userPreferences) {
    hideAlreadyListened
  }
}
    `;
export type SetUserPreferencesMutationFn = Apollo.MutationFunction<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>;

/**
 * __useSetUserPreferencesMutation__
 *
 * To run a mutation, you first call `useSetUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserPreferencesMutation, { data, loading, error }] = useSetUserPreferencesMutation({
 *   variables: {
 *      userPreferences: // value for 'userPreferences'
 *   },
 * });
 */
export function useSetUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>(SetUserPreferencesDocument, options);
      }
export type SetUserPreferencesMutationHookResult = ReturnType<typeof useSetUserPreferencesMutation>;
export type SetUserPreferencesMutationResult = Apollo.MutationResult<SetUserPreferencesMutation>;
export type SetUserPreferencesMutationOptions = Apollo.BaseMutationOptions<SetUserPreferencesMutation, SetUserPreferencesMutationVariables>;
export const UserSubscriptionInfoDocument = gql`
    query userSubscriptionInfo {
  me {
    id
    activeSubscription {
      ...ActiveSubscription
      billingPeriod {
        period
        unit
      }
      scheduledChanges {
        billingPeriod {
          period
          unit
        }
      }
      coupons {
        id
        discountPercentage
        discountAmount
        currencyCode
        discountType
        durationType
      }
    }
  }
}
    ${ActiveSubscriptionFragmentDoc}`;

/**
 * __useUserSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useUserSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscriptionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSubscriptionInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserSubscriptionInfoQuery, UserSubscriptionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSubscriptionInfoQuery, UserSubscriptionInfoQueryVariables>(UserSubscriptionInfoDocument, options);
      }
export function useUserSubscriptionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSubscriptionInfoQuery, UserSubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSubscriptionInfoQuery, UserSubscriptionInfoQueryVariables>(UserSubscriptionInfoDocument, options);
        }
export type UserSubscriptionInfoQueryHookResult = ReturnType<typeof useUserSubscriptionInfoQuery>;
export type UserSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useUserSubscriptionInfoLazyQuery>;
export type UserSubscriptionInfoQueryResult = Apollo.QueryResult<UserSubscriptionInfoQuery, UserSubscriptionInfoQueryVariables>;

export const anAccent = (overrides?: Partial<Accent>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Accent' } & Accent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Accent');
    return {
        __typename: 'Accent',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ecacaf1b-fc73-4c42-ad99-b3eb83e4fe90',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cernuus',
    };
};

export const anAddStoryToPlaylistInput = (overrides?: Partial<AddStoryToPlaylistInput>, _relationshipsToOmit: Set<string> = new Set()): AddStoryToPlaylistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddStoryToPlaylistInput');
    return {
        playlistId: overrides && overrides.hasOwnProperty('playlistId') ? overrides.playlistId! : '59e22122-cd88-4da6-bea8-0fd91f679e90',
        storyId: overrides && overrides.hasOwnProperty('storyId') ? overrides.storyId! : '1955144f-72f3-46e3-8bf7-31c079473146',
    };
};

export const aBillingPeriod = (overrides?: Partial<BillingPeriod>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BillingPeriod' } & BillingPeriod => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BillingPeriod');
    return {
        __typename: 'BillingPeriod',
        currencyCode: overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'conatus',
        period: overrides && overrides.hasOwnProperty('period') ? overrides.period! : 3262,
        price: overrides && overrides.hasOwnProperty('price') ? overrides.price! : 7692,
        unit: overrides && overrides.hasOwnProperty('unit') ? overrides.unit! : 'aranea',
    };
};

export const aContentDrop = (overrides?: Partial<ContentDrop>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ContentDrop' } & ContentDrop => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ContentDrop');
    return {
        __typename: 'ContentDrop',
        backgroundColor: overrides && overrides.hasOwnProperty('backgroundColor') ? overrides.backgroundColor! : 'volubilis',
        content: overrides && overrides.hasOwnProperty('content') ? overrides.content! : [relationshipsToOmit.has('ContentDropContent') ? {} as ContentDropContent : aContentDropContent({}, relationshipsToOmit)],
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'summisse',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7104cc60-0d2d-4257-bcac-d6baa0004770',
        image: overrides && overrides.hasOwnProperty('image') ? overrides.image! : 'statua',
        textColor: overrides && overrides.hasOwnProperty('textColor') ? overrides.textColor! : 'adulatio',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'carbo',
    };
};

export const aContentDropContent = (overrides?: Partial<ContentDropContent>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ContentDropContent' } & ContentDropContent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ContentDropContent');
    return {
        __typename: 'ContentDropContent',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3b0d481b-8712-4533-a03f-a5e5bc3aec7f',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'ventus',
    };
};

export const aContentType = (overrides?: Partial<ContentType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ContentType' } & ContentType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ContentType');
    return {
        __typename: 'ContentType',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9ec356bf-b0d3-4b3d-8273-f89803483699',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vigilo',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'laborum',
    };
};

export const aCoupon = (overrides?: Partial<Coupon>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Coupon' } & Coupon => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Coupon');
    return {
        __typename: 'Coupon',
        currencyCode: overrides && overrides.hasOwnProperty('currencyCode') ? overrides.currencyCode! : 'sum',
        discountAmount: overrides && overrides.hasOwnProperty('discountAmount') ? overrides.discountAmount! : 5184,
        discountPercentage: overrides && overrides.hasOwnProperty('discountPercentage') ? overrides.discountPercentage! : 8.9,
        discountType: overrides && overrides.hasOwnProperty('discountType') ? overrides.discountType! : 'xiphias',
        durationType: overrides && overrides.hasOwnProperty('durationType') ? overrides.durationType! : 'venustas',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'vigilo',
    };
};

export const aCreatePlaylistInput = (overrides?: Partial<CreatePlaylistInput>, _relationshipsToOmit: Set<string> = new Set()): CreatePlaylistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreatePlaylistInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'antiquus',
        playlistImageId: overrides && overrides.hasOwnProperty('playlistImageId') ? overrides.playlistImageId! : '6ce720d8-79eb-4700-a3bb-67e31779e941',
        storiesIds: overrides && overrides.hasOwnProperty('storiesIds') ? overrides.storiesIds! : ['cc21f2d9-b435-40be-a698-d7dbb12b72d9'],
    };
};

export const aDeletePlaylistInput = (overrides?: Partial<DeletePlaylistInput>, _relationshipsToOmit: Set<string> = new Set()): DeletePlaylistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeletePlaylistInput');
    return {
        playlistId: overrides && overrides.hasOwnProperty('playlistId') ? overrides.playlistId! : '92812913-e999-4b98-b58f-58f1bef66884',
    };
};

export const aDuration = (overrides?: Partial<Duration>, _relationshipsToOmit: Set<string> = new Set()): Duration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Duration');
    return {
        durationAbove: overrides && overrides.hasOwnProperty('durationAbove') ? overrides.durationAbove! : 4889,
        durationBelow: overrides && overrides.hasOwnProperty('durationBelow') ? overrides.durationBelow! : 3873,
    };
};

export const aFeatureFlag = (overrides?: Partial<FeatureFlag>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FeatureFlag' } & FeatureFlag => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FeatureFlag');
    return {
        __typename: 'FeatureFlag',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        featureName: overrides && overrides.hasOwnProperty('featureName') ? overrides.featureName! : 'doloremque',
    };
};

export const aFilterSelection = (overrides?: Partial<FilterSelection>, _relationshipsToOmit: Set<string> = new Set()): FilterSelection => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FilterSelection');
    return {
        alreadyListened: overrides && overrides.hasOwnProperty('alreadyListened') ? overrides.alreadyListened! : false,
        contentTypeSlugs: overrides && overrides.hasOwnProperty('contentTypeSlugs') ? overrides.contentTypeSlugs! : ['ceno'],
        duration: overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : relationshipsToOmit.has('Duration') ? {} as Duration : aDuration({}, relationshipsToOmit),
        excludeAlreadyListened: overrides && overrides.hasOwnProperty('excludeAlreadyListened') ? overrides.excludeAlreadyListened! : false,
        excludeFemtasyRed: overrides && overrides.hasOwnProperty('excludeFemtasyRed') ? overrides.excludeFemtasyRed! : false,
        genreIds: overrides && overrides.hasOwnProperty('genreIds') ? overrides.genreIds! : ['f648aa15-281e-4883-a88e-0b5de1f81e23'],
        isThreeSixtyStory: overrides && overrides.hasOwnProperty('isThreeSixtyStory') ? overrides.isThreeSixtyStory! : false,
        languageIntensityIds: overrides && overrides.hasOwnProperty('languageIntensityIds') ? overrides.languageIntensityIds! : ['a008c00f-2ca1-4969-bf23-0d5f0b65d340'],
        lovedStories: overrides && overrides.hasOwnProperty('lovedStories') ? overrides.lovedStories! : false,
        markets: overrides && overrides.hasOwnProperty('markets') ? overrides.markets! : [Market.De],
        onlyLoved: overrides && overrides.hasOwnProperty('onlyLoved') ? overrides.onlyLoved! : true,
        participantTypes: overrides && overrides.hasOwnProperty('participantTypes') ? overrides.participantTypes! : [ParticipantType.Anonym],
        seriesIds: overrides && overrides.hasOwnProperty('seriesIds') ? overrides.seriesIds! : ['1d7946a5-5028-4562-ad82-79a71f0f8888'],
        speakerGender: overrides && overrides.hasOwnProperty('speakerGender') ? overrides.speakerGender! : Gender.Diverse,
        speakerIds: overrides && overrides.hasOwnProperty('speakerIds') ? overrides.speakerIds! : ['c997d16b-eae6-47cd-8839-927fb40380a6'],
        storiesFromLovedSpeakers: overrides && overrides.hasOwnProperty('storiesFromLovedSpeakers') ? overrides.storiesFromLovedSpeakers! : false,
        storyIds: overrides && overrides.hasOwnProperty('storyIds') ? overrides.storyIds! : ['63b5c741-73e0-466c-a7ed-2ecf0589b811'],
        tagIds: overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['a21b8d89-2041-485d-a48a-32e72e4a6f51'],
        tagIdsByOr: overrides && overrides.hasOwnProperty('tagIdsByOr') ? overrides.tagIdsByOr! : ['25c8a836-7d6c-4520-bb22-11724d59e386'],
    };
};

export const aGenre = (overrides?: Partial<Genre>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Genre' } & Genre => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Genre');
    return {
        __typename: 'Genre',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'desparatus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'brevis',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bd7e6058-f5ab-44bd-9e71-91d19bce8f14',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'civitas',
        storiesCount: overrides && overrides.hasOwnProperty('storiesCount') ? overrides.storiesCount! : 5995,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'strues',
    };
};

export const anInfluencerCode = (overrides?: Partial<InfluencerCode>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InfluencerCode' } & InfluencerCode => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InfluencerCode');
    return {
        __typename: 'InfluencerCode',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sumptus',
        discountCode: overrides && overrides.hasOwnProperty('discountCode') ? overrides.discountCode! : 'tibi',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e8b9642d-0aa0-4ce2-b1c1-e12d61c6bc77',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'taedium',
        utmCampaign: overrides && overrides.hasOwnProperty('utmCampaign') ? overrides.utmCampaign! : 'peior',
    };
};

export const aJourney = (overrides?: Partial<Journey>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Journey' } & Journey => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Journey');
    return {
        __typename: 'Journey',
        backgroundGradientBottom: overrides && overrides.hasOwnProperty('backgroundGradientBottom') ? overrides.backgroundGradientBottom! : 'vivo',
        backgroundGradientTop: overrides && overrides.hasOwnProperty('backgroundGradientTop') ? overrides.backgroundGradientTop! : 'votum',
        completionMessage: overrides && overrides.hasOwnProperty('completionMessage') ? overrides.completionMessage! : 'tabgo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'acidus',
        headerIllustration: overrides && overrides.hasOwnProperty('headerIllustration') ? overrides.headerIllustration! : 'desidero',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '312de30f-5627-4e47-8dc1-22138ff647a9',
        illustration: overrides && overrides.hasOwnProperty('illustration') ? overrides.illustration! : 'toties',
        languageIntensity: overrides && overrides.hasOwnProperty('languageIntensity') ? overrides.languageIntensity! : relationshipsToOmit.has('LanguageIntensity') ? {} as LanguageIntensity : aLanguageIntensity({}, relationshipsToOmit),
        longTitle: overrides && overrides.hasOwnProperty('longTitle') ? overrides.longTitle! : 'debilito',
        releaseDate: overrides && overrides.hasOwnProperty('releaseDate') ? overrides.releaseDate! : 'aspicio',
        stories: overrides && overrides.hasOwnProperty('stories') ? overrides.stories! : relationshipsToOmit.has('StoriesResponse') ? {} as StoriesResponse : aStoriesResponse({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        teaser: overrides && overrides.hasOwnProperty('teaser') ? overrides.teaser! : 'tabernus',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'vox',
        transcodedTeaserUrl: overrides && overrides.hasOwnProperty('transcodedTeaserUrl') ? overrides.transcodedTeaserUrl! : 'depraedor',
    };
};

export const aJourneyFilters = (overrides?: Partial<JourneyFilters>, _relationshipsToOmit: Set<string> = new Set()): JourneyFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('JourneyFilters');
    return {
        journeyIds: overrides && overrides.hasOwnProperty('journeyIds') ? overrides.journeyIds! : ['a91966df-5186-4657-84ea-a77a3529558a'],
    };
};

export const aKlaviyoForm = (overrides?: Partial<KlaviyoForm>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'KlaviyoForm' } & KlaviyoForm => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('KlaviyoForm');
    return {
        __typename: 'KlaviyoForm',
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        displayUrl: overrides && overrides.hasOwnProperty('displayUrl') ? overrides.displayUrl! : 'vergo',
        excludeUrls: overrides && overrides.hasOwnProperty('excludeUrls') ? overrides.excludeUrls! : 'arbustum',
        formId: overrides && overrides.hasOwnProperty('formId') ? overrides.formId! : 'victus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '28aaba70-d689-40c3-b91e-ca2b170ba6a0',
        includeUrls: overrides && overrides.hasOwnProperty('includeUrls') ? overrides.includeUrls! : 'vapulus',
        showAfter: overrides && overrides.hasOwnProperty('showAfter') ? overrides.showAfter! : 5318,
        showOnlyOnce: overrides && overrides.hasOwnProperty('showOnlyOnce') ? overrides.showOnlyOnce! : false,
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'testimonium',
    };
};

export const aLanguageIntensity = (overrides?: Partial<LanguageIntensity>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LanguageIntensity' } & LanguageIntensity => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LanguageIntensity');
    return {
        __typename: 'LanguageIntensity',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'communis',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'velit',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f0edd860-3d5c-46ed-99f8-4aa897a9f0ad',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'delectus',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : 'tricesimus',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'ventito',
    };
};

export const aMarkStoryAsListenedInput = (overrides?: Partial<MarkStoryAsListenedInput>, _relationshipsToOmit: Set<string> = new Set()): MarkStoryAsListenedInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MarkStoryAsListenedInput');
    return {
        storyId: overrides && overrides.hasOwnProperty('storyId') ? overrides.storyId! : '38c5b761-80cb-4ec3-adf8-1d6df48031ad',
        timeStopped: overrides && overrides.hasOwnProperty('timeStopped') ? overrides.timeStopped! : 3726,
    };
};

export const aMasturbationTechnique = (overrides?: Partial<MasturbationTechnique>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MasturbationTechnique' } & MasturbationTechnique => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MasturbationTechnique');
    return {
        __typename: 'MasturbationTechnique',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'succedo',
        headerIllustration: overrides && overrides.hasOwnProperty('headerIllustration') ? overrides.headerIllustration! : 'aegrus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'f3fd8f91-ed3e-4759-bdb1-fa3e2b561577',
        stories: overrides && overrides.hasOwnProperty('stories') ? overrides.stories! : relationshipsToOmit.has('StoriesResponse') ? {} as StoriesResponse : aStoriesResponse({}, relationshipsToOmit),
        tileIllustration: overrides && overrides.hasOwnProperty('tileIllustration') ? overrides.tileIllustration! : 'aggero',
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'uterque',
    };
};

export const aMasturbationTechniquesFilters = (overrides?: Partial<MasturbationTechniquesFilters>, _relationshipsToOmit: Set<string> = new Set()): MasturbationTechniquesFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MasturbationTechniquesFilters');
    return {
        masturbationTechniquesIds: overrides && overrides.hasOwnProperty('masturbationTechniquesIds') ? overrides.masturbationTechniquesIds! : ['47aaec18-6573-4b76-ae30-728f899b4ca8'],
    };
};

export const aMasturbationTechniquesOrder = (overrides?: Partial<MasturbationTechniquesOrder>, _relationshipsToOmit: Set<string> = new Set()): MasturbationTechniquesOrder => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MasturbationTechniquesOrder');
    return {
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : SortOrder.Asc,
        orderBy: overrides && overrides.hasOwnProperty('orderBy') ? overrides.orderBy! : MasturbationTechniqueSortBy.Position,
    };
};

export const aMessage = (overrides?: Partial<Message>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Message' } & Message => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Message');
    return {
        __typename: 'Message',
        text: overrides && overrides.hasOwnProperty('text') ? overrides.text! : 'vere',
    };
};

export const aNewCheckout = (overrides?: Partial<NewCheckout>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'NewCheckout' } & NewCheckout => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NewCheckout');
    return {
        __typename: 'NewCheckout',
        response: overrides && overrides.hasOwnProperty('response') ? overrides.response! : 'cultura',
    };
};

export const aNewCheckoutInput = (overrides?: Partial<NewCheckoutInput>, _relationshipsToOmit: Set<string> = new Set()): NewCheckoutInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NewCheckoutInput');
    return {
        planId: overrides && overrides.hasOwnProperty('planId') ? overrides.planId! : 'cena',
        referralId: overrides && overrides.hasOwnProperty('referralId') ? overrides.referralId! : 'custodia',
        utm: overrides && overrides.hasOwnProperty('utm') ? overrides.utm! : relationshipsToOmit.has('Utm') ? {} as Utm : anUtm({}, relationshipsToOmit),
    };
};

export const anOnboardingV1Response = (overrides?: Partial<OnboardingV1Response>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OnboardingV1Response' } & OnboardingV1Response => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OnboardingV1Response');
    return {
        __typename: 'OnboardingV1Response',
        contentTypes: overrides && overrides.hasOwnProperty('contentTypes') ? overrides.contentTypes! : ['tergo'],
        languageIntensity: overrides && overrides.hasOwnProperty('languageIntensity') ? overrides.languageIntensity! : 'aperiam',
        reasons: overrides && overrides.hasOwnProperty('reasons') ? overrides.reasons! : ['comedo'],
        scenarios: overrides && overrides.hasOwnProperty('scenarios') ? overrides.scenarios! : ['arbustum'],
        tagIds: overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['avaritia'],
    };
};

export const aPagination = (overrides?: Partial<Pagination>, _relationshipsToOmit: Set<string> = new Set()): Pagination => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Pagination');
    return {
        page: overrides && overrides.hasOwnProperty('page') ? overrides.page! : 9886,
        perPage: overrides && overrides.hasOwnProperty('perPage') ? overrides.perPage! : 5699,
    };
};

export const aParticipantsType = (overrides?: Partial<ParticipantsType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ParticipantsType' } & ParticipantsType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParticipantsType');
    return {
        __typename: 'ParticipantsType',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adfectus',
        slug: overrides && overrides.hasOwnProperty('slug') ? overrides.slug! : ParticipantType.Anonym,
    };
};

export const aPlaylist = (overrides?: Partial<Playlist>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Playlist' } & Playlist => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Playlist');
    return {
        __typename: 'Playlist',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'doloribus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '027153e8-acc7-480f-a70c-17173b63e19a',
        image: overrides && overrides.hasOwnProperty('image') ? overrides.image! : relationshipsToOmit.has('PlaylistImage') ? {} as PlaylistImage : aPlaylistImage({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vicissitudo',
        publicAccess: overrides && overrides.hasOwnProperty('publicAccess') ? overrides.publicAccess! : true,
        showAsCuration: overrides && overrides.hasOwnProperty('showAsCuration') ? overrides.showAsCuration! : true,
        showOnExplorePage: overrides && overrides.hasOwnProperty('showOnExplorePage') ? overrides.showOnExplorePage! : true,
        stories: overrides && overrides.hasOwnProperty('stories') ? overrides.stories! : relationshipsToOmit.has('StoriesResponse') ? {} as StoriesResponse : aStoriesResponse({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : PlaylistTypeEnum.Femtasy,
    };
};

export const aPlaylistFilters = (overrides?: Partial<PlaylistFilters>, _relationshipsToOmit: Set<string> = new Set()): PlaylistFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PlaylistFilters');
    return {
        ids: overrides && overrides.hasOwnProperty('ids') ? overrides.ids! : ['50ad8f4b-e5c5-4e17-aaa9-aba37a7b555e'],
        types: overrides && overrides.hasOwnProperty('types') ? overrides.types! : [PlaylistTypeEnum.Femtasy],
        visibleAsCuration: overrides && overrides.hasOwnProperty('visibleAsCuration') ? overrides.visibleAsCuration! : true,
        visibleOnHomePage: overrides && overrides.hasOwnProperty('visibleOnHomePage') ? overrides.visibleOnHomePage! : false,
    };
};

export const aPlaylistImage = (overrides?: Partial<PlaylistImage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'PlaylistImage' } & PlaylistImage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PlaylistImage');
    return {
        __typename: 'PlaylistImage',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aed66602-e71f-4d52-a093-172c6330fde8',
        image: overrides && overrides.hasOwnProperty('image') ? overrides.image! : 'explicabo',
    };
};

export const aPlaylistImagesFilters = (overrides?: Partial<PlaylistImagesFilters>, _relationshipsToOmit: Set<string> = new Set()): PlaylistImagesFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PlaylistImagesFilters');
    return {
        showInCreationDialog: overrides && overrides.hasOwnProperty('showInCreationDialog') ? overrides.showInCreationDialog! : true,
    };
};

export const aPortalSession = (overrides?: Partial<PortalSession>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'PortalSession' } & PortalSession => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PortalSession');
    return {
        __typename: 'PortalSession',
        response: overrides && overrides.hasOwnProperty('response') ? overrides.response! : 'vere',
    };
};

export const aPostPurchaseAnswer = (overrides?: Partial<PostPurchaseAnswer>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'PostPurchaseAnswer' } & PostPurchaseAnswer => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PostPurchaseAnswer');
    return {
        __typename: 'PostPurchaseAnswer',
        freeText: overrides && overrides.hasOwnProperty('freeText') ? overrides.freeText! : false,
        freeTextPlaceholder: overrides && overrides.hasOwnProperty('freeTextPlaceholder') ? overrides.freeTextPlaceholder! : 'tumultus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ec9f1903-3f53-47e6-9b0d-9afe1a61277c',
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'placeat',
        localizedLabel: overrides && overrides.hasOwnProperty('localizedLabel') ? overrides.localizedLabel! : 'creptio',
        options: overrides && overrides.hasOwnProperty('options') ? overrides.options! : ['clarus'],
        optionsTrackingIds: overrides && overrides.hasOwnProperty('optionsTrackingIds') ? overrides.optionsTrackingIds! : ['confero'],
        sendSelectedOptionAsKey: overrides && overrides.hasOwnProperty('sendSelectedOptionAsKey') ? overrides.sendSelectedOptionAsKey! : false,
    };
};

export const aRecentSearchContent = (overrides?: Partial<RecentSearchContent>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecentSearchContent' } & RecentSearchContent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecentSearchContent');
    return {
        __typename: 'RecentSearchContent',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '9b691ae0-2d3e-46dc-b56b-028e397d353e',
    };
};

export const aRecentSearchesFilters = (overrides?: Partial<RecentSearchesFilters>, _relationshipsToOmit: Set<string> = new Set()): RecentSearchesFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecentSearchesFilters');
    return {
        types: overrides && overrides.hasOwnProperty('types') ? overrides.types! : [SearchResultType.ContentType],
    };
};

export const aRecommendedStories = (overrides?: Partial<RecommendedStories>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecommendedStories' } & RecommendedStories => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecommendedStories');
    return {
        __typename: 'RecommendedStories',
        recommendedStories: overrides && overrides.hasOwnProperty('recommendedStories') ? overrides.recommendedStories! : [relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit)],
    };
};

export const aRedeemOfferInput = (overrides?: Partial<RedeemOfferInput>, _relationshipsToOmit: Set<string> = new Set()): RedeemOfferInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RedeemOfferInput');
    return {
        offerType: overrides && overrides.hasOwnProperty('offerType') ? overrides.offerType! : RedeemedOfferType.CancelFlowDiscount_1,
        variant: overrides && overrides.hasOwnProperty('variant') ? overrides.variant! : RedeemedOfferVariant.Feedback,
    };
};

export const aRedeemedOffer = (overrides?: Partial<RedeemedOffer>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RedeemedOffer' } & RedeemedOffer => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RedeemedOffer');
    return {
        __typename: 'RedeemedOffer',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'pauper',
        offerType: overrides && overrides.hasOwnProperty('offerType') ? overrides.offerType! : RedeemedOfferType.CancelFlowDiscount_1,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'rem',
    };
};

export const aRemoveStoryFromPlaylistInput = (overrides?: Partial<RemoveStoryFromPlaylistInput>, _relationshipsToOmit: Set<string> = new Set()): RemoveStoryFromPlaylistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RemoveStoryFromPlaylistInput');
    return {
        playlistId: overrides && overrides.hasOwnProperty('playlistId') ? overrides.playlistId! : 'dbf10f72-b77a-42ca-b2fb-60cb1f426cb5',
        storyId: overrides && overrides.hasOwnProperty('storyId') ? overrides.storyId! : '37608e9a-d801-4696-9a91-87b5f0747185',
    };
};

export const aRootMutationType = (overrides?: Partial<RootMutationType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RootMutationType' } & RootMutationType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RootMutationType');
    return {
        __typename: 'RootMutationType',
        addStoryToPlaylist: overrides && overrides.hasOwnProperty('addStoryToPlaylist') ? overrides.addStoryToPlaylist! : relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit),
        cancelSubscription: overrides && overrides.hasOwnProperty('cancelSubscription') ? overrides.cancelSubscription! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        createPlaylist: overrides && overrides.hasOwnProperty('createPlaylist') ? overrides.createPlaylist! : relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit),
        createPortalSession: overrides && overrides.hasOwnProperty('createPortalSession') ? overrides.createPortalSession! : relationshipsToOmit.has('PortalSession') ? {} as PortalSession : aPortalSession({}, relationshipsToOmit),
        deletePlaylist: overrides && overrides.hasOwnProperty('deletePlaylist') ? overrides.deletePlaylist! : relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit),
        increaseNumberOfListens: overrides && overrides.hasOwnProperty('increaseNumberOfListens') ? overrides.increaseNumberOfListens! : relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit),
        markStoryAsListened: overrides && overrides.hasOwnProperty('markStoryAsListened') ? overrides.markStoryAsListened! : relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit),
        newCheckout: overrides && overrides.hasOwnProperty('newCheckout') ? overrides.newCheckout! : relationshipsToOmit.has('NewCheckout') ? {} as NewCheckout : aNewCheckout({}, relationshipsToOmit),
        reactivateSubscription: overrides && overrides.hasOwnProperty('reactivateSubscription') ? overrides.reactivateSubscription! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        redeemOffer: overrides && overrides.hasOwnProperty('redeemOffer') ? overrides.redeemOffer! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        removeStoryFromPlaylist: overrides && overrides.hasOwnProperty('removeStoryFromPlaylist') ? overrides.removeStoryFromPlaylist! : relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit),
        savePlaylistToMyPlaylists: overrides && overrides.hasOwnProperty('savePlaylistToMyPlaylists') ? overrides.savePlaylistToMyPlaylists! : relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit),
        savePostPurchaseSurveyAnswer: overrides && overrides.hasOwnProperty('savePostPurchaseSurveyAnswer') ? overrides.savePostPurchaseSurveyAnswer! : false,
        saveRecentSearch: overrides && overrides.hasOwnProperty('saveRecentSearch') ? overrides.saveRecentSearch! : false,
        segmentTrack: overrides && overrides.hasOwnProperty('segmentTrack') ? overrides.segmentTrack! : true,
        setNotificationShown: overrides && overrides.hasOwnProperty('setNotificationShown') ? overrides.setNotificationShown! : relationshipsToOmit.has('UserNotification') ? {} as UserNotification : aUserNotification({}, relationshipsToOmit),
        setStoryMarkets: overrides && overrides.hasOwnProperty('setStoryMarkets') ? overrides.setStoryMarkets! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        setUserPreferences: overrides && overrides.hasOwnProperty('setUserPreferences') ? overrides.setUserPreferences! : relationshipsToOmit.has('UserPreferences') ? {} as UserPreferences : aUserPreferences({}, relationshipsToOmit),
        startGracePeriod: overrides && overrides.hasOwnProperty('startGracePeriod') ? overrides.startGracePeriod! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        storeOnboardingResponses: overrides && overrides.hasOwnProperty('storeOnboardingResponses') ? overrides.storeOnboardingResponses! : false,
        subscribeToNewsletter: overrides && overrides.hasOwnProperty('subscribeToNewsletter') ? overrides.subscribeToNewsletter! : true,
        toggleLoveSpeaker: overrides && overrides.hasOwnProperty('toggleLoveSpeaker') ? overrides.toggleLoveSpeaker! : relationshipsToOmit.has('Speaker') ? {} as Speaker : aSpeaker({}, relationshipsToOmit),
        toggleLoveStory: overrides && overrides.hasOwnProperty('toggleLoveStory') ? overrides.toggleLoveStory! : relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit),
        updatePlaylist: overrides && overrides.hasOwnProperty('updatePlaylist') ? overrides.updatePlaylist! : relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit),
        updateTimeStopped: overrides && overrides.hasOwnProperty('updateTimeStopped') ? overrides.updateTimeStopped! : relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit),
    };
};

export const aRootQueryType = (overrides?: Partial<RootQueryType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RootQueryType' } & RootQueryType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RootQueryType');
    return {
        __typename: 'RootQueryType',
        activeContentDrop: overrides && overrides.hasOwnProperty('activeContentDrop') ? overrides.activeContentDrop! : relationshipsToOmit.has('ContentDrop') ? {} as ContentDrop : aContentDrop({}, relationshipsToOmit),
        favouriteKinks: overrides && overrides.hasOwnProperty('favouriteKinks') ? overrides.favouriteKinks! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        featureFlags: overrides && overrides.hasOwnProperty('featureFlags') ? overrides.featureFlags! : [relationshipsToOmit.has('FeatureFlag') ? {} as FeatureFlag : aFeatureFlag({}, relationshipsToOmit)],
        genres: overrides && overrides.hasOwnProperty('genres') ? overrides.genres! : [relationshipsToOmit.has('Genre') ? {} as Genre : aGenre({}, relationshipsToOmit)],
        hotStories: overrides && overrides.hasOwnProperty('hotStories') ? overrides.hotStories! : relationshipsToOmit.has('StoriesResponse') ? {} as StoriesResponse : aStoriesResponse({}, relationshipsToOmit),
        influencerCode: overrides && overrides.hasOwnProperty('influencerCode') ? overrides.influencerCode! : relationshipsToOmit.has('InfluencerCode') ? {} as InfluencerCode : anInfluencerCode({}, relationshipsToOmit),
        journeys: overrides && overrides.hasOwnProperty('journeys') ? overrides.journeys! : [relationshipsToOmit.has('Journey') ? {} as Journey : aJourney({}, relationshipsToOmit)],
        klaviyoForms: overrides && overrides.hasOwnProperty('klaviyoForms') ? overrides.klaviyoForms! : [relationshipsToOmit.has('KlaviyoForm') ? {} as KlaviyoForm : aKlaviyoForm({}, relationshipsToOmit)],
        languageIntensities: overrides && overrides.hasOwnProperty('languageIntensities') ? overrides.languageIntensities! : [relationshipsToOmit.has('LanguageIntensity') ? {} as LanguageIntensity : aLanguageIntensity({}, relationshipsToOmit)],
        listenedStories: overrides && overrides.hasOwnProperty('listenedStories') ? overrides.listenedStories! : [relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit)],
        masturbationTechniques: overrides && overrides.hasOwnProperty('masturbationTechniques') ? overrides.masturbationTechniques! : [relationshipsToOmit.has('MasturbationTechnique') ? {} as MasturbationTechnique : aMasturbationTechnique({}, relationshipsToOmit)],
        me: overrides && overrides.hasOwnProperty('me') ? overrides.me! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : relationshipsToOmit.has('Message') ? {} as Message : aMessage({}, relationshipsToOmit),
        playlistImages: overrides && overrides.hasOwnProperty('playlistImages') ? overrides.playlistImages! : [relationshipsToOmit.has('PlaylistImage') ? {} as PlaylistImage : aPlaylistImage({}, relationshipsToOmit)],
        playlists: overrides && overrides.hasOwnProperty('playlists') ? overrides.playlists! : [relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit)],
        postPurchaseAnswers: overrides && overrides.hasOwnProperty('postPurchaseAnswers') ? overrides.postPurchaseAnswers! : [relationshipsToOmit.has('PostPurchaseAnswer') ? {} as PostPurchaseAnswer : aPostPurchaseAnswer({}, relationshipsToOmit)],
        recentSearches: overrides && overrides.hasOwnProperty('recentSearches') ? overrides.recentSearches! : [relationshipsToOmit.has('RecentSearchContent') ? {} as RecentSearchContent : aRecentSearchContent({}, relationshipsToOmit)],
        recommendedStories: overrides && overrides.hasOwnProperty('recommendedStories') ? overrides.recommendedStories! : relationshipsToOmit.has('RecommendedStories') ? {} as RecommendedStories : aRecommendedStories({}, relationshipsToOmit),
        redeemedOffers: overrides && overrides.hasOwnProperty('redeemedOffers') ? overrides.redeemedOffers! : [relationshipsToOmit.has('RedeemedOffer') ? {} as RedeemedOffer : aRedeemedOffer({}, relationshipsToOmit)],
        search: overrides && overrides.hasOwnProperty('search') ? overrides.search! : relationshipsToOmit.has('SearchResult') ? {} as SearchResult : aSearchResult({}, relationshipsToOmit),
        speakers: overrides && overrides.hasOwnProperty('speakers') ? overrides.speakers! : relationshipsToOmit.has('SpeakersResponse') ? {} as SpeakersResponse : aSpeakersResponse({}, relationshipsToOmit),
        stories: overrides && overrides.hasOwnProperty('stories') ? overrides.stories! : relationshipsToOmit.has('StoriesResponse') ? {} as StoriesResponse : aStoriesResponse({}, relationshipsToOmit),
        story: overrides && overrides.hasOwnProperty('story') ? overrides.story! : relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit),
        tag: overrides && overrides.hasOwnProperty('tag') ? overrides.tag! : relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        userNotifications: overrides && overrides.hasOwnProperty('userNotifications') ? overrides.userNotifications! : [relationshipsToOmit.has('UserNotification') ? {} as UserNotification : aUserNotification({}, relationshipsToOmit)],
        userPreferences: overrides && overrides.hasOwnProperty('userPreferences') ? overrides.userPreferences! : relationshipsToOmit.has('UserPreferences') ? {} as UserPreferences : aUserPreferences({}, relationshipsToOmit),
    };
};

export const aSavePlaylistToMyPlaylistsInput = (overrides?: Partial<SavePlaylistToMyPlaylistsInput>, _relationshipsToOmit: Set<string> = new Set()): SavePlaylistToMyPlaylistsInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SavePlaylistToMyPlaylistsInput');
    return {
        playlistId: overrides && overrides.hasOwnProperty('playlistId') ? overrides.playlistId! : '9238d778-3d61-422d-bdde-ca6cba000068',
    };
};

export const aSearchResult = (overrides?: Partial<SearchResult>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SearchResult' } & SearchResult => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchResult');
    return {
        __typename: 'SearchResult',
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('Genre') ? {} as Genre : aGenre({}, relationshipsToOmit)],
    };
};

export const aSegmentInput = (overrides?: Partial<SegmentInput>, _relationshipsToOmit: Set<string> = new Set()): SegmentInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SegmentInput');
    return {
        eventName: overrides && overrides.hasOwnProperty('eventName') ? overrides.eventName! : 'absorbeo',
        requestType: overrides && overrides.hasOwnProperty('requestType') ? overrides.requestType! : SegmentRequestType.Identify,
        traits: overrides && overrides.hasOwnProperty('traits') ? overrides.traits! : 'sustineo',
    };
};

export const aSeries = (overrides?: Partial<Series>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Series' } & Series => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Series');
    return {
        __typename: 'Series',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'laboriosam',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8139e5be-a0d1-4b1c-9454-390c8166f1fa',
        stories: overrides && overrides.hasOwnProperty('stories') ? overrides.stories! : relationshipsToOmit.has('StoriesResponse') ? {} as StoriesResponse : aStoriesResponse({}, relationshipsToOmit),
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'vos',
    };
};

export const aSeriesInfo = (overrides?: Partial<SeriesInfo>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SeriesInfo' } & SeriesInfo => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SeriesInfo');
    return {
        __typename: 'SeriesInfo',
        nextStory: overrides && overrides.hasOwnProperty('nextStory') ? overrides.nextStory! : relationshipsToOmit.has('StoryInterface') ? {} as StoryInterface : aStoryInterface({}, relationshipsToOmit),
        previousStory: overrides && overrides.hasOwnProperty('previousStory') ? overrides.previousStory! : relationshipsToOmit.has('StoryInterface') ? {} as StoryInterface : aStoryInterface({}, relationshipsToOmit),
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'amaritudo',
    };
};

export const aSetNotificationShownInput = (overrides?: Partial<SetNotificationShownInput>, _relationshipsToOmit: Set<string> = new Set()): SetNotificationShownInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SetNotificationShownInput');
    return {
        notificationType: overrides && overrides.hasOwnProperty('notificationType') ? overrides.notificationType! : NotificationType.NewExplorePage,
    };
};

export const aSpeaker = (overrides?: Partial<Speaker>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Speaker' } & Speaker => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Speaker');
    return {
        __typename: 'Speaker',
        accent: overrides && overrides.hasOwnProperty('accent') ? overrides.accent! : relationshipsToOmit.has('Accent') ? {} as Accent : anAccent({}, relationshipsToOmit),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'nemo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'aegrotatio',
        featured: overrides && overrides.hasOwnProperty('featured') ? overrides.featured! : true,
        gender: overrides && overrides.hasOwnProperty('gender') ? overrides.gender! : Gender.Diverse,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a09b6768-7fa0-4943-89b0-71e453350250',
        illustration: overrides && overrides.hasOwnProperty('illustration') ? overrides.illustration! : 'tametsi',
        loved: overrides && overrides.hasOwnProperty('loved') ? overrides.loved! : true,
        lovedAt: overrides && overrides.hasOwnProperty('lovedAt') ? overrides.lovedAt! : 'sui',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pectus',
        numberOfListens: overrides && overrides.hasOwnProperty('numberOfListens') ? overrides.numberOfListens! : 5054,
        participantsType: overrides && overrides.hasOwnProperty('participantsType') ? overrides.participantsType! : relationshipsToOmit.has('ParticipantsType') ? {} as ParticipantsType : aParticipantsType({}, relationshipsToOmit),
        rating: overrides && overrides.hasOwnProperty('rating') ? overrides.rating! : 'asperiores',
        stories: overrides && overrides.hasOwnProperty('stories') ? overrides.stories! : relationshipsToOmit.has('StoriesResponse') ? {} as StoriesResponse : aStoriesResponse({}, relationshipsToOmit),
        storiesCount: overrides && overrides.hasOwnProperty('storiesCount') ? overrides.storiesCount! : 1284,
        transcodedSampleUrl: overrides && overrides.hasOwnProperty('transcodedSampleUrl') ? overrides.transcodedSampleUrl! : 'tot',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'bardus',
    };
};

export const aSpeakerFilters = (overrides?: Partial<SpeakerFilters>, _relationshipsToOmit: Set<string> = new Set()): SpeakerFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpeakerFilters');
    return {
        onlyLoved: overrides && overrides.hasOwnProperty('onlyLoved') ? overrides.onlyLoved! : false,
        participantTypes: overrides && overrides.hasOwnProperty('participantTypes') ? overrides.participantTypes! : [ParticipantType.Anonym],
        speakerIds: overrides && overrides.hasOwnProperty('speakerIds') ? overrides.speakerIds! : ['a107534e-479f-437d-b2a5-67f36ddcb35b'],
    };
};

export const aSpeakerOrder = (overrides?: Partial<SpeakerOrder>, _relationshipsToOmit: Set<string> = new Set()): SpeakerOrder => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpeakerOrder');
    return {
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : SortOrder.Asc,
        orderBy: overrides && overrides.hasOwnProperty('orderBy') ? overrides.orderBy! : SpeakerSortBy.CreatedAt,
    };
};

export const aSpeakersResponse = (overrides?: Partial<SpeakersResponse>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SpeakersResponse' } & SpeakersResponse => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpeakersResponse');
    return {
        __typename: 'SpeakersResponse',
        speakers: overrides && overrides.hasOwnProperty('speakers') ? overrides.speakers! : [relationshipsToOmit.has('Speaker') ? {} as Speaker : aSpeaker({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 7139,
    };
};

export const aStoriesResponse = (overrides?: Partial<StoriesResponse>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StoriesResponse' } & StoriesResponse => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StoriesResponse');
    return {
        __typename: 'StoriesResponse',
        stories: overrides && overrides.hasOwnProperty('stories') ? overrides.stories! : [relationshipsToOmit.has('StoryInterface') ? {} as StoryInterface : aStoryInterface({}, relationshipsToOmit)],
        totalCount: overrides && overrides.hasOwnProperty('totalCount') ? overrides.totalCount! : 2724,
    };
};

export const aStory = (overrides?: Partial<Story>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Story' } & Story => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Story');
    return {
        __typename: 'Story',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : [StoryActions.Play],
        alreadyListened: overrides && overrides.hasOwnProperty('alreadyListened') ? overrides.alreadyListened! : true,
        alreadyVoted: overrides && overrides.hasOwnProperty('alreadyVoted') ? overrides.alreadyVoted! : true,
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : relationshipsToOmit.has('ContentType') ? {} as ContentType : aContentType({}, relationshipsToOmit),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'sui',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'arbor',
        duration: overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 4954,
        durationInMinutes: overrides && overrides.hasOwnProperty('durationInMinutes') ? overrides.durationInMinutes! : 'utor',
        femtasyRed: overrides && overrides.hasOwnProperty('femtasyRed') ? overrides.femtasyRed! : false,
        freeTrial: overrides && overrides.hasOwnProperty('freeTrial') ? overrides.freeTrial! : true,
        genre: overrides && overrides.hasOwnProperty('genre') ? overrides.genre! : relationshipsToOmit.has('Genre') ? {} as Genre : aGenre({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '53319be6-4d3b-4a00-8348-5f4f526c6b33',
        isNew: overrides && overrides.hasOwnProperty('isNew') ? overrides.isNew! : false,
        languageIntensity: overrides && overrides.hasOwnProperty('languageIntensity') ? overrides.languageIntensity! : relationshipsToOmit.has('LanguageIntensity') ? {} as LanguageIntensity : aLanguageIntensity({}, relationshipsToOmit),
        loved: overrides && overrides.hasOwnProperty('loved') ? overrides.loved! : false,
        markets: overrides && overrides.hasOwnProperty('markets') ? overrides.markets! : [Market.De],
        numberOfListens: overrides && overrides.hasOwnProperty('numberOfListens') ? overrides.numberOfListens! : 3612,
        orgasms: overrides && overrides.hasOwnProperty('orgasms') ? overrides.orgasms! : [8342],
        playlists: overrides && overrides.hasOwnProperty('playlists') ? overrides.playlists! : [relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit)],
        rating: overrides && overrides.hasOwnProperty('rating') ? overrides.rating! : 'desparatus',
        recommendedOrder: overrides && overrides.hasOwnProperty('recommendedOrder') ? overrides.recommendedOrder! : 961,
        releaseDate: overrides && overrides.hasOwnProperty('releaseDate') ? overrides.releaseDate! : 'depulso',
        relevanceScore: overrides && overrides.hasOwnProperty('relevanceScore') ? overrides.relevanceScore! : 4.5,
        safeDescription: overrides && overrides.hasOwnProperty('safeDescription') ? overrides.safeDescription! : 'desino',
        seriesInfo: overrides && overrides.hasOwnProperty('seriesInfo') ? overrides.seriesInfo! : relationshipsToOmit.has('SeriesInfo') ? {} as SeriesInfo : aSeriesInfo({}, relationshipsToOmit),
        speaker: overrides && overrides.hasOwnProperty('speaker') ? overrides.speaker! : relationshipsToOmit.has('Speaker') ? {} as Speaker : aSpeaker({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        themeTag: overrides && overrides.hasOwnProperty('themeTag') ? overrides.themeTag! : relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit),
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'demum',
        transcodedAudioUrl: overrides && overrides.hasOwnProperty('transcodedAudioUrl') ? overrides.transcodedAudioUrl! : 'sublime',
        transcodedSampleUrl: overrides && overrides.hasOwnProperty('transcodedSampleUrl') ? overrides.transcodedSampleUrl! : 'suffoco',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'succedo',
        userRating: overrides && overrides.hasOwnProperty('userRating') ? overrides.userRating! : 5853,
    };
};

export const aStoryInterface = (overrides?: Partial<StoryInterface>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StoryInterface' } & StoryInterface => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StoryInterface');
    return {
        __typename: 'StoryInterface',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : [StoryActions.Play],
        alreadyListened: overrides && overrides.hasOwnProperty('alreadyListened') ? overrides.alreadyListened! : true,
        alreadyVoted: overrides && overrides.hasOwnProperty('alreadyVoted') ? overrides.alreadyVoted! : true,
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : relationshipsToOmit.has('ContentType') ? {} as ContentType : aContentType({}, relationshipsToOmit),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'vicissitudo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'dolores',
        duration: overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 2436,
        durationInMinutes: overrides && overrides.hasOwnProperty('durationInMinutes') ? overrides.durationInMinutes! : 'vesica',
        femtasyRed: overrides && overrides.hasOwnProperty('femtasyRed') ? overrides.femtasyRed! : false,
        freeTrial: overrides && overrides.hasOwnProperty('freeTrial') ? overrides.freeTrial! : true,
        genre: overrides && overrides.hasOwnProperty('genre') ? overrides.genre! : relationshipsToOmit.has('Genre') ? {} as Genre : aGenre({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '34922adf-824d-4c7c-8d52-deb7b8bae9c3',
        isNew: overrides && overrides.hasOwnProperty('isNew') ? overrides.isNew! : false,
        languageIntensity: overrides && overrides.hasOwnProperty('languageIntensity') ? overrides.languageIntensity! : relationshipsToOmit.has('LanguageIntensity') ? {} as LanguageIntensity : aLanguageIntensity({}, relationshipsToOmit),
        loved: overrides && overrides.hasOwnProperty('loved') ? overrides.loved! : true,
        markets: overrides && overrides.hasOwnProperty('markets') ? overrides.markets! : [Market.De],
        numberOfListens: overrides && overrides.hasOwnProperty('numberOfListens') ? overrides.numberOfListens! : 6554,
        orgasms: overrides && overrides.hasOwnProperty('orgasms') ? overrides.orgasms! : [1718],
        playlists: overrides && overrides.hasOwnProperty('playlists') ? overrides.playlists! : [relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit)],
        rating: overrides && overrides.hasOwnProperty('rating') ? overrides.rating! : 'coerceo',
        recommendedOrder: overrides && overrides.hasOwnProperty('recommendedOrder') ? overrides.recommendedOrder! : 2848,
        releaseDate: overrides && overrides.hasOwnProperty('releaseDate') ? overrides.releaseDate! : 'suppono',
        relevanceScore: overrides && overrides.hasOwnProperty('relevanceScore') ? overrides.relevanceScore! : 2.3,
        safeDescription: overrides && overrides.hasOwnProperty('safeDescription') ? overrides.safeDescription! : 'uxor',
        speaker: overrides && overrides.hasOwnProperty('speaker') ? overrides.speaker! : relationshipsToOmit.has('Speaker') ? {} as Speaker : aSpeaker({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        themeTag: overrides && overrides.hasOwnProperty('themeTag') ? overrides.themeTag! : relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit),
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'vespillo',
        transcodedAudioUrl: overrides && overrides.hasOwnProperty('transcodedAudioUrl') ? overrides.transcodedAudioUrl! : 'tabgo',
        transcodedSampleUrl: overrides && overrides.hasOwnProperty('transcodedSampleUrl') ? overrides.transcodedSampleUrl! : 'attollo',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'bestia',
        userRating: overrides && overrides.hasOwnProperty('userRating') ? overrides.userRating! : 1573,
    };
};

export const aStoryOrder = (overrides?: Partial<StoryOrder>, _relationshipsToOmit: Set<string> = new Set()): StoryOrder => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StoryOrder');
    return {
        campaign: overrides && overrides.hasOwnProperty('campaign') ? overrides.campaign! : 'sufficio',
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : SortOrder.Asc,
        orderBy: overrides && overrides.hasOwnProperty('orderBy') ? overrides.orderBy! : StorySortBy.CreatedAt,
    };
};

export const aTag = (overrides?: Partial<Tag>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Tag' } & Tag => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Tag');
    return {
        __typename: 'Tag',
        bubbleWithTitle: overrides && overrides.hasOwnProperty('bubbleWithTitle') ? overrides.bubbleWithTitle! : 'annus',
        bubbleWithTitleAndImage: overrides && overrides.hasOwnProperty('bubbleWithTitleAndImage') ? overrides.bubbleWithTitleAndImage! : 'magnam',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'quisquam',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'aureus',
        featured: overrides && overrides.hasOwnProperty('featured') ? overrides.featured! : true,
        featuredImage: overrides && overrides.hasOwnProperty('featuredImage') ? overrides.featuredImage! : 'bibo',
        headerImage: overrides && overrides.hasOwnProperty('headerImage') ? overrides.headerImage! : 'sum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6926b150-7296-4e15-bc70-c82302664d98',
        image: overrides && overrides.hasOwnProperty('image') ? overrides.image! : 'abduco',
        isAffirmation: overrides && overrides.hasOwnProperty('isAffirmation') ? overrides.isAffirmation! : false,
        isMood: overrides && overrides.hasOwnProperty('isMood') ? overrides.isMood! : false,
        isScenario: overrides && overrides.hasOwnProperty('isScenario') ? overrides.isScenario! : true,
        isUserPlaylist: overrides && overrides.hasOwnProperty('isUserPlaylist') ? overrides.isUserPlaylist! : true,
        kinkinessScore: overrides && overrides.hasOwnProperty('kinkinessScore') ? overrides.kinkinessScore! : 8420,
        mostRecentAddedAt: overrides && overrides.hasOwnProperty('mostRecentAddedAt') ? overrides.mostRecentAddedAt! : 'saepe',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cruentus',
        numberOfListens: overrides && overrides.hasOwnProperty('numberOfListens') ? overrides.numberOfListens! : 3752,
        onboardingImage: overrides && overrides.hasOwnProperty('onboardingImage') ? overrides.onboardingImage! : 'tribuo',
        onboardingPosition: overrides && overrides.hasOwnProperty('onboardingPosition') ? overrides.onboardingPosition! : 9064,
        playlist: overrides && overrides.hasOwnProperty('playlist') ? overrides.playlist! : relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit),
        rating: overrides && overrides.hasOwnProperty('rating') ? overrides.rating! : 'canto',
        stories: overrides && overrides.hasOwnProperty('stories') ? overrides.stories! : relationshipsToOmit.has('StoriesResponse') ? {} as StoriesResponse : aStoriesResponse({}, relationshipsToOmit),
        storiesCount: overrides && overrides.hasOwnProperty('storiesCount') ? overrides.storiesCount! : 804,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'impedit',
        visualWithText: overrides && overrides.hasOwnProperty('visualWithText') ? overrides.visualWithText! : 'delinquo',
        visualWithoutText: overrides && overrides.hasOwnProperty('visualWithoutText') ? overrides.visualWithoutText! : 'vapulus',
    };
};

export const aTagFilters = (overrides?: Partial<TagFilters>, _relationshipsToOmit: Set<string> = new Set()): TagFilters => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TagFilters');
    return {
        contentTypeIds: overrides && overrides.hasOwnProperty('contentTypeIds') ? overrides.contentTypeIds! : ['56614d27-9502-4049-9043-ddba540ba6be'],
        isAffirmation: overrides && overrides.hasOwnProperty('isAffirmation') ? overrides.isAffirmation! : true,
        isFeatured: overrides && overrides.hasOwnProperty('isFeatured') ? overrides.isFeatured! : true,
        isMood: overrides && overrides.hasOwnProperty('isMood') ? overrides.isMood! : true,
        isScenario: overrides && overrides.hasOwnProperty('isScenario') ? overrides.isScenario! : false,
        onlyWithOnboardingPosition: overrides && overrides.hasOwnProperty('onlyWithOnboardingPosition') ? overrides.onlyWithOnboardingPosition! : false,
        tagIds: overrides && overrides.hasOwnProperty('tagIds') ? overrides.tagIds! : ['ba8cf389-1f86-4449-991d-e8eff8968b41'],
    };
};

export const aTagOrder = (overrides?: Partial<TagOrder>, _relationshipsToOmit: Set<string> = new Set()): TagOrder => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TagOrder');
    return {
        order: overrides && overrides.hasOwnProperty('order') ? overrides.order! : SortOrder.Asc,
        orderBy: overrides && overrides.hasOwnProperty('orderBy') ? overrides.orderBy! : TagSortBy.CreatedAt,
    };
};

export const aThreeSixtyStory = (overrides?: Partial<ThreeSixtyStory>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ThreeSixtyStory' } & ThreeSixtyStory => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreeSixtyStory');
    return {
        __typename: 'ThreeSixtyStory',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : [StoryActions.Play],
        alreadyListened: overrides && overrides.hasOwnProperty('alreadyListened') ? overrides.alreadyListened! : true,
        alreadyVoted: overrides && overrides.hasOwnProperty('alreadyVoted') ? overrides.alreadyVoted! : true,
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : relationshipsToOmit.has('ContentType') ? {} as ContentType : aContentType({}, relationshipsToOmit),
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'deinde',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'capio',
        duration: overrides && overrides.hasOwnProperty('duration') ? overrides.duration! : 4749,
        durationInMinutes: overrides && overrides.hasOwnProperty('durationInMinutes') ? overrides.durationInMinutes! : 'amissio',
        femtasyRed: overrides && overrides.hasOwnProperty('femtasyRed') ? overrides.femtasyRed! : false,
        freeTrial: overrides && overrides.hasOwnProperty('freeTrial') ? overrides.freeTrial! : false,
        genre: overrides && overrides.hasOwnProperty('genre') ? overrides.genre! : relationshipsToOmit.has('Genre') ? {} as Genre : aGenre({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '4b440255-03c3-4e43-a0e5-46d5dca4d7f0',
        image: overrides && overrides.hasOwnProperty('image') ? overrides.image! : 'earum',
        isNew: overrides && overrides.hasOwnProperty('isNew') ? overrides.isNew! : false,
        languageIntensity: overrides && overrides.hasOwnProperty('languageIntensity') ? overrides.languageIntensity! : relationshipsToOmit.has('LanguageIntensity') ? {} as LanguageIntensity : aLanguageIntensity({}, relationshipsToOmit),
        loved: overrides && overrides.hasOwnProperty('loved') ? overrides.loved! : false,
        markets: overrides && overrides.hasOwnProperty('markets') ? overrides.markets! : [Market.De],
        numberOfListens: overrides && overrides.hasOwnProperty('numberOfListens') ? overrides.numberOfListens! : 5996,
        orgasms: overrides && overrides.hasOwnProperty('orgasms') ? overrides.orgasms! : [6481],
        playlists: overrides && overrides.hasOwnProperty('playlists') ? overrides.playlists! : [relationshipsToOmit.has('Playlist') ? {} as Playlist : aPlaylist({}, relationshipsToOmit)],
        rating: overrides && overrides.hasOwnProperty('rating') ? overrides.rating! : 'amissio',
        recommendedOrder: overrides && overrides.hasOwnProperty('recommendedOrder') ? overrides.recommendedOrder! : 6141,
        releaseDate: overrides && overrides.hasOwnProperty('releaseDate') ? overrides.releaseDate! : 'tam',
        relevanceScore: overrides && overrides.hasOwnProperty('relevanceScore') ? overrides.relevanceScore! : 7.5,
        safeDescription: overrides && overrides.hasOwnProperty('safeDescription') ? overrides.safeDescription! : 'acer',
        seriesInfo: overrides && overrides.hasOwnProperty('seriesInfo') ? overrides.seriesInfo! : relationshipsToOmit.has('SeriesInfo') ? {} as SeriesInfo : aSeriesInfo({}, relationshipsToOmit),
        speaker: overrides && overrides.hasOwnProperty('speaker') ? overrides.speaker! : relationshipsToOmit.has('Speaker') ? {} as Speaker : aSpeaker({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : [relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit)],
        themeTag: overrides && overrides.hasOwnProperty('themeTag') ? overrides.themeTag! : relationshipsToOmit.has('Tag') ? {} as Tag : aTag({}, relationshipsToOmit),
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'arto',
        transcodedAudioUrl: overrides && overrides.hasOwnProperty('transcodedAudioUrl') ? overrides.transcodedAudioUrl! : 'deprecator',
        transcodedSampleUrl: overrides && overrides.hasOwnProperty('transcodedSampleUrl') ? overrides.transcodedSampleUrl! : 'defero',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'arto',
        userRating: overrides && overrides.hasOwnProperty('userRating') ? overrides.userRating! : 7688,
    };
};

export const aToggleLoveSpeakerInput = (overrides?: Partial<ToggleLoveSpeakerInput>, _relationshipsToOmit: Set<string> = new Set()): ToggleLoveSpeakerInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ToggleLoveSpeakerInput');
    return {
        speakerId: overrides && overrides.hasOwnProperty('speakerId') ? overrides.speakerId! : '41a86269-e3af-4abd-866f-d1d311b5e715',
    };
};

export const aToggleLoveStoryInput = (overrides?: Partial<ToggleLoveStoryInput>, _relationshipsToOmit: Set<string> = new Set()): ToggleLoveStoryInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ToggleLoveStoryInput');
    return {
        storyId: overrides && overrides.hasOwnProperty('storyId') ? overrides.storyId! : 'da19055b-4d4e-45af-85ad-bcb33435ab64',
    };
};

export const anUpdatePlaylistInput = (overrides?: Partial<UpdatePlaylistInput>, _relationshipsToOmit: Set<string> = new Set()): UpdatePlaylistInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatePlaylistInput');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'comitatus',
        playlistId: overrides && overrides.hasOwnProperty('playlistId') ? overrides.playlistId! : '9e4bf1b1-0a7c-41b6-91a6-363efd1d2443',
        playlistImageId: overrides && overrides.hasOwnProperty('playlistImageId') ? overrides.playlistImageId! : '1e9c52b0-d6e1-4ad7-8dc0-1f722b8d6814',
        storiesIds: overrides && overrides.hasOwnProperty('storiesIds') ? overrides.storiesIds! : ['6c77dfc2-4e43-40cd-8783-9a63ad97354f'],
    };
};

export const anUpdateTimeStoppedInput = (overrides?: Partial<UpdateTimeStoppedInput>, _relationshipsToOmit: Set<string> = new Set()): UpdateTimeStoppedInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTimeStoppedInput');
    return {
        storyId: overrides && overrides.hasOwnProperty('storyId') ? overrides.storyId! : 'acfd082e-8b09-4163-b155-c9e9d69f351c',
        timeStopped: overrides && overrides.hasOwnProperty('timeStopped') ? overrides.timeStopped! : 9307,
    };
};

export const aUser = (overrides?: Partial<User>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'User' } & User => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('User');
    return {
        __typename: 'User',
        activeSubscription: overrides && overrides.hasOwnProperty('activeSubscription') ? overrides.activeSubscription! : relationshipsToOmit.has('UserSubscription') ? {} as UserSubscription : aUserSubscription({}, relationshipsToOmit),
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'natus',
        emailConfirmed: overrides && overrides.hasOwnProperty('emailConfirmed') ? overrides.emailConfirmed! : true,
        favouriteSound: overrides && overrides.hasOwnProperty('favouriteSound') ? overrides.favouriteSound! : relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit),
        favouriteStory: overrides && overrides.hasOwnProperty('favouriteStory') ? overrides.favouriteStory! : relationshipsToOmit.has('Story') ? {} as Story : aStory({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b5756f00-51a6-422a-81a7-dc13ee6a6375',
        isFirstSession: overrides && overrides.hasOwnProperty('isFirstSession') ? overrides.isFirstSession! : true,
        maxedOutTrials: overrides && overrides.hasOwnProperty('maxedOutTrials') ? overrides.maxedOutTrials! : false,
        modeKinkiness: overrides && overrides.hasOwnProperty('modeKinkiness') ? overrides.modeKinkiness! : 5.1,
        nickname: overrides && overrides.hasOwnProperty('nickname') ? overrides.nickname! : 'depraedor',
        onboardingResponses: overrides && overrides.hasOwnProperty('onboardingResponses') ? overrides.onboardingResponses! : [relationshipsToOmit.has('UserOnboardingResponses') ? {} as UserOnboardingResponses : aUserOnboardingResponses({}, relationshipsToOmit)],
        pinSet: overrides && overrides.hasOwnProperty('pinSet') ? overrides.pinSet! : true,
        primaryMarket: overrides && overrides.hasOwnProperty('primaryMarket') ? overrides.primaryMarket! : Market.De,
        provider: overrides && overrides.hasOwnProperty('provider') ? overrides.provider! : 'capto',
        signUpDate: overrides && overrides.hasOwnProperty('signUpDate') ? overrides.signUpDate! : 'magnam',
        storyMarkets: overrides && overrides.hasOwnProperty('storyMarkets') ? overrides.storyMarkets! : [Market.De],
        submittedPostPurchaseSurvey: overrides && overrides.hasOwnProperty('submittedPostPurchaseSurvey') ? overrides.submittedPostPurchaseSurvey! : true,
        subscriptionExpiresAt: overrides && overrides.hasOwnProperty('subscriptionExpiresAt') ? overrides.subscriptionExpiresAt! : 'tres',
        subscriptionId: overrides && overrides.hasOwnProperty('subscriptionId') ? overrides.subscriptionId! : 'quibusdam',
        timeSpent: overrides && overrides.hasOwnProperty('timeSpent') ? overrides.timeSpent! : 5724,
        topContentType: overrides && overrides.hasOwnProperty('topContentType') ? overrides.topContentType! : relationshipsToOmit.has('ContentType') ? {} as ContentType : aContentType({}, relationshipsToOmit),
        trackingId: overrides && overrides.hasOwnProperty('trackingId') ? overrides.trackingId! : 'cimentarius',
        verificationStatus: overrides && overrides.hasOwnProperty('verificationStatus') ? overrides.verificationStatus! : VerificationStatus.Failure,
    };
};

export const aUserNotification = (overrides?: Partial<UserNotification>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserNotification' } & UserNotification => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserNotification');
    return {
        __typename: 'UserNotification',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 9794,
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'umquam',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1bf304ca-d9dc-4691-81a2-8f6e595fa49d',
        lastShownAt: overrides && overrides.hasOwnProperty('lastShownAt') ? overrides.lastShownAt! : 'aequitas',
        notificationType: overrides && overrides.hasOwnProperty('notificationType') ? overrides.notificationType! : NotificationType.NewExplorePage,
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'aufero',
    };
};

export const aUserOnboardingResponses = (overrides?: Partial<UserOnboardingResponses>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserOnboardingResponses' } & UserOnboardingResponses => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserOnboardingResponses');
    return {
        __typename: 'UserOnboardingResponses',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '581a00eb-9006-4fb5-9c1c-8e6647031924',
        responses: overrides && overrides.hasOwnProperty('responses') ? overrides.responses! : relationshipsToOmit.has('OnboardingV1Response') ? {} as OnboardingV1Response : anOnboardingV1Response({}, relationshipsToOmit),
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 3607,
    };
};

export const aUserPreferences = (overrides?: Partial<UserPreferences>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserPreferences' } & UserPreferences => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserPreferences');
    return {
        __typename: 'UserPreferences',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'demens',
        hideAlreadyListened: overrides && overrides.hasOwnProperty('hideAlreadyListened') ? overrides.hideAlreadyListened! : false,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '54b83e0a-4a3d-4897-bcad-c158d75438ed',
        updatedAt: overrides && overrides.hasOwnProperty('updatedAt') ? overrides.updatedAt! : 'neque',
    };
};

export const aUserPreferencesInput = (overrides?: Partial<UserPreferencesInput>, _relationshipsToOmit: Set<string> = new Set()): UserPreferencesInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserPreferencesInput');
    return {
        hideAlreadyListened: overrides && overrides.hasOwnProperty('hideAlreadyListened') ? overrides.hideAlreadyListened! : true,
    };
};

export const aUserSubscription = (overrides?: Partial<UserSubscription>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserSubscription' } & UserSubscription => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserSubscription');
    return {
        __typename: 'UserSubscription',
        bespoke: overrides && overrides.hasOwnProperty('bespoke') ? overrides.bespoke! : false,
        billingPeriod: overrides && overrides.hasOwnProperty('billingPeriod') ? overrides.billingPeriod! : relationshipsToOmit.has('BillingPeriod') ? {} as BillingPeriod : aBillingPeriod({}, relationshipsToOmit),
        cancellationScheduledAt: overrides && overrides.hasOwnProperty('cancellationScheduledAt') ? overrides.cancellationScheduledAt! : 'animi',
        coupons: overrides && overrides.hasOwnProperty('coupons') ? overrides.coupons! : [relationshipsToOmit.has('Coupon') ? {} as Coupon : aCoupon({}, relationshipsToOmit)],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'tempore',
        expiresAt: overrides && overrides.hasOwnProperty('expiresAt') ? overrides.expiresAt! : 'suppono',
        freeTrialEndsAt: overrides && overrides.hasOwnProperty('freeTrialEndsAt') ? overrides.freeTrialEndsAt! : 'laborum',
        freeTrialStartedAt: overrides && overrides.hasOwnProperty('freeTrialStartedAt') ? overrides.freeTrialStartedAt! : 'odit',
        scheduledChanges: overrides && overrides.hasOwnProperty('scheduledChanges') ? overrides.scheduledChanges! : relationshipsToOmit.has('UserSubscriptionWithScheduledChanges') ? {} as UserSubscriptionWithScheduledChanges : aUserSubscriptionWithScheduledChanges({}, relationshipsToOmit),
        subscriptionId: overrides && overrides.hasOwnProperty('subscriptionId') ? overrides.subscriptionId! : 'vulgus',
    };
};

export const aUserSubscriptionWithScheduledChanges = (overrides?: Partial<UserSubscriptionWithScheduledChanges>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserSubscriptionWithScheduledChanges' } & UserSubscriptionWithScheduledChanges => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserSubscriptionWithScheduledChanges');
    return {
        __typename: 'UserSubscriptionWithScheduledChanges',
        billingPeriod: overrides && overrides.hasOwnProperty('billingPeriod') ? overrides.billingPeriod! : relationshipsToOmit.has('BillingPeriod') ? {} as BillingPeriod : aBillingPeriod({}, relationshipsToOmit),
        cancellationScheduledAt: overrides && overrides.hasOwnProperty('cancellationScheduledAt') ? overrides.cancellationScheduledAt! : 'ipsam',
        expiresAt: overrides && overrides.hasOwnProperty('expiresAt') ? overrides.expiresAt! : 'carmen',
        freeTrialEndsAt: overrides && overrides.hasOwnProperty('freeTrialEndsAt') ? overrides.freeTrialEndsAt! : 'aveho',
        freeTrialStartedAt: overrides && overrides.hasOwnProperty('freeTrialStartedAt') ? overrides.freeTrialStartedAt! : 'voluptas',
    };
};

export const anUtm = (overrides?: Partial<Utm>, _relationshipsToOmit: Set<string> = new Set()): Utm => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Utm');
    return {
        b2bSpecialPlan: overrides && overrides.hasOwnProperty('b2bSpecialPlan') ? overrides.b2bSpecialPlan! : 'ademptio',
        campaign: overrides && overrides.hasOwnProperty('campaign') ? overrides.campaign! : 'ducimus',
        content: overrides && overrides.hasOwnProperty('content') ? overrides.content! : 'ratione',
        crossTeamCampaign: overrides && overrides.hasOwnProperty('crossTeamCampaign') ? overrides.crossTeamCampaign! : 'vox',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'volup',
        medium: overrides && overrides.hasOwnProperty('medium') ? overrides.medium! : 'admitto',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'adfectus',
        term: overrides && overrides.hasOwnProperty('term') ? overrides.term! : 'sollers',
    };
};
